/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  reminder_trigger: {
    start_date: 'תאריך התחלה',
    expiry_date: 'תאריך תפוגה',
    start_date_required: '!תאריך התחלה נדרש',
    expiry_date_required: '!תאריך תפוגה נדרש',
    select_start_date: 'בחר תאריך התחלה',
    select_expiry_date: 'בחר תאריך תפוגה',
    title: 'תזכורות ותדירות',
    expand_all: 'הרחב הכל',
    recurrence_by_date: 'חזרה לפי תאריך',
    mandatory_course: 'קורס חובה',
    by_failed_attempts: 'לפי ניסיונות כושלים',
    every: 'כל',
    due_date: 'תאריך יעד',
    select_interval: 'בחר מרווח',
    select_duration: 'בחר משך',
    select_date: 'בחר תאריך',
    day: 'יום',
    week: 'שבוע',
    month: 'חודש',
    year: 'שנה',
    tooltip_start_date: 'תאריך התחלה',
    tooltip_start_date_description: 'כלל זה משתמש בתאריך ההתחלה הכללי של הקורס שנקבע משמאל.',
  },
  tour: {
    take_a_tour: 'צא לסיור',
    // Add Content Tour
    add_content_generation_name: 'הרחב את התוכן שלך',
    add_content_generation_desc:
      'הרחב בצורה חכמה את הקורס שלך עם תוכן משלים שמעשיר את חווית הלמידה.',
    add_content_generation_step_0_title: 'גישה לכלי יצירת תוכן',
    add_content_generation_step_0_content: 'לחץ כדי להרחיב את תפריט יצירת התוכן ולפתוח את יכולות הכתיבה המופעלות על ידי AI של Sharelook.',
    add_content_generation_step_1_title: 'צור תוכן נוסף',
    add_content_generation_step_1_content_prefix: 'בחר ',
    add_content_generation_step_1_content_bold: 'הוסף תוכן',
    add_content_generation_step_1_content_suffix: ' כדי להרחיב את הקורס שלך עם חומרים תומכים. ה-AI של Sharelook מנתח את התוכן הקיים שלך כדי ליצור תוספות רלוונטיות ואיכותיות.',
    add_content_generation_step_2_title: 'בחר חומר עזר',
    add_content_generation_step_2_content: 'בחר את הדפים שישמשו כבסיס לתוכן החדש. ה-AI יזהה הזדמויות להעמקת ההבנה ולמילוי פערי ידע.',
    add_content_generation_step_3_title: 'צור תוכן משלים',
    add_content_generation_step_3_content_prefix: 'לחץ על ',
    add_content_generation_step_3_content_bold: 'הוסף תוכן',
    add_content_generation_step_3_content_suffix: ' כדי להתחיל את תהליך ההרחבה. Sharelook ייצר חומר רלוונטי להקשר שמשתלב בצורה חלקה עם הקורס הקיים שלך.',

    // Interactive Tour
    interactive_generation_name: 'סימולציות אינטראקטיביות',
    interactive_generation_desc:
      'הפוך את התוכן הסטטי שלך לחוויות למידה סוחפות ומעשיות עם סימולציות אינטראקטיביות המופעלות על ידי AI.',
    interactive_generation_step_0_title: 'גישה לכלי יצירת תוכן',
    interactive_generation_step_0_content: 'לחץ כדי להרחיב את תפריט יצירת התוכן ולפתוח את יכולות הכתיבה המופעלות על ידי AI של Sharelook.',
    interactive_generation_step_1_title: 'צור סימולציות אינטראקטיביות',
    interactive_generation_step_1_content_prefix: 'בחר ',
    interactive_generation_step_1_content_bold: 'סימולציה אינטראקטיבית',
    interactive_generation_step_1_content_suffix: ' כדי להפוך את דפי הקורס שלך לחוויות למידה מרתקות ומבוססות תרחישים. ה-AI של Sharelook ייצור סימולציות מציאותיות המניעות השתתפות פעילה של הלומד.',
    interactive_generation_step_2_title: 'בחר את תוכן המקור שלך',
    interactive_generation_step_2_content:
      'בחר את הדפים מהקורס שלך שברצונך לשפר עם אלמנטים אינטראקטיביים. ה-AI ינתח את התוכן שלך וייצור סימולציות רלוונטיות להקשר.',
    interactive_generation_step_3_title: 'צור את הסימולציה שלך',
    interactive_generation_step_3_content_prefix: 'לחץ על ',
    interactive_generation_step_3_content_bold: 'שיעור אינטראקטיבי',
    interactive_generation_step_3_content_suffix: ' כדי להתחיל את תהליך יצירת ה-AI. Sharelook יצור סימולציה סוחפת המותאמת ליעדי הלמידה שלך תוך שניות.',

    // Background Color Tour
    background_color_settings_name: 'התאמה אישית של צבע רקע',
    background_color_settings_desc:
      'החל צבעי מותג וצור עקביות חזותית בתוכן הלמידה שלך.',
    background_color_settings_step_0_title: 'הגדרות צבע רקע',
    background_color_settings_step_0_content:
      'לוח זה מאפשר לך להתאים אישית את צבע הרקע של הדף שלך. בחר צבעים התואמים את המותג שלך ומשפרים את חווית הלמידה.',
    background_color_settings_step_1_title: 'בחר את הצבע שלך',
    background_color_settings_step_1_content:
      'בחר מהפלטה או הזן קוד hex ספציפי כדי להתאים להנחיות המותג שלך. שימוש עקבי בצבע מחזק את זהות המותג.',
    background_color_settings_step_2_title: 'החל את הבחירה שלך',
    background_color_settings_step_2_content:
      'אשר כדי להחיל את צבע הרקע על הדף שלך. השינויים שלך יהיו גלויים מיד בעורך.',

    // Background Image Tour
    background_image_settings_name: 'התאמה אישית של תמונת רקע',
    background_image_settings_desc:
      'צור דפים מדהימים ויזואלית עם תמונות רקע מקצועיות ושליטה מדויקת באטימות.',
    background_image_settings_step_0_title: 'הגדרות תמונת רקע',
    background_image_settings_step_0_content:
      'לוח זה מספק שליטה מלאה על תמונת הרקע של הדף שלך. צור דפים מדהימים ויזואלית עם תמונות מקצועיות והתאמה אישית מדויקת.',
    background_image_settings_step_1_title: 'בחר תמונת רקע',
    background_image_settings_step_1_content:
      'בחר מספריית המדיה שלך או העלה תמונה חדשה. רקעים איכותיים יוצרים דפים מקצועיים ומרתקים.',
    background_image_settings_step_2_title: 'כיוון עדין של אטימות',
    background_image_settings_step_2_content:
      'התאם את השקיפות כדי להבטיח קריאות אופטימלית של תוכן החזית. רקעים עדינים משפרים מבלי להסיח את הדעת.',
    background_image_settings_step_3_title: 'הסר רקע',
    background_image_settings_step_3_content:
      'נקה את תמונת הרקע הנוכחית כדי לחזור לקנבס נקי או ליישם טיפול ויזואלי שונה.',
    background_image_settings_step_4_title: 'סיים שינויים',
    background_image_settings_step_4_content:
      'החל את הגדרות הרקע שלך כדי לעדכן את הדף. השינויים נשמרים וגלויים מיד ללומדים.',

    // Create Course Tour
    create_course_name: 'מדריך ליצירת קורס',
    create_course_desc: 'למד לבנות תוכניות למידה מקיפות ומקצועיות ברמה ארגונית עם Sharelook.',
    create_course_step_0_title: 'ברוכים הבאים לבונה הקורסים',
    create_course_step_0_content: 'ברוכים הבאים לבונה הקורסים העילי של Sharelook. סביבת עבודה זו תוכננה לעזור לכם ליצור חוויות למידה בעלות השפעה גבוהה. בואו נצא לסיור קצר בכלים החיוניים העומדים לרשותכם.',
    create_course_step_1_title: 'הגדרות ליבה',
    create_course_step_1_content:
      'לוח הגדרות זה מאפשר לכם להגדיר את היסודות של הקורס שלכם. קביעת מאפיינים אלו בצורה מדויקת מבטיחה שהתוכן שלכם יהיה מאורגן, ניתן לחיפוש ומוצג בצורה מקצועית.',
    create_course_step_2_title: 'כותרת משכנעת',
    create_course_step_2_content:
      'קורס נהדר מתחיל בכותרת חזקה. כוונו למשהו ברור ומרתק שמאותת מיד על תוצאות הלמידה לקהל שלכם.',
    create_course_step_3_title: 'תמונות מקצועיות',
    create_course_step_3_content:
      'ויזואליה חשובה. תמונת כריכה מקצועית קובעת את הטון ובונה אמינות מיידית. בחרו תמונה שמתכתבת עם נושא הקורס ומעוררת השראה בלומדים.',
    create_course_step_4_title: 'מבנה תוכנית הלימודים',
    create_course_step_4_content:
      'תוכנית הלימודים שלכם היא הלב של הקורס. כאן תוכלו לבנות את השיעורים שלכם, להוסיף מדיה עשירה ולעצב מסע שמוביל את הלומדים שלכם מתיאוריה למיומנות.',
    create_course_step_5_title: 'פרסמו את הקורס שלכם',
    create_course_step_5_content: 'מוכנים לחלוק את המומחיות שלכם? לאחר שסיימתם את התוכן, השתמשו בכפתור הפרסום כדי לפרוס את הקורס שלכם. Sharelook מטפלת בפריסה והופכת אותו לזמין בארגון שלכם באופן מיידי.',
    create_course_ai_step_title: 'יצירת קורס באמצעות AI',
    create_course_ai_step_content: 'לחצו כאן כדי להמשיך לשלב הבא. ה-AI של Sharelook יפיק באופן אוטומטי נושאים ושיעורים רלוונטיים על סמך הגדרות הקורס שלכם, מה שיחסוך לכם זמן ומאמץ.',

    // Create Lesson Tour
    create_lesson_name: 'מדריך ליצירת שיעור',
    create_lesson_desc: 'שלוט ביסודות של יצירת שיעורים מקצועיים ומשפיעים ב-Sharelook.',
    create_lesson_step_0_title: 'בונה השיעורים',
    create_lesson_step_0_content: 'ברוכים הבאים לבונה השיעורים של Sharelook - סביבת העבודה שלך ליצירת חוויות למידה מרתקות ומובנות. בואו נעבור על האלמנטים החיוניים של עיצוב שיעור יעיל.',
    create_lesson_step_1_title: 'הגדר את השיעור שלך',
    create_lesson_step_1_content:
      'התחל עם כותרת ברורה ותיאורית שתופסת את תוצאת הלמידה של השיעור. כותרות יעילות מציבות ציפיות ברורות ועוזרות ללומדים לנווט במבנה הקורס שלך.',
    create_lesson_step_2_title: 'זהות חזותית',
    create_lesson_step_2_content:
      'העלה תמונת כריכה מקצועית שמייצגת את תוכן השיעור שלך. תמונות ויזואליות איכותיות משפרות את מעורבות הלומד והופכות את התוכן שלך לבלתי נשכח יותר.',
    create_lesson_step_3_title: 'בנה את התוכן שלך',
    create_lesson_step_3_content: 'מוכן להוסיף תוכן? לחץ כאן כדי להתחיל ליצור דפים ולבנות את השיעור שלך. Sharelook מספק כלים רבי עוצמה כדי להביא את החזון שלך לחיים.',

    // Infographics Tour
    infographics_generation_name: 'סיפורי נתונים ויזואליים',
    infographics_generation_desc:
      'המר מידע מורכב לאינפוגרפיקה ויזואלית משכנעת שמשפרת הבנה וזיכרון.',
    infographics_generation_step_0_title: 'גישה לכלי יצירת תוכן',
    infographics_generation_step_0_content: 'לחץ כדי להרחיב את תפריט יצירת התוכן ולפתוח את יכולות הכתיבה המופעלות על ידי AI של Sharelook.',
    infographics_generation_step_1_title: 'עצב תוכן ויזואלי',
    infographics_generation_step_1_content_prefix: 'בחר ',
    infographics_generation_step_1_content_bold: 'אינפוגרפיקה',
    infographics_generation_step_1_content_suffix: ' כדי להפוך נתונים ומושגים לייצוגים ויזואליים מקצועיים. ה-AI של Sharelook מזהה מידע מפתח ומארגן אותו להשפעה ויזואלית מקסימלית.',
    infographics_generation_step_2_title: 'בחר תוכן להמחשה',
    infographics_generation_step_2_content:
      'בחר את הדפים המכילים נתונים או מושגים שברצונך להמחיש ויזואלית. ה-AI יחלץ מידע קריטי ויעצב אינפוגרפיקה מרתקת.',
    infographics_generation_step_3_title: 'צור אינפוגרפיקה',
    infographics_generation_step_3_content_prefix: 'לחץ על ',
    infographics_generation_step_3_content_bold: 'צור אינפוגרפיקה',
    infographics_generation_step_3_content_suffix: ' כדי להתחיל את תהליך ההמחשה. Sharelook ייצור אינפוגרפיקה מקצועית שמעבירה את המסר שלך בצורה ברורה ויעילה.',

    // Quiz Tour
    quiz_generation_name: 'הערכות חכמות',
    quiz_generation_desc:
      'צור חידונים מותאמים אישית המודדים במדויק הבנה ומחזקים מושגי מפתח.',
    quiz_generation_step_0_title: 'גישה לכלי יצירת תוכן',
    quiz_generation_step_0_content: 'לחץ כדי להרחיב את תפריט יצירת התוכן ולפתוח את יכולות הכתיבה המופעלות על ידי AI של Sharelook.',
    quiz_generation_step_1_title: 'צור חידונים חכמים',
    quiz_generation_step_1_content_prefix: 'בחר ',
    quiz_generation_step_1_content_bold: 'חידון AI',
    quiz_generation_step_1_content_suffix: ' כדי ליצור שאלות הערכה המכוונות במדויק ליעדי הלמידה שלך. ה-AI של Sharelook יוצר שאלות מגוונות ומבוססות פדגוגית הבוחנות הבנה אמיתית.',
    quiz_generation_step_2_title: 'הגדר היקף הערכה',
    quiz_generation_step_2_content:
      'בחר את הדפים המכילים את התוכן שברצונך להעריך. ה-AI ינתח את החומר שלך כדי ליצור שאלות רלוונטיות להקשר.',
    quiz_generation_step_3_title: 'צור הערכה',
    quiz_generation_step_3_content_prefix: 'לחץ על ',
    quiz_generation_step_3_content_bold: 'צור חידון',
    quiz_generation_step_3_content_suffix: ' כדי להפעיל את בונה החידונים. Sharelook ייצור שאלות באיכות גבוהה המותאמות לתוכן שלך בתוך רגעים.',

    // Scenario Tour
    scenario_generation_name: 'אימון מבוסס תרחישים',
    scenario_generation_desc:
      'צור תרחישים מציאותיים מוכווני החלטות שמכינים לומדים לאתגרים בעולם האמיתי.',
    scenario_generation_step_0_title: 'גישה לכלי יצירת תוכן',
    scenario_generation_step_0_content: 'לחץ כדי להרחיב את תפריט יצירת התוכן ולפתוח את יכולות הכתיבה המופעלות על ידי AI של Sharelook.',
    scenario_generation_step_1_title: 'בנה תרחישי החלטה',
    scenario_generation_step_1_content_prefix: 'בחר ',
    scenario_generation_step_1_content_bold: 'תרחיש',
    scenario_generation_step_1_content_suffix: ' כדי ליצור נתיבי למידה מסועפים מבוססי תוצאות. ה-AI של Sharelook יוצר תרחישים אותנטיים המפתחים כישורי חשיבה ביקורתית.',
    scenario_generation_step_2_title: 'בחר תוכן בסיס',
    scenario_generation_step_2_content:
      'בחר את הדפים המכילים את המושגים לתרחיש שלך. ה-AI יבנה נקודות החלטה מציאותיות המבוססות על התוכן שלך.',
    scenario_generation_step_3_title: 'צור את התרחיש שלך',
    scenario_generation_step_3_content_prefix: 'לחץ על ',
    scenario_generation_step_3_content_bold: 'צור תרחיש',
    scenario_generation_step_3_content_suffix: ' כדי להתחיל ביצירת התרחיש. Sharelook יצור נרטיב סוחף ומסועף המותאם למטרות הלמידה שלך.',

    // Story Tour
    story_generation_name: 'למידה מבוססת סיפור',
    story_generation_desc:
      'הפוך תוכן יבש לנרטיבים שובי לב המניעים מעורבות רגשית ושימור ידע.',
    story_generation_step_0_title: 'גישה לכלי יצירת תוכן',
    story_generation_step_0_content: 'לחץ כדי להרחיב את תפריט יצירת התוכן ולפתוח את יכולות הכתיבה המופעלות על ידי AI של Sharelook.',
    story_generation_step_1_title: 'צור תוכן נרטיבי',
    story_generation_step_1_content_prefix: 'בחר ',
    story_generation_step_1_content_bold: 'כתיבת סיפור',
    story_generation_step_1_content_suffix: ' כדי להפוך את חומר הקורס שלך לנרטיבים משכנעים. ה-AI של Sharelook מצטיין בשזירת תוכן חינוכי לחוויות בלתי נשכחות ומבוססות סיפור.',
    story_generation_step_2_title: 'בחר את חומר המקור שלך',
    story_generation_step_2_content:
      'בחר את הדפים המכילים את המושגים שברצונך להפוך לסיפור. ה-AI יחלץ נקודות למידה מרכזיות ויבנה סביבן נרטיב.',
    story_generation_step_3_title: 'הפעל את בונה הסיפורים',
    story_generation_step_3_content_prefix: 'לחץ על ',
    story_generation_step_3_content_bold: 'צור סיפור',
    story_generation_step_3_content_suffix: ' כדי לגשת לממשק יצירת הסיפורים של Sharelook, שבו תוכל לעצב את הנרטיב שלך בדייקנות.',
    story_generation_step_4_title: 'צור את הנרטיב שלך',
    story_generation_step_4_content:
      'השתמש בבונה הסיפורים החכם שלנו כדי לחדד את הנרטיב שלך. שתף פעולה עם ה-AI באמצעות הנחיות שיחה או קלטים מובנים כדי להשיג את התוצאה הרצויה.',
    story_generation_step_5_title: 'צור את הסיפור שלך',
    story_generation_step_5_content_prefix: 'לחץ על ',
    story_generation_step_5_content_bold: 'צור את הסיפור הראשון שלך',
    story_generation_step_5_content_suffix: ' כדי ליצור את הנרטיב שלך. ה-AI של Sharelook יצור סיפור מרתק שמשלב בצורה חלקה את יעדי הלמידה שלך.',

    // Toolbar Tour
    toolbar_guide_name: 'כלי עריכת תוכן',
    toolbar_guide_desc: 'שלוט בערכת הכלים המקיפה של Sharelook ליצירת חוויות למידה עשירות במולטימדיה.',
    toolbar_guide_step_0_title: 'יישור מדויק',
    toolbar_guide_step_0_content:
      'הפעל את שכבת הרשת כדי להבטיח יישור מושלם (פיקסל-פרפקט) של אלמנטים. פריסות מקצועיות מתחילות במיקום מדויק.',
    toolbar_guide_step_1_title: 'תוכן טקסט',
    toolbar_guide_step_1_content:
      'הוסף בלוקים של טקסט מעוצב כדי להעביר מושגים והוראות. כולל יכולות עריכת טקסט עשיר, היפר-קישורים ובקרת טיפוגרפיה.',
    toolbar_guide_step_2_title: 'מדיה ויזואלית',
    toolbar_guide_step_2_content:
      'שלב תמונות כדי לשפר הבנה ומעורבות. העלה מהספרייה או מהמכשיר שלך כדי להוסיף הקשר ויזואלי לשיעורים שלך.',
    toolbar_guide_step_3_title: 'שילוב וידאו',
    toolbar_guide_step_3_content:
      'הטמע סרטונים מ-YouTube, Vimeo או העלאות משלך. תוכן וידאו מניע מעורבות ותומך בהעדפות למידה מגוונות.',
    toolbar_guide_step_4_title: 'אלמנטים של שמע',
    toolbar_guide_step_4_content:
      'הוסף קריינות, פודקאסטים או שמע סביבתי כדי ליצור סביבות למידה סוחפות. שמע תומך בנגישות ולמידה רב-חושית.',
    toolbar_guide_step_5_title: 'מציאות רבודה',
    toolbar_guide_step_5_content:
      'שלב חוויות AR כדי להביא מושגים לחיים. צור למידה חדשנית וסוחפת שמגשרת בין העולם הדיגיטלי לפיזי.',
    toolbar_guide_step_6_title: 'בדיקות ידע',
    toolbar_guide_step_6_content:
      'הטמע חידונים אינטראקטיביים כדי לאמת למידה ולחזק מושגי מפתח. עקוב אחר התקדמות הלומד וזהה פערי ידע.',
    toolbar_guide_step_7_title: 'הערות אינטראקטיביות',
    toolbar_guide_step_7_content:
      'הוסף שכבות של הערות אינטראקטיביות על תמונות ומדיה. צור נקודות חמות ללחיצה שחושפות מידע נוסף ומניעות חקירה.',
    toolbar_guide_step_8_title: 'עיצוב דף',
    toolbar_guide_step_8_content: 'התאם אישי רקעי דף כדי להתאים למותג שלך או ליצור היררכיה חזותית. עיצוב מקצועי מעלה את אמינות התוכן.',
    toolbar_guide_step_9_title: 'תצוגה מקדימה ללומד',
    toolbar_guide_step_9_content:
      'חווה את הקורס שלך בדיוק כפי שהלומדים יראו אותו. מצב תצוגה מקדימה מבטיח בקרת איכות לפני פרסום.',

    // World Scenario Tour
    world_scenario_generation_name: 'יישומים בעולם האמיתי',
    world_scenario_generation_desc:
      'גשר בין תיאוריה לפרקטיקה עם תרחישי מקום עבודה אותנטיים הבונים מיומנויות מוכנות לעבודה.',
    world_scenario_generation_step_0_title: 'גישה לכלי יצירת תוכן',
    world_scenario_generation_step_0_content: 'לחץ כדי להרחיב את תפריט יצירת התוכן ולפתוח את יכולות הכתיבה המופעלות על ידי AI של Sharelook.',
    world_scenario_generation_step_1_title: 'צור תרחישי מקום עבודה',
    world_scenario_generation_step_1_content_prefix: 'בחר ',
    world_scenario_generation_step_1_content_bold: 'תרחיש עולם אמיתי',
    world_scenario_generation_step_1_content_suffix: ' כדי לייצר סיטואציות אותנטיות וספציפיות לתעשייה. ה-AI של Sharelook יוצר תרחישים המשקפים אתגרי מקום עבודה אמיתיים והקשרי קבלת החלטות.',
    world_scenario_generation_step_2_title: 'בחר תוכן הקשרי',
    world_scenario_generation_step_2_content:
      'בחר את הדפים המכילים את המיומנויות או המושגים ליישום. ה-AI יעצב תרחישים מציאותיים המדגימים יישום מעשי במסגרות מקצועיות.',
    world_scenario_generation_step_3_title: 'צור תרחיש עולם אמיתי',
    world_scenario_generation_step_3_content_prefix: 'לחץ על ',
    world_scenario_generation_step_3_content_bold: 'צור תרחיש',
    world_scenario_generation_step_3_content_suffix: ' כדי לבנות את תרחיש מקום העבודה שלך. Sharelook יצור חוויה אותנטית ורלוונטית לתעשייה שמכינה לומדים לאתגרים אמיתיים.',

    // Match Image Tour
    match_image_generation_name: 'התאמת תמונה',
    match_image_generation_desc:
      'לחץ כדי להרחיב את תפריט יצירת התוכן ולפתוח את יכולות היצירה המופעלות על ידי AI של Sharelock.',
    match_image_generation_step_0_content: "לחץ כדי להרחיב את תפריט יצירת התוכן ולפתוח את יכולות היצירה המופעלות על ידי AI של Sharelook.",
    match_image_generation_step_1_title: 'עקביות התאמת תמונה',
    match_image_generation_step_1_content_prefix: 'בחר ',
    match_image_generation_step_1_content_bold: 'התאמת תמונה',
    match_image_generation_step_1_content_suffix:
      ' כדי ליצור תמונות ששומרות על סגנון ואופי עקביים לאורך הקורס שלך.',
    match_image_generation_step_2_title: 'בחר דפי הפניה',
    match_image_generation_step_2_content:
      'בחר את העמודים שברצונך להתאים להם את סגנון התמונה.',
    match_image_generation_step_3_title: 'צור תמונות תואמות',
    match_image_generation_step_3_content_prefix: 'לחץ על ',
    match_image_generation_step_3_content_bold: 'התאמת תמונה',
    match_image_generation_step_3_content_suffix: ' כדי להתחיל ליצור תמונות שמשתלבות בצורה מושלמת עם ההפניות שבחרת.',
    match_image_generation_step_4_title: 'הגדרת יצירה',
    match_image_generation_step_4_content:
      'התאם הגדרות ותמונות הפניה בחלונית זו כדי לכוונן את התוצאה הסופית.',
    match_image_generation_step_5_title: 'התחל יצירה',
    match_image_generation_step_5_content_prefix: 'לחץ על ',
    match_image_generation_step_5_content_bold: 'צור עבור עמודים נבחרים',
    match_image_generation_step_5_content_suffix: ' כדי ליצור את התמונות העקביות שלך.'
  },
  matchimage: {
    title: "התאמת תמונה",
    consistency_subtitle: "שמירה על אחידות חזותית בכל דפי הקורס",
    consistency: "אחידות בהתאמת תמונות",
    visual_style: "סגנון חזותי",
    select_style: "בחר סגנון חזותי...",
    reference_images: "תמונות ייחוס",
    reference_images_tip: "תמונות אלו מספקות עוגן חזותי ל-AI ומבטיחות עקביות בדמויות, בצבעים ובסגנון לאורך מספר עמודים.",
    add: "הוסף",
    max_9_reference_images: "המערכת משתמשת בתמונות הרלוונטיות ביותר מהעמודים שנבחרו כהקשר, כדי לשמור על מיקוד חזותי ומהירות יצירה.",
    generation_progress: "התקדמות יצירה",
    no_images_generated_yet: "עדיין לא נוצרו תמונות",
    click_generate_to_start: "לחץ על צור כדי להתחיל את התהליך הרב-עמודי.",
    page: "עמוד",
    completed: "הושלם",
    failed: "נכשל",
    generating: "נוצר...",
    generate_selected_pages: "צור עבור עמודים נבחרים",
    apply_to_all_pages: "החל על כל העמודים",
    applied: "הוחל",
    cancel: "ביטול",
    apply_success: "התמונות הוחלו בהצלחה!",
    select_at_least_one_page: "אנא בחר לפחות עמוד אחד ליצירה.",
    fetching_references: "מאחזר הפניות...",
    fetching: "מאחזר...",
    no_references_found: "לא נמצאו הפניות",
    loading_references: "טוען תמונות ייחוס...",
    apply_confirmation_content: "פעולה זו תחליף תמונות קיימות בעמודים שנבחרו ותוסיף חדשות היכן שאין. האם ברצונך להמשיך?",
    uploaded: "הועלה",
    style_photorealistic_label: "פוטוריאליסטי",
    style_photorealistic_prompt: "תמונה פוטוריאליסטית במיוחד, איכות DSLR, תאורה טבעית, פוקוס חד, טקסטורות ריאליסטיות, צילום מקצועי.",
    style_product_label: "צילום מוצר מסחרי",
    style_product_prompt: "צילום מוצר מסחרי ברמה גבוהה, תאורת סטודיו, רקע נקי, פרטים חדים, סגנון פרסום פרימיום.",
    style_lifestyle_label: "צילום לייפסטייל",
    style_lifestyle_prompt: "צילום לייפסטייל טבעי, קומפוזיציה ספונטנית, אור יום רך, אנשים אמיתיים, מראה מסחרי מודרני ואותנטי.",
    style_corporate_portrait_label: "דיוקן תאגידי",
    style_corporate_portrait_prompt: "דיוקן תאגידי מקצועי, רקע ניטרלי, תאורת סטודיו רכה, פרטי פנים חדים, סגנון צילום עסקי.",
    style_3d_modern_label: "איור תלת־ממדי מודרני",
    style_3d_modern_prompt: "איור תלת־ממדי מודרני, גיאומטריה חלקה, תאורה גלובלית רכה, חומרים ריאליסטיים, מראה מקצועי ונקי.",
    style_3d_isometric_label: "סצנה איזומטרית תלת־ממדית",
    style_3d_isometric_prompt: "סצנה איזומטרית תלת־ממדית, גיאומטריה נקייה, תאורה מאוזנת, צללים רכים, סגנון איור תאגידי מודרני.",
    style_flat_corporate_label: "איור תאגידי שטוח",
    style_flat_corporate_prompt: "איור שטוח ונקי, סגנון מיתוג תאגידי, צורות מינימליות, פלטת צבעים מקצועית ומאוזנת.",
    style_ui_brand_label: "ויזואל UI / מיתוג מינימלי",
    style_ui_brand_prompt: "ויזואל בסגנון UI מינימלי, רקע לבן או בהיר, פריסה פשוטה, מיתוג טכנולוגי מודרני, מדויק ונקי.",
    style_editorial_label: "צילום מערכתי",
    style_editorial_prompt: "סגנון צילום מערכתי, אור טבעי, סביבה ריאליסטית, תחושה תיעודית, פרטים ברזולוציה גבוהה.",
    style_technical_diagram_label: "תרשים טכני",
    style_technical_diagram_prompt: "תרשים טכני נקי, קווים מדויקים, צבעים שטוחים, סגנון אינפוגרפיקה מקצועי, פריסה ברורה להבנה.",
    style_abstract_corporate_label: "רקע תאגידי מופשט",
    style_abstract_corporate_prompt: "רקע תאגידי מופשט, גרדיאנטים רכים, צורות גיאומטריות עדינות, מיתוג מקצועי מודרני.",
    style_saas_marketing_label: "ויזואל שיווקי ל-SaaS",
    style_saas_marketing_prompt: "ויזואל שיווקי מודרני ל-SaaS, קומפוזיציה נקייה, צבעים מקצועיים ובהירים, ממוקד טכנולוגיה ומלוטש.",
    generating_image: "יוצר תמונה...",
    ready: "מוכן",
    generating_page: "יוצר עבור עמוד",
  },
  infographic: {
    title: 'צור אינפוגרפיקה',
    custom_prompt: 'הנחיות מותאמות אישית (אופציונלי)',
    prompt_placeholder:
      'למשל: השתמש בצבעים כחולים, כלול תרשימים, התמקד בסטטיסטיקות...',
    generating: 'יוצר אינפוגרפיקה...',
    generated: 'האינפוגרפיקה נוצרה בהצלחה!',
    generation_failed: 'נכשל ביצירת האינפוגרפיקה',
    no_content: 'אין תוכן זמין ליצירת אינפוגרפיקה',
    no_image: 'אין אינפוגרפיקה ליישום',
    empty_state: 'לחץ על צור כדי ליצור את האינפוגרפיקה שלך',
    generate: 'צור אינפוגרפיקה',
    regenerate: 'צור מחדש',
    apply_question: 'איך תרצה להשתמש באינפוגרפיקה הזו?',
    replace_option: 'החלף תמונה קיימת',
    add_option: 'הוסף כתמונה חדשה',
    replace_success: 'האינפוגרפיקה הוחלפה בהצלחה!',
    add_success: 'האינפוגרפיקה נוספה בהצלחה!',
    page_content: 'תוכן הדף',
    generated_infographic: 'אינפוגרפיקה שנוצרה',
    title_label: 'כותרת',
    text_label: 'תוכן טקסט',
    aspect_ratio: 'יחס גובה-רוחב',
    replace_the_existing_image_on_the_page:
      'החלף את התמונה הקיימת בדף עם אינפוגרפיקה זו',
    add_this_infographic: 'הוסף את האינפוגרפיקה הזו כאלמנט חדש בדף',
    square: '1:1 (ריבוע)',
    portrait: '2:3 (אנכי)',
    landscape: '3:2 (אופקי)',
    three_four_Portrait: '3:4 (אנכי)',
    four_three_landscape: '4:3 (אופקי)',
    four_five_portrait: '4:5 (אנכי)',
    four_five_landscape: '5:4 (אופקי)',
    mobile_portrait: '9:16 (אנכי למובייל)',
    widescreen: '16:9 (מסך רחב)',
    ultrawide: '21:9 (מסך רחב במיוחד)'
  },

  helplist: {
    // MISC
    main_categories: 'קטגוריות ראשיות',
    my_workshop: 'הסדנה שלי',
    basic_course_controls: 'בקרות קורס בסיסיות',
    scorm_courses: 'קורסי SCORM',
    user_management: 'ניהול משתמשים',
    virtual_coach_title: 'מאמן וירטואלי',
    sharelook_trivia: 'טריוויה של Sharelook',
    leaderboard_title: 'לוח מובילים של Sharelook',
    live_events: 'אירועים חיים',
    podcasts_music_story: 'פודקאסטים, מוזיקה וסיפור',
    whats_new: 'מה חדש',
    whats_new_sharelook: 'מה חדש ב-ShareLook',
    whats_new_desc:
      'האם ידעת שיצירת חוויית למידה בסגנון סיפור היא קלה לביצוע בזמן קצר וזולה? עליך לשלב את בונה הקורסים של ShareLook עם הכישרונות שלך. שאל אותנו איך.',
    no_video_found: 'לא נמצאו סרטונים תואמים',
    uploaded_on: 'הועלה ב-',
    user_view: 'תצוגת משתמש',
    admin_view: 'תצוגת מנהל',

    no_video_available: 'אין סרטונים חדשים זמינים כרגע.',
    welcome: 'ברוכים הבאים למרכז העזרה של ShareLook',
    video_filter:
      'בחר סרטון מהניווט השמאלי כדי להתחיל, או השתמש בחיפוש כדי למצוא תוכן ספציפי.',

    // HELP CENTER
    sharelook: 'מהו Sharelook',
    sharelook_desc: 'מבוא ל-Sharelook ותכונותיו',

    course_summary: 'סיכום יצירת קורס',
    course_summary_desc: 'סקירה וסיכום של תהליך יצירת הקורס',

    ai_course_creation: 'תהליך מלא – יצירת קורס באמצעות בינה מלאכותית',
    ai_course_creation_desc: 'למד כיצד ליצור קורס באמצעות בינה מלאכותית.',

    scenario_based_assessment:
      'תהליך מלא – יצירת הערכה מבוססת תרחיש (Metamaze)',
    scenario_based_assessment_desc:
      'למד כיצד ליצור הערכה מבוססת תרחיש באמצעות בינה מלאכותית.',

    skill_leaderboard_creation: 'תהליך מלא – יצירת מסע מיומנויות ולוח מובילים',
    skill_leaderboard_creation_desc:
      'למד כיצד ליצור מסע מיומנויות ולוח מובילים באמצעות בינה מלאכותית.',

    skill_journey: 'מהו מסע כישורים',
    skill_journey_desc: 'הבן מהו מסע כישורים ואיך הוא עוזר ללומדים',

    metamaze: 'מהו מבוך מטא',
    metamaze_desc: 'מבוא ל-מבוך מטא ותפקידו בלמידה מבוססת תרחישים',

    share_shorts: 'Sharelook שתף מכנס קצר',
    share_shorts_desc: 'סקירה של שתף מכנס קצר ואיך להשתמש בהם ביעילות',

    // TRAINING
    view_channel: 'צפה בערוץ וידאו',
    view_channel_desc: 'למד איך לצפות ולחקור תוכן בערוץ וידאו',

    take_course: 'כיצד לקחת קורס - לומד',
    take_course_desc: 'הבן איך לומדים יכולים לקחת ולנווט בקורס',

    take_metamaze: 'כיצד לקחת מבוך מטא',
    take_metamaze_desc:
      'למד איך לומדים יכולים להשתתף במודול למידה מבוסס תרחישים של מבוך מטא',

    take_skill_journey: 'כיצד לקחת מסע כישורים',
    take_skill_journey_desc: 'למד איך להתחיל ולהשלים מסע כישורים כלומד',

    listen_podcast: 'איך להאזין לפודקאסט',
    listen_podcast_desc: 'למד איך להאזין ולנווט בתוכן פודקאסט',

    // COURSES
    create_course: 'הוספת תעודה, תג וכריכת קורס לקורס',
    create_course_desc: 'צור קורס והתאם אותו עם תגים, תעודות ותמונות כריכה',

    create_course_simulation: 'סימולציה (סביבת סנדבוקס) בתוך הקורס',
    create_course_simulation_desc:
      'מדריך שלב אחר שלב ליצירת סימולציות בתוך קורס.',

    create_interactive_lesson: 'שיעור אינטראקטיבי',
    create_interactive_lesson_desc:
      'מדריך שלב אחר שלב ליצירת שיעורים אינטראקטיביים בתוך קורס.',

    interactive_lesson_learner: 'כיצד לקחת שיעור אינטראקטיבי',
    interactive_lesson_learner_desc:
      'חווה שיעורים אינטראקטיביים מנקודת המבט של הלומד',

    interactive_lesson_admin: 'שיעור אינטראקטיבי - תצוגת מנהל',
    interactive_lesson_admin_desc:
      'מדריך שלב אחר שלב ליצירה וניהול שיעורים אינטראקטיביים',

    create_lesson: 'איך ליצור שיעור',
    create_lesson_desc: 'מדריך שלב אחר שלב ליצירת שיעורים בתוך קורס',

    create_course_complete_tutorial: 'צור מדריך קורס מלא',
    create_course_complete_tutorial_desc:
      'מדריך מקיף המסביר כיצד ליצור תוכנית לימודים ולבנות קורס באמצעות בינה מלאכותית ב-Sharelook.',

    // COURSES AI
    ai_curriculum: 'יצירת תכנית לימודים ב-AI',
    ai_curriculum_desc:
      'למד איך להשתמש ב-AI כדי ליצור אוטומטית תכנית לימודים לקורס',

    // COURSES BUILDER
    intro_gen: 'יצירת מבוא',
    intro_gen_desc: 'צור מבואי קורס משכנעים עם AI',

    intro_generation: 'יצירת מבוא לשיעור',
    intro_generation_desc: 'צור מבואי קורס משכנעים עם AI',

    story_gen: 'יצירת סיפורי AI וסיפורים מהחיים האמיתיים',
    story_gen_desc: 'צור סיפורים מעניינים ותרחישים מהחיים האמיתיים עם AI',

    ai_story_generation: 'יצירת סיפורי AI וסיפורים מהחיים האמיתיים',
    ai_story_generation_desc:
      'צור סיפורים מעניינים ותרחישים מהחיים האמיתיים עם AI',

    scenario_gen: 'יצירת תרחיש',
    scenario_gen_desc: 'בנה תרחישים אינטראקטיביים ללמידה ממוקדת',

    scenario_generation: 'יצירת תרחיש',
    scenario_generation_desc: 'בנה תרחישים אינטראקטיביים ללמידה ממוקדת',

    quiz_ai: 'יצירת חידון AI',
    quiz_ai_desc: 'צור חידונים אוטומטית באמצעות טכנולוגיית AI',

    ai_quiz_generation: 'יצירת חידון AI',
    ai_quiz_generation_desc: 'צור חידונים אוטומטית באמצעות טכנולוגיית AI',

    bullet_gen: 'יצירת נקודות תבליט',
    bullet_gen_desc: 'צור נקודות תבליט מובנות לשיעורים שלך',

    bullet_points: 'יצירת נקודות תבליט',
    bullet_points_desc: 'צור נקודות תבליט מובנות לשיעורים שלך',

    summary_gen: 'יצירת סיכום',
    summary_gen_desc: 'צור אוטומטית סיכומי שיעורים עם AI',

    summary_generation: 'יצירת סיכום',
    summary_generation_desc: 'צור אוטומטית סיכומי שיעורים עם AI',

    add_content: 'הוסף תוכן לשיעור',
    add_content_desc: 'הוסף סוגים שונים של תוכן כדי להעשיר את השיעורים שלך',

    add_lesson_content: 'הוסף תוכן לשיעור',
    add_lesson_content_desc:
      'הוסף סוגים שונים של תוכן כדי להעשיר את השיעורים שלך',

    layout_change: 'שנה פריסת שיעור',
    layout_change_desc: 'התאם את הפריסה של דפי השיעור שלך',

    change_lesson_layout: 'שנה פריסת שיעור',
    change_lesson_layout_desc: 'התאם את הפריסה של דפי השיעור שלך',

    voiceover_gen: 'יצירת קריינות',
    voiceover_gen_desc: 'הוסף קריינות מקצועית לתוכן הקורס שלך',

    voiceover_generation: 'יצירת קריינות',
    voiceover_generation_desc: 'הוסף קריינות מקצועית לתוכן הקורס שלך',

    manual_quiz: 'יצירת חידון ידנית',
    manual_quiz_desc: 'למד איך ליצור ולהתאים חידונים ידנית',

    manual_quiz_creation: 'יצירת חידון ידנית',
    manual_quiz_creation_desc: 'למד איך ליצור ולהתאים חידונים ידנית',

    ai_image_gen: 'יצירת תמונות AI',
    ai_image_gen_desc: 'צור תמונות מותאמות אישית לקורס שלך באמצעות AI',

    ai_image_generation: 'יצירת תמונות AI',
    ai_image_generation_desc: 'צור תמונות מותאמות אישית לקורס שלך באמצעות AI',

    simulation: 'צור סימולציה',
    simulation_desc: 'צור סימולציות אינטראקטיביות בסביבת sandbox',

    simulation_creation: 'יצירת סימולציה (סביבת Sandbox)',
    simulation_creation_desc:
      'מדריך שלב אחר שלב ליצירת סימולציות בסביבת ה-Sandbox',

    course_learner_view: 'תצוגת לומד קורס',
    course_learner_view_desc: 'הבן את נקודת המבט והחוויה של הלומד בקורסים',

    simulation_learner_view: 'כיצד לקחת סימולציה',
    simulation_learner_view_desc:
      'חווה סימולציות מנקודת המבט של הלומד בסביבת הסנדבוקס.',

    infographic_title: 'הוספת אינפוגרפיקות לדף שיעור',
    infographic_desc: 'למד ליצור אינפוגרפיקות אינטראקטיביות עבור השיעורים שלך.',

    // MAZE
    ai_metamaze: 'יצירת AI-מבוך מטא',
    ai_metamaze_desc: 'למד איך ליצור חוויות מבוך מטא אינטראקטיביות באמצעות AI',

    ai_metamaze_creation: 'יצירת AI-מבוך מטא',
    ai_metamaze_creation_desc:
      'למד איך ליצור חוויות מבוך מטא אינטראקטיביות באמצעות AI',

    // LIBRARY
    media_library: 'Media Library',
    media_library_desc: 'סקירה של ספריית המדיה ושימושיה',

    file_management: 'File Management',
    file_management_desc: 'למד איך לנהל את הקבצים שלך ביעילות',

    upload_files: 'Uploading Files & Adding to AI Repository',
    upload_files_desc: 'איך להעלות ולשלב קבצים במאגר AI',

    file_upload_repository:
      'Uploading Files & Adding Files to the AI Repository',
    file_upload_repository_desc:
      'למד כיצד להעלות קבצים ולהוסיף אותם למאגר הבינה המלאכותית.',

    document_creation: 'Document Creation (Word, Calc, Impress)',
    document_creation_desc: 'למד ליצור מסמכים בפורמטים Word, Calc ו-Impress',

    file_organization: 'File Organization in Folders',
    file_organization_desc: 'ארגן קבצים ביעילות בתוך תיקיות',

    document_creation_screen: 'Document Creation Using Screen Capture',
    document_creation_screen_desc: 'צור מסמכים באמצעות פונקציונליות לכידת מסך',

    course_creation_screen: 'Course Creation Using Screen Capture',
    course_creation_screen_desc: 'צור קורסים באמצעות פונקציונליות לכידת מסך',

    downloads_center: 'Downloads Center',
    downloads_center_desc: 'גישה וניהול של תוכן שהורד ממרכז ההורדות',

    // REPORTS
    reports_analytics: 'Reports and Analytics Overview',
    reports_analytics_desc: 'מדריך מקיף לדוחות ואנליטיקה ב-Sharelook',

    reports_detailed: 'Reports and Analytics Detailed',
    reports_detailed_desc: 'סקירה מפורטת של כל תכונות הדיווח ויכולות האנליטיקה',

    workshop_report: 'דוח הסדנה',
    workshop_report_desc: 'צפה ונתח דוחות ביצועים של סדנאות',

    user_report: 'דוח משתמש',
    user_report_desc: 'גישה לדוחות פעילות וביצועים מקיפים של משתמשים',

    course_report: 'דוח קורס',
    course_report_desc: 'צפה בדוחות מפורטים על השלמת קורסים ומעורבות',

    live_events_report: 'דוח אירועים חיים',
    live_events_report_desc: 'ניתוח מדדי נוכחות ומעורבות עבור אירועים חיים',

    metamaze_reports: 'דוחות מבוך מטא',
    metamaze_reports_desc: 'צפה בדוחות ביצועים והשלמה עבור מודולי מבוך מטא',

    live_assessments_reports: 'דוחות הערכות חיים',
    live_assessments_reports_desc: 'גישה לדוחות על ביצועי הערכות חיים ותוצאות',

    skill_journey_reports: 'דוחות מסע כישורים',
    skill_journey_reports_desc:
      'עקוב אחר דוחות התקדמות והשלמה עבור מסעי כישורים',

    sharesphere_report: 'דוח ShareSphere',
    sharesphere_report_desc: 'צפה בדוחות מעורבות ופעילות עבור תוכן ShareSphere',

    // SKILL JOURNEY
    create_skill_journey: 'צור מסע כישורים',
    create_skill_journey_desc: 'למד איך ליצור ולנהל מסעי כישורים ללומדים',

    // PODCAST
    podcast_creation: 'יצירת פודקאסט',
    podcast_creation_desc: 'למד איך ליצור ולנהל ערוצי פודקאסט',

    podcast_listening_learner: 'כיצד להאזין לפודקאסט',
    podcast_listening_learner_desc: 'למד איך להאזין ולנווט בפודקאסטים כלומד',

    // CHANNEL
    video_channel_creation: 'כיצד להשתמש בערוץ הוידאו',
    video_channel_creation_desc: 'צור והתאם ערוצי וידאו לתוכן שלך',

    // REEL
    short_video_creation: 'תרומת Share Shorts וידאו',
    short_video_creation_desc: 'למד איך ליצור סרטונים קצרים מעניינים',

    short_video_admin: 'Short video/Shareshorts Admin View',
    short_video_admin_desc: 'נהל וסקור סרטונים קצרים מנקודת המבט של המנהל',

    // TRIVIA
    create_trivia: 'How to Create a Trivia on Sharelook',
    create_trivia_desc: 'למד איך ליצור משחקי טריוויה מעניינים',

    take_trivia: 'כיצד לקחת טריוויה',
    take_trivia_desc: 'למד איך להשתתף במשחקי טריוויה כלומד',

    // MANAGEMENT
    add_users: 'How to add users to an organization',
    add_users_desc: 'הוסף ונהל משתמשים בארגון שלך',

    add_group: 'How to create a group in your organization',
    add_group_desc: 'צור ונהל קבוצות משתמשים',

    // SKILL JOURNEY
    create_skill_journey: 'Skill Journey Creation',
    create_skill_journey_desc: 'למד איך ליצור ולנהל מסעי כישורים ללומדים',

    // CHANNEL
    video_channel_creation: 'Video Channel Creation',
    video_channel_creation_desc: 'צור והתאם ערוצי וידאו לתוכן שלך',

    // MAZE
    ai_metamaze_creation: 'AI Metamaze Creation',
    ai_metamaze_creation_desc:
      'למד איך ליצור חוויות מבוך מטא אינטראקטיביות באמצעות AI',

    // COACHING
    virtual_coach: 'Virtual Coach Overview',
    virtual_coach_desc: 'למד איך להשתמש בתכונת המאמן הווירטואלי',

    coaching_creation: 'יצירת סשן אימון',
    coaching_creation_desc: 'צור ותזמן סשני אימון',

    coaching_session_creation: 'יצירת סשן אימון',
    coaching_session_creation_desc: 'צור ותזמן סשני אימון',

    coaching_booking: 'הזמן מקום לסשן אימון',
    coaching_booking_desc: 'איך להזמין מקומות זמינים לסשן אימון',

    booking_coaching_slot: 'כיצד להזמין מקום לסשן אימון',
    booking_coaching_slot_desc: 'איך להזמין מקומות זמינים לסשן אימון',

    // WORKSHOP
    my_workshop: 'הסדנה שלי',
    my_workshop_desc: 'סקירה של חלק הסדנה ותכונותיו',

    add_scorm: 'How to Add a SCORM Course on Sharelook',
    add_scorm_desc: 'העלה קורס SCORM, התאם אותו עם תגים, תעודות ותמונות כריכה',

    edit_skill_journey: 'ערוך מסע כישורים',
    edit_skill_journey_desc: 'למד איך לערוך מסע כישורים קיים',

    edit_live_event: 'ערוך אירוע חי',
    edit_live_event_desc: 'ערוך ונהל אירועים חיים ביעילות',

    clone_course: 'שכפל קורס',
    clone_course_desc: 'שכפל קורס קיים לשימוש חוזר או שינוי',

    clone_metamaze: 'שכפל מבוך מטא',
    clone_metamaze_desc: 'למד איך לשכפל מבוך מטא ללומדים חדשים או עדכונים',

    delete_skill_journey: 'מחק מסע כישורים',
    delete_skill_journey_desc: 'תהליך שלב אחר שלב למחיקת מסע כישורים',

    delete_live_event: 'מחק אירוע חי',
    delete_live_event_desc: 'מחק אירועים חיים לא רצויים מהפלטפורמה',

    edit_course: 'ערוך קורס',
    edit_course_desc: 'ערוך קורסים קיימים ועדכן את התוכן שלהם',

    delete_metamaze: 'מחק מבוך מטא',
    delete_metamaze_desc: 'למד איך למחוק בבטחה מודול מבוך מטא',

    delete_podcast: 'מחק פודקאסט',
    delete_podcast_desc: 'הסר פודקאסטים קיימים מהערוץ שלך',

    delete_video_channel: 'מחק ערוץ וידאו',
    delete_video_channel_desc: 'מחק ערוצי וידאו לא רצויים בקלות',

    edit_video_channel: 'ערוך ערוץ וידאו',
    edit_video_channel_desc: 'למד איך לערוך פרטים של ערוצי הווידאו שלך',

    delete_course: 'מחק קורס',
    delete_course_desc: 'שלבים למחיקה קבועה של קורס',

    edit_metamaze: 'ערוך מבוך מטא',
    edit_metamaze_desc: 'למד איך לבצע עריכות במודולי מבוך מטא קיימים',

    edit_podcast: 'ערוך פודקאסט',
    edit_podcast_desc: 'ערוך פרקי פודקאסט ופרטים בקלות',

    create_live_event: 'איך ליצור אירוע חי',
    create_live_event_desc: 'מדריך שלב אחר שלב ליצירה ותזמון של אירועים חיים',

    translate_course: 'איך לתרגם קורס',
    translate_course_desc: 'למד איך לתרגם תוכן קורס למספר שפות',

    // LEADERBOARD
    create_competition: 'How to create a competition on the leaderboard',
    create_competition_desc: 'הגדר תחרויות ולוחות מובילים כדי לערב לומדים',

    leaderboard_settings: 'הגדרות לוח מובילים',
    leaderboard_settings_desc: 'הגדר הגדרות לוח מובילים ותחרויות',

    leaderboard_learner_view: 'ניווט בלוח המובילים של Sharelook',
    leaderboard_learner_view_desc:
      'צפה בלוחות מובילים ותחרויות מנקודת המבט של הלומד',

    // MARKETPLACE
    marketplace: 'An overview of The Sharelook Marketplace',
    marketplace_desc: 'סקירה של השוק ואיך לקנות ולמכור תוכן',

    buy_course: 'איך לקנות קורס',
    buy_course_desc: 'למד איך לקנות קורסים מהשוק',

    book_coaching: 'איך להזמין סשן אימון',
    book_coaching_desc: 'מדריך שלב אחר שלב להזמנת סשני אימון מהשוק',

    buy_podcast: 'איך לקנות פודקאסט',
    buy_podcast_desc: 'למד איך לקנות מנויי פודקאסט',

    subscribe_channel: 'איך לקנות/להירשם לערוץ וידאו',
    subscribe_channel_desc: 'הירשם לערוצי וידאו וגש לתוכן פרימיום'
  },
  v5: {
    view_document: 'הצג מסמך',
    duplicate_folder_name: 'קיים כבר תיקייה עם שם זה.',
    my_video_shorts: 'סרטונים קצרים שלי',
    see_more: 'ראה עוד',
    no_shorts_found: 'לא נמצאו סרטונים קצרים',
    shorts: 'סרטונים קצרים',
    general_information: 'מידע כללי',
    gamification: 'הפעלה במשחק',
    click_to_select_files: 'לחץ כדי לבחור קבצים',
    selected_files: 'קבצים שנבחרו',
    uploaded: 'הועלה',
    failed: 'נכשל',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'המערכת תנתח ותבחר אוטומטית את המסמכים הרלוונטיים ביותר מספריית הארגון שלך בהתאם לדרישות התוכן.',
    select_from_library: ' בחר מהספרייה',
    search_document: 'חפש מסמכים...',
    selected: 'נבחר',
    loading_documents: 'טוען מסמכים...',
    review_generated_content: 'סקור את התוכן שנוצר',
    confirm_and_replace_content: 'אשר והחלף תוכן',
    the_generate_content_will_replace:
      'התוכן שנוצר יחליף את הטקסט הקיים בעמודים שנבחרו. אם אינך רוצה ליישם את השינויים האלה, תוכל לחזור לשלב הקודם.',
    pages_to_be_updated: 'עמודים שיעודכנו',
    generated_revisions: 'תיקונים שנוצרו',
    lesson_preview: 'תצוגה מקדימה של השיעור',
    interactive_simulation: 'שיעור אינטראקטיבי',
    create_new_folder: 'צור תיקיה חדשה',
    rename_item: 'שנה שם פריט',
    enter_folder_name: 'הזן שם תיקיה:',
    enter_new_name: 'הזן שם חדש:',
    folder_name: 'שם תיקיה:',
    new_name: 'שם חדש',
    move_items: 'העבר פריטים',
    copy_items: 'העתק פריטים',
    move_here: 'העבר לכאן',
    copy_here: 'העתק לכאן',
    select_destination_library_and_folder: 'בחר ספריית יעד ותיקייה:',
    items_selected: 'פריטים נבחרו',
    version: 'גרסה',
    modified_by: 'נערך על ידי',
    size: 'גודל',
    restore: 'שחזר',
    are_you_sure_you_want_to_restore_this_version:
      'האם אתה בטוח שברצונך לשחזר גרסה זו?',
    this_will_replce_the_current_version_with_the_selected_one:
      'פעולה זו תחליף את הגרסה הנוכחית בגרסה שנבחרה.',
    restore_this_version: 'שחזר גרסה זו',
    restore_not_available: 'שחזור לא זמין',
    version_history: 'היסטוריית גרסאות:',
    by_making_items_public:
      'על ידי הפיכת הפריטים לציבוריים, הם יהיו גלויים לכולם. אנא עיין בתנאים וההגבלות לפני שתמשיך.',
    the_selected_items_will_be_copied:
      'הפריטים שנבחרו יועתקו לספרייה הציבורית שלך ויהיו גלויים לכולם.',
    the_selected_items_will_be_copied_to_org:
      'הפריטים שנבחרו יועתקו לספריית הארגון שלך ויהיו גלויים לכל חברי הארגון.',
    the_selected_items_will_be_copied_to_your_private:
      'הפריטים שנבחרו יועתקו לספרייה הפרטית שלך ויהיו גלויים רק לך.',
    loading_organization: 'טוען משתמשי ארגון...',
    click_download_to_view: 'לחץ על הורדה כדי להציג',
    archive_file: 'קובץ ארכיון',
    no_preview_available: 'תצוגה מקדימה אינה זמינה',
    audit_report: 'דוח ביקורת',
    audit_type: 'סוג פעולה',
    i_agree_to_the_terms_and_conditions: 'אני מסכים לתנאים ולהגבלות.',
    this_file_is_indexed_for_ai: 'קובץ זה מאונדקס עבור בינה מלאכותית.',
    file_is_not_indexed_for_ai: 'קובץ זה אינו מאונדקס עבור בינה מלאכותית.',
    no_users_found: 'לא נמצאו משתמשים',
    no_users_available: 'אין משתמשים זמינים',
    add_people: 'הוסף אנשים',
    people: 'אנשים',
    access_type: 'סוג גישה',
    no_group_found: 'לא נמצאו קבוצות',
    add_group: 'הוסף קבוצות',
    groups: 'קבוצות',
    users_top: 'משתמשים',
    confirm_delete: 'אשר מחיקה',
    do_you_want_remove: 'האם אתה בטוח שברצונך להסיר',
    form_this_documents_permissions: 'מההרשאות של מסמך זה?',
    no_users_found_in_this_group: 'לא נמצאו משתמשים בקבוצה זו',
    add_selected_users: 'הוסף משתמשים נבחרים',
    choose_users_from_the_list: 'בחר משתמשים מהרשימה',
    selected_users: 'משתמשים נבחרים',
    archived: 'ארכיון',
    request_approval: 'בקשת אישור',
    document_in_review: 'מסמך בבדיקה',
    approve: 'אשר',
    reject: 'דחה',
    comment: 'תגובה:',
    enter_your_commit: 'הכנס את התגובה שלך...',
    confirm_cancel: 'אשר ביטול',
    upload_3d_zip: 'העלה קובץ 3D Zip',
    delete_items: 'מחק פריטים',
    video_upload_request: 'בקשת העלאת וידאו',
    reject_video: 'דחה וידאו',
    enter_rejection_reason: 'הכנס סיבת דחייה...',
    please_provide_a_reason_for_reejection_this_video:
      'אנא ספק סיבה לדחיית וידאו זה:',
    generate_trivia_with_ai: 'צור חידון עם AI',
    select_category: 'בחר קטגוריה:',
    number_of_question: 'מספר שאלות',
    generated_questions: 'שאלות שנוצרו',
    this_will_clear_all_generate_question:
      'פעולה זו תמחוק את כל השאלות שנוצרו. להמשיך?',
    sure_delete: 'האם אתה בטוח שברצונך למחוק?',
    delete_this_question: 'האם אתה בטוח שברצונך למחוק שאלה זו?',
    loading_quiz: 'טוען חידון...',
    creteing_file: 'יוצר קובץ',
    opening_desktop_app: 'פותח אפליקציית שולחן עבודה',
    this_folder_is_empty: 'תיקייה זו ריקה',
    select_a_competition: 'בחר תחרות...',
    activity_badges: 'סמלי פעילות',
    awarded_every_badges: 'מוענק כל 4, 8, 16, 32, 64, 128, 256, 512 כניסות',
    learning_badges: 'סמלי למידה',
    awarded_every_courses: 'מוענק כל 1, 4, 8, 16, 32, 64, 128 קורסים שהושלמו',
    test_badges: 'סמלי מבחנים',
    awarded_every_passes_tests:
      'מוענק כל 2, 4, 8, 16, 32, 64, 128, 256 מבחנים שעברו',
    assignment_badges: 'סמלי משימות',
    awarded_every_passed_assignments:
      'מוענק כל 1, 2, 4, 8, 16, 32, 64, 128 משימות שעברו',
    perfectionism_badges: 'סמלי פרפקציוניזם',
    awarded_every_assignments_with_scrore:
      'מוענק כל 1, 2, 4, 8, 16, 32, 64, 128 מבחנים או משימות עם ציון 90%+',
    communication_badges: 'סמלי תקשורת',
    awarded_every_topics_or_comments:
      'מוענק כל 2, 4, 8, 16, 32, 64, 128, 256 נושאים או תגובות',
    certification_badges: 'סמלי הסמכה',
    awarded_every_certificates: 'מוענק כל 1, 2, 4, 8, 16, 32, 64, 128 תעודות',
    level_name: 'שם רמה',
    delete_competition: 'מחק תחרות',
    this_week: 'השבוע',
    this_year: 'השנה',
    delete_item: 'מחק {{type}}',
    folder: 'תיקייה',
    item: 'פריט',
    delete_confirmation: 'האם אתה בטוח שברצונך למחוק את',
    make_organization: 'עשה ארגון',
    no_results_found: 'לא נמצאו תוצאות עבור',
    no_items_available: 'אין פריטים זמינים',
    help_video: 'סרטוני עזרה',
    select_a_video_from_the_list: 'בחר סרטון מהרשימה כדי להתחיל ללמוד',
    relevant_videos_label: 'סרטונים בודדים',
    pinned_bundle_label: 'מדריך מלא',
    recording: 'הקלטה',
    on: 'פעיל',
    off: 'כבוי',
    started_on: 'התחיל ב',
    created_on: 'נוצר ב',
    this: 'זה',
    list_arrangement_will_be_primary_order:
      'סידור הרשימה יהיה הסדר הראשי עבור הרשימה הנראית בדף ההדרכה.',
    sequence_order: 'סדר רצף',
    sequence_not_set: 'רצף לא נקבע',
    order_sequence_set_successfully: 'סדר הרצף נקבע בהצלחה',
    search_for_stock_images: 'חפש תמונות ממלאי...',
    search_for_a_location: 'חפש מיקום...',
    loading_suggestions: 'טוען הצעות...',
    suggested_locations: 'מיקומים מוצעים:',
    available: 'זמין',
    no_podcast_is_available: 'אין פודקאסט זמין!',
    no_mazes_available: 'אין מבוכים זמינים!',
    grid_view: 'תצוגת רשת',
    list_view: 'תצוגת רשימה',
    create_a_subtle_and_non_distracting_background_image:
      'צור תמונת רקע עדינה שאינה מסיחה עבור קורס דיגיטלי, בהשראת',
    the_image_should_incorporate_elements_of: 'התמונה צריכה לשלב אלמנטים של',
    vary_abstract_faded_or_minimalist_way:
      'בצורה מופשטת, דהויה או מינימליסטית מאוד. השתמש בצבעים רכים מאוד, הדרגות עדינות או דפוסים כמעט בלתי נראים שמרמזים על הנושא מבלי להיות מילוליים או בולטים מדי. האפקט הכללי צריך להיות קל וקליל, כך שהטקסט והתוכן שמעליו יהיו קריאים בקלות. העיצוב חייב להיות מתאים לממדי 16:9 ולהתאים לרכיבי UI שונים. ודא שהאלמנטים מפוזרים באופן שווה ליצירת רקע מאוזן שאינו מסיח את הדעת.',
    top_left: 'פינה עליונה שמאלית',
    top_right: 'פינה עליונה ימנית',
    bottom_left: 'פינה תחתונה שמאלית',
    bottom_right: 'פינה תחתונה ימנית',
    select_position_of_image_you_like: 'בחר את המיקום של התמונה שאתה אוהב',
    select_a_position_of_image:
      'בחר מיקום של התמונה שתרצה ליצור עבורה גרסאות שונות',
    generate_variations: 'צור גרסאות',
    select_a_position_of_image_upscale: 'בחר מיקום של התמונה שתרצה לשדרג',
    upscale_image_for_selection: 'שדרג תמונה עבור הבחירה',
    generation_variations: 'יוצר גרסאות...',
    generating_your_image: 'יוצר את התמונה שלך...',
    waiting_start_generation: 'ממתין להתחלת יצירה',
    variations: 'גרסאות',
    upscaling_image: 'משדרג תמונה...',
    upscaled_image: 'תמונה משודרגת',
    ai_generate_image: 'תמונה שנוצרה על ידי AI',
    select: 'בחר',
    generate_image_using_your_image: 'צור תמונה באמצעות הרעיון שלך',
    please_enter_your_idea: 'אנא הזן את הרעיון שלך...',
    your_prompt_here: 'ההנחיה שלך כאן...',
    add_text_in_the_image: 'הוסף טקסט בתמונה',
    what_type_image_do_you_generate:
      'איזה סוג תמונה ברצונך ליצור? אנא תאר את הסצנה, האובייקטים או כל פרט ספציפי, ואעשה כמיטב יכולתי ליצור עבורך.',
    are_you_sure_you_want_to_start_a_new_chat:
      'האם אתה בטוח שברצונך להתחיל צ׳אט חדש?',
    start_new_chat: 'התחל צ׳אט חדש',
    stop_chat: 'עצור צ׳אט',
    start_chat: 'התחל צ׳אט',
    created_successfully: 'נוצר בהצלחה',
    failed_to_create_folder: 'נכשל ביצירת תיקייה',
    please_enter_name: 'אנא הזן שם',
    failed_to_rename_file_folder: 'נכשל בשינוי שם קובץ/תיקייה',
    opened_download_link_in_new_tab: 'קישור ההורדה נפתח בכרטיסייה חדשה',
    failed_to_get_download_link: 'נכשל בקבלת קישור להורדה',
    prepare_download: 'מכין הורדות...',
    failed_download_link: 'נכשל בקבלת קישור להורדה עבור מזהה',
    open_first_download: 'הקישור הראשון נפתח. בדוק את הקונסולה עבור',
    additional_link: 'קישורים נוספים.',
    prepared: 'מוכן',
    download_link: 'קישורי הורדה',
    no_download_file: 'לא נמצאו קבצים להורדה',
    download_failed: 'הכנת ההורדה נכשלה',
    certificate_title_is_required: 'נדרש כותרת תעודה.',
    are_you_sure_you_want_to_attach_this_certificate:
      'האם אתה בטוח שברצונך לצרף תעודה זו לקורס זה? היא תהיה זמינה גם בהיסטוריית התעודות שלך.',
    update_badge: 'עדכן סמל',
    attach_audio: 'צרף שמע',
    correct_answer_is_required: 'נדרש תשובה נכונה.',
    or: 'או',
    insert_scenario: 'הכנס תרחיש',
    as_screen_capture: 'כתפיסת מסך',
    as_simulation: 'עם סימולציה',
    added_avatar: 'אווטאר נוסף',
    select_avatar: 'בחר אווטאר',
    add_audio: 'הוסף שמע',
    only_to_options: 'רק 2 עד 4 אפשרויות',
    only_to_layers: 'רק 2 עד 8 שכבות',
    shop: 'SOP',
    video_channel: 'ערוץ וידאו',
    podcasts: 'פודקאסטים',
    organisations: 'ארגונים',
    org_groups: 'קבוצות ארגונים',
    channel_outline_is_required: 'נדרש מבנה ערוץ',
    channel_obj_required: 'נדרשים מטרות הערוץ.',
    enter_value: 'אנא הזן ערך.',
    no_basket_to_add: 'לא נבחרו פריטים להוספה לסל',
    find_your_video: 'מצא את מזהי המשתמש והערוץ שלך ב-YouTube',
    each_youtube_channel_has_unique:
      'לכל ערוץ YouTube יש מזהי משתמש וערוץ ייחודיים. מזהים אלו משמשים להפניה לערוץ באפליקציות ושירותים מסוימים.',
    find_channel_id: 'כיצד למצוא את מזהי המשתמש והערוץ שלך',
    your_channel_user_id: 'אתה יכול למצוא את מזהים של הערוץ שלך ב',
    advance_account: 'הגדרות חשבון מתקדמות',
    computer_or_mobile_browser: 'במחשב או דפדפן מובייל.',
    sign_in_to: 'התחבר ל',
    click_profile_pic_left: 'בפינה הימנית העליונה, לחץ על תמונת הפרופיל שלך',
    from_the_left_menu: 'מהתפריט השמאלי, בחר',
    adv_setting: 'הגדרות מתקדמות',
    user_channel_id_there: 'שם תראה את מזהי המשתמש והערוץ שלך.',
    you_can_also: 'אתה יכול גם',
    manage_channel: 'לנהל את שם הערוץ שלך',
    studio_youtube: 'ב-YouTube Studio.',
    sharesphere_question_updated: 'שאלת ShareSphere עודכנה',
    select_category: 'בחר קטגוריה(ות)',
    please_select_category: 'אנא בחר קטגוריה(ות)!',
    ShareSphere_question_created: 'שאלת ShareSphere נוצרה',
    generate_text: 'צור טקסט',
    ar_trigger_image: 'תמונת טריגר AR',
    name_of_the_guest: 'שם האורח מספר',
    library: 'ספרייה',
    previous: 'קודם',
    draft: 'טיוטה',
    unpublishing: 'מסיר פרסום',
    publishing: 'מפרסם',
    unpublish_from_marketplace: 'הסר פרסום מהשוק',
    unpublished: 'לא פורסם',
    unpublish: 'הסר פרסום',
    publish: 'פרסם',
    quiz_complete: 'חידון הושלם',
    lesson_complete: 'שיעור הושלם',
    get_certificate: 'קבל תעודה',
    select_participants: 'בחר משתתפים',
    competition_updated_successfully: 'התחרות עודכנה בהצלחה!',
    competition_created_successfully: 'התחרות נוצרה בהצלחה!',
    levels_configuration: 'קונפיגורציית רמות',
    account_subscribptions: 'מנויים פעילים',
    search_organisation: 'חפש ארגון',

    generate_an_engaging_introduction_to_capture:
      'צור הקדמה מרתקת כדי למשוך את תשומת הלב של הקהל שלך ולקבוע את הטון לשיעור שלך.',
    create_a_comprehensive_summary:
      'צור סיכום מקיף שמחזק נקודות מפתח ומסיים את השיעור שלך ביעילות.',
    introductio_added_at_the_beginning: 'הקדמה נוספה בתחילת השיעור.',
    summary_added: 'סיכום נוסף בסוף השיעור.',
    you_cannot_add_other_element_in_a_scenario_page:
      'אינך יכול להוסיף אלמנטים אחרים בעמוד תרחיש. אנא נסה בעמודים אחרים או הסר את התרחיש מהעמוד תחילה.',
    pages_list_whose_content_you_want_to_reference:
      'אנא לחץ על העמודים מרשימת העמודים שתוכן שלהם תרצה להתייחס אליו ב',
    choose_your_story: 'בחר את הסיפור שלך',
    generate_scenario: 'הנה התרחיש שנוצר עבורך!',
    will_help_you_create_scenario:
      'שלום! אני אעזור לך ליצור תרחיש. על מה תרצה להתמקד?',
    sorry_encountered_an_error: 'מצטער, נתקלתי בשגיאה. אנא נסה שוב.',
    chat_based_scenario_generation: "יצירת תרחיש מבוססת צ'אט",
    start_conversation_to_generate:
      'התחל שיחה כדי ליצור את התרחיש שלך באמצעות דיאלוג אינטראקטיבי.',
    view_scenario: 'הצג תרחיש',
    use_this_scenario: 'השתמש בתרחיש זה',
    prompt_helper: 'עוזר הנחיות',
    hide_prompt_helper: 'הסתר עוזר הנחיות',
    please_upload_reference_image:
      'אנא העלה לפחות תמונת התייחסות אחת למצב עריכת תמונה',
    error_generating_image: 'שגיאה ביצירת תמונה. אנא נסה שוב!',
    max_reference_images_allowed:
      'מקסימום 9 תמונות התייחסות מותר. אנא הסר תמונה תחילה.',
    failed_to_convert_image_url: 'נכשל בהמרת כתובת התמונה!',
    preparing_variations: 'מכין גרסאות...',
    preparing_image: 'מכין תמונה...',
    generated_image_alt: 'תמונה שנוצרה',
    processing_your_request: 'מעבד את הבקשה שלך...',
    generating_variations_in_progress: 'יוצר גרסאות בתהליך',
    lightning_fast_generation_in_progress: 'יצירה מהירה מאוד בתהליך',
    file: 'קובץ',
    is_too_large: 'גדול מדי',
    mb: 'MB',
    limit_is: 'הגבלה היא',
    please_enter_image_idea: 'אנא הזן את רעיון התמונה שלך...',
    your_prompt_here: 'ההנחיה שלך כאן...',
    what_type_image_generate:
      'איזה סוג תמונה תרצה ליצור? אנא תאר את הסצנה, האובייקטים או כל פרט ספציפי שיש לך בראש, ואעשה כמיטב יכולתי ליצור עבורך.',
    select_pixel_image_title: 'בחר תמונת פיקסל',
    stock_image: 'תמונת מלאי',
    pagination_of: 'מתוך',
    pagination_images: 'תמונות',
    reference_image_alt: 'תמונת התייחסות',
    user_alt: 'משתמש',
    story_description_tone: 'מצב רוח כללי או גישה של הסיפור.',
    story_description_narrative_hook:
      'שורה או פסקה פותחת מרתקת שמושכת את תשומת הלב של הקורא ומכינה את הבמה לסיפור.',
    story_description_narrative_style: 'נקודת מבט שממנה מסופר הסיפור.',
    story_description_story_plot:
      'עלילה היא איך סיפור מוצג, כמו בסרט או בספר. זה הסדר שבו אירועים קורים. לפעמים הם מוצגים אחד אחרי השני, ולפעמים הם מעורבבים. למשל, כמה סיפורים מתחילים עם הסוף ואז חוזרים להתחלה כדי להסביר.',
    story_description_complexity: 'רמת קושי ועומק של הסיפור.',
    story_description_genre: 'קטגוריה או סוג של סיפור.',
    story_description_vocabulary: 'בחירה ושימוש במילים.',
    story_description_narrative_structure: 'ארגון אירועי הסיפור.',
    story_description_time_period: 'תקופה שבה הסיפור מתרחש.',
    story_description_story_length: 'אורך הנרטיב.',
    story_description_character_names: 'שמות הדמויות בסיפור.',
    story_description_output_type: 'הפורמט של הסיפור.',
    story_chat_initial_message:
      'שלום! אני אעזור לך ליצור סיפור. על מה תרצה להתמקד?',
    story_add_to_pages_title: 'האם תרצה להוסיף סיפור לעמודים?',
    story_add_to_pages_content: 'התוכן המקורי יוחלף בטקסט הסיפור.',
    story_chat_error_message: 'מצטער, נתקלתי בשגיאה. אנא נסה שוב.',
    story_generated_story_label: 'סיפור שנוצר',
    story_generating: 'יוצר...',
    story_use_story_title: 'האם תרצה להשתמש בסיפור שנוצר זה?',
    story_use_story_content:
      'זה יפתח את עורך הסיפורים שבו תוכל לבצע עריכות נוספות לפני הוספתו לשיעור שלך.',
    story_use_story_button: 'השתמש בסיפור',
    story_chat_placeholder: 'הקלד את ההודעה שלך...',
    story_chat_send: 'שלח',
    story_form_mode: 'מצב טופס',
    story_chat_mode: "מצב צ'אט",
    story_page_heading: 'סיפור',
    bullet_points: 'נקודות בולטות',
    scenario_generation: 'יצירת תרחיש',
    please_enter_number_of_questions: 'אנא הזן את מספר השאלות',
    please_enter_number_of_questions: 'אנא הזן מספר שאלות בין 1 ל-10',
    maze_summary: 'סיכום מבוך',
    course_recommendation: 'המלצת קורס',
    downlad_center_save_summary: 'שמור סיכום במרכז ההורדות',
    loading_maze_summary: 'טוען סיכום מבוך...',
    generating_course_recommendation: 'יוצר המלצת קורס...',
    no_course_recommended: 'לא הומלץ קורס.',
    click_to_view_course: 'לחץ כדי לצפות בקורס',
    select_simulation_type: 'בחר סוג סימולציה',
    simulation_mode: 'מצב סימולציה',
    attempts_count: 'מספר ניסיונות',
    no_of_attempts_user_can_try: 'מספר ניסיונות שמשתמש יכול לנסות',
    uload_section_file: 'העלה קובץ סעיף',
    my_library: 'הספרייה שלי',
    search_documents_by_name: 'חפש מסמכים לפי שם...',
    document: 'מסמך',
    org_library: 'ספריית הארגון',
    top_center: 'מרכז עליון',
    center: 'מרכז',
    bottom_center: 'מרכז תחתון',
    big: 'גדול',
    small: 'קטן',
    medium: 'בינוני',
    text_position: '📝 מיקום טקסט',
    please_select_text: 'אנא בחר מיקום טקסט',
    note_that_ai_generated_content_may_not_always_be_accurate:
      '* שים לב שתוכן שנוצר על ידי בינה מלאכותית לא תמיד מדויק. מיקום ועיצוב הטקסט, כגון הוספת טקסט, עלולים לעיתים להיות לא מדויקים.',
    number_of_images: '📝 מספר תמונות',
    please_select_of_image: 'אנא בחר מספר תמונות',
    creating_calc_spreadsheet: 'יוצר גיליון Calc...',
    creating_calc_spreadsheet_successfully: 'גיליון Calc נוצר והועלה בהצלחה!',
    opening_sharelook: 'פותח את ShareLook...',
    shareLook_opened_successfully: 'ShareLook נפתח בהצלחה!',
    upload_function_not_provided: 'מצגת Impress נוצרה והועלתה בהצלחה!',
    creating_impress_presentation: 'יוצר מצגת Impress...',
    talk_with_course_assistants: 'שוחח עם עוזרי הקורס',
    select_your_coacher: 'בחר את המאמן שלך',
    simon_witts_aviation_generation_ccoacher: 'סיימון ויטס - דור התעופה - מאמן',
    simon_witts: 'סיימון ויטס',
    aviation_generation_coacher: 'דור התעופה - מאמן',
    coacher_mode_active: 'מצב מאמן פעיל',
    your_personal_coaching_experience: 'חוויית האימון האישית שלך',
    powered_by: 'מופעל על ידי',
    uk_civil_viation_authority_data: 'נתוני רשות התעופה האזרחית של בריטניה',
    start_coaching_session: 'התחל מפגש אימון',
    what_image_do_you_need: 'איזו תמונה אתה צריך?',
    write_something: 'כתוב משהו.',
    speak: 'דבר',
    grid: 'רֶשֶׁת',
    ar: 'מציאות רבודה',
    premium_voices: 'קולות פרימיום',
    default_tts: 'המרת טקסט לדיבור ברירת מחדל',
    generate_audio: 'צור שמע',
    username_or_email_address: 'שם משתמש או כתובת אימייל',
    meta_maze_avatars: 'אווטרים של מבוך מטא',
    training_skill_journey: 'מסע מיומנויות ההדרכה',
    video_channel: 'ערוץ וידאו',
    marketplace: 'מרקטפלייס',
    are_you_sure_you_want_to_update_your_course_template:
      'האם אתה בטוח שברצונך לעדכן את תבנית הקורס?',
    this_will_automatically_update_the_template:
      'פעולה זו תעדכן אוטומטית את התבנית עבור כל השיעורים והעמודים שנוצרו בקורס שלך.',
    note_this_process_will_change_the_course_lesson_layouts:
      'לתשומת לבך: תהליך זה ישנה את פריסות השיעורים בקורס, מה שעשוי להשפיע על מיקום האודיו, הווידאו, התמונות ואלמנטים נוספים. אם הוספת אלמנטים חדשים לתבנית קיימת בעמוד כלשהו, המיקומים שלהם לא ישתנו.',
    open_sharelook_application: 'לפתוח את אפליקציית ShareLook?',
    this_will_launch_sharelook_for_screen_capture:
      'פעולה זו תפתח את ShareLook לצילום מסך.',
    open: 'פתח',
    are_you_sure_you_want_to_save_this_certificate_for_later:
      'האם אתה בטוח שברצונך לשמור את התעודה הזו לאחר כך? היא לא תצורף לקורס זה אך תהיה זמינה בהיסטוריית התעודות שלך.',
    are_you_sure_you_want_to_remove_this_media:
      'האם אתה בטוח שברצונך להסיר את המדיה הזו?',
    the_media_will_be_removed_from_the_scenario: 'המדיה תוסר מהתרחיש.',
    proceed_to_template_selection: 'המשך לבחירת תבנית',
    template_selection: 'בחירת תבנית',
    template_selection: 'בחירת תבנית',
    competition_title_is_required: 'כותרת התחרות חובה!',
    competition_description_is_required: 'תיאור התחרות חובה!',
    skill_selection_is_required: 'בחירת מיומנות חובה!',
    start_date_is_required: 'תאריך התחלה חובה!',
    end_date_is_required: 'תאריך סיום חובה!',
    start_date_must_be_before_end_date:
      'תאריך ההתחלה חייב להיות לפני תאריך הסיום!',
    points_cannot_be_negative: 'נקודות לא יכולות להיות שליליות!',
    points_connot_exceed: 'נקודות לא יכולות לעלות על 1000!',
    error_occured_while_creating_the_competition:
      'אירעה שגיאה בעת יצירת התחרות.',
    select_question_type: 'בחר סוג שאלה',
    please_select_question_type: 'אנא בחר סוג שאלה!',
    search_by_title_or_description: 'חפש לפי כותרת או תיאור...',
    no_videos_found_matching: 'לא נמצאו סרטונים תואמים',
    what_new_at_shareLook: 'מה חדש ב-ShareLook',
    did_you_know_that_creating_learning_experience:
      'האם ידעת שיצירת חוויית למידה בסגנון סיפור היא קלה, מהירה וזולה? כדאי לשלב את בונה הקורסים של ShareLook עם הכישורים שלך. שאל אותנו איך.',
    welcome_to_shareLook_help_center: 'ברוכים הבאים למרכז העזרה של ShareLook',
    select_video_from_the_left_navigation:
      'בחר סרטון מהניווט השמאלי כדי להתחיל, או השתמש בחיפוש כדי למצוא תוכן ספציפי.',
    date_time_error_peer: 'זמן התחלת האירוע חייב להיות לפחות דקה מהעת הנוכחית.',
    no_language_information_available: 'אין מידע על שפה זמין עבור הקולות האלה.',
    loading_eventlabs_voices: 'טוען קולות מ-ElevenLabs...',
    search_voices: 'חפש קולות...',
    please_upload_at_last_one_supported_file: 'אנא העלה לפחות קובץ אחד נתמך.',
    you_can_upload_a_maximum_of_files: 'ניתן להעלות עד 5 קבצים.',
    failed_to_load_documents: 'טעינת המסמכים נכשלה. אנא נסה שוב.',
    file_not_supported: 'אינו סוג קובץ נתמך. סוגי הקבצים הנתמכים:',
    required_fields_are_missing: 'שדות חובה חסרים.',
    form_validation_failed: 'אימות הטופס נכשל.',
    select_cloned_voice: 'בחר קול משוכפל',
    upload_voice: 'קולות שהועלו',
    max_five: '5 (מקסימום)',
    loading_list: 'טוען רשימה...',
    failed_to_create_podcast: 'נכשל ביצירת הפודקאסט!',
    failed_to_create_voicce: 'נכשל ביצירת הקול!',
    make_public_success: 'הפריטים הופכו לציבוריים בהצלחה',
    make_org_success: 'הפריטים הועברו לארגון בהצלחה',
    make_private_success: 'הפריטים הופכו לפרטיים בהצלחה',
    make_public_failed: 'נכשל בהפיכת הפריטים לציבוריים',
    make_org_failed: 'נכשל בהעברת הפריטים לארגון',
    make_private_failed: 'נכשל בהפיכת הפריטים לפרטיים',
    the_number_of_choices_or_paths_available:
      'מספר האפשרויות או המסלולים הזמינים ללומד. חלק זה יושבת אם הלומד בוחר בסוג תרחיש פתוח. <2, 3, 4>',
    select_this_image: 'בחר תמונה זו',
    please_select_a_font_size: 'אנא בחר גודל גופן',
    font_style: 'סגנון גופן',
    please_select_a_font_style: 'אנא בחר סגנון גופן',
    font_type: 'סוג גופן',
    please_select_a_font_type: 'אנא בחר סוג גופן',
    text_color: 'צבע טקסט',
    please_select_a_text_color: 'אנא בחר צבע טקסט',
    regular: 'רגיל',
    bold: 'מודגש',
    italic: 'נטוי',
    thin: 'דק',
    font_retro: 'רטרו',
    font_techy: 'טכנולוגי',
    font_neon: 'ניאון',
    font_sketch: 'סקיצה',
    font_3d: 'תלת-ממדי',
    font_comic_style: 'סגנון קומיקס',
    font_anime_style: 'סגנון אנימה',
    font_illustration: 'איור',
    font_hand_written: 'כתב יד',
    font_quirky: 'משונה',
    font_chalk_board: 'לוח גיר',
    color_vibrant: 'חיים',
    color_black_white: 'שחור ולבן',
    color_gold_script: 'כתב זהב',
    color_rainbow_neon: 'קשת ניאון',
    color_gradient: 'מדרג',
    text_options: 'אפשרויות טקסט',
    icon_text: '📝 טקסט',
    type_message: 'הקלד הודעה',
    please_upload_at_least_one_supported_file:
      'אנא העלה לפחות קובץ אחד נתמך (.pdf, .doc, .docx, .ppt, .pptx, .txt).',
    select_files_to_upload: 'בחר קבצים להעלאה',
    showing: 'מציג',
    are_you_sure_delete_file_confirm: 'האם אתה בטוח שברצונך למחוק זאת?',
    click_to_open_pdf_reference: 'לחץ לפתיחת קובץ PDF',
    click_to_open: 'לחץ לפתיחה',
    write_here: 'כתוב כאן...',
    content_edited_successfully: 'התוכן נערך בהצלחה!',
    failed_to_edit_content: 'העריכת התוכן נכשלה',
    please_enter_editing_instruction: 'אנא הזן הוראות עריכה',
    review_course_wide_changes: 'סקירת שינויים בכל הקורס',
    collapse_all: 'כווץ הכל',
    expand_all: 'הרחב הכל',
    adding_content_from_internet: 'מוסיף תוכן מהאינטרנט...',
    no_content_found: 'לא נמצא תוכן.',
    please_enroll_to_take_this_skill_journey:
      'אנא הירשם כדי לקחת את מסע המיומנויות הזה',
    edited_content: 'תוכן ערוך',
    a_recommended_course_is_available:
      'קורס מומלץ זמין. אנא בדוק את היישום לפרטים נוספים.',
    competition_deleted_successfully: 'התחרות נמחקה בהצלחה!',
    failed_to_delete_the_competition: 'נכשל במחיקת התחרות!',
    generate_content_from: 'צור תוכן מ־',
    minimum_score: 'ציון מינימלי',
    please_select_style: 'אנא בחר סגנון',
    document_type: 'סוג מסמך',
    select_document_type: 'בחר סוג מסמך',
    please_select_document_type: 'אנא בחר סוג מסמך',
    document_name: 'שם המסמך',
    please_enter_document_name: 'אנא הזן שם מסמך',
    infographics: 'אינפוגרפיקות',
    generate_infographics: 'צור אינפוגרפיקות',
    course_builder: 'בונה קורסים',
    short_videos: 'סרטונים קצרים',
    user_management: 'ניהול משתמשים',
    user_agreement: 'הסכם משתמש',
    terms_and_conditions_upper: 'תנאים והגבלות',
    connected: 'מחובר',
    waiting_for_coach: 'ממתין למאמן...',
    disconnected: 'מנותק',
    coach_intro: 'שלום, אני מאמן לוגיסטיקה של DGF.',
    coach_help: 'איך אני יכול לעזור לך?',
    press_to_speak: 'לחץ כאן לפני הדיבור',
    leave: 'עזוב',
    open_the_sharelook_application_for_building_interactive_lesson:
      'פעולה זו תפתח את אפליקציית ShareLook ליצירת שיעור אינטראקטיבי. אם האפליקציה לא נפתחת, ייתכן שהיא אינה מותקנת על המכשיר שלך.',
    launch_interactive_lesson: 'הפעל שיעור אינטראקטיבי',
    create_interactive_lesson: 'צור שיעור אינטראקטיבי',
    set_up_your_interactive_lesson: 'הגדר את השיעור האינטראקטיבי שלך',
    interactive_lesson_title: 'כותרת השיעור האינטראקטיבי',
    enter_interactive_lesson_title: 'הזן כותרת לשיעור האינטראקטיבי',
    this_feature_available_for_windows_user_only:
      'פיצ׳ר זה זמין למשתמשי Windows בלבד',
    create_interactive_lesson: 'צור שיעור אינטראקטיבי',
    preparing_interactive_lesson: 'מכין שיעור אינטראקטיבי...',
    please_wait_while_we_set_up_your_interactive_lesson:
      'אנא המתן בזמן שאנו מגדירים את השיעור האינטראקטיבי שלך',
    open_sharelook_app: 'פתח את אפליקציית ShareLook',
    current_color: 'הצבע הנוכחי',
    new_color: 'הצבע החדש',
    narrativeHook: 'וו נרטיבי',
    storyPlot: 'עלילת הסיפור',
    complexity: 'מורכבות',
    genre: 'ז׳אנר',
    vocabulary: 'אוצר מילים',
    narrativeStructure: 'מבנה נרטיבי',
    timePeriod: 'תקופת זמן',
    storyLength: 'אורך הסיפור',
    characterNames: 'שמות הדמויות',
    outputType: 'סוג פלט',
    tone: 'טון',
    narrativeStyle: 'סגנון נרטיבי',
    formal: 'רשמי',
    informal: 'לא רשמי',
    humorous: 'מצחיק',
    assertive: 'נחרץ',
    sarcastic: 'סרקסטי',
    optimistic: 'אופטימי',
    firstPerson: 'דמות ראשונה',
    secondPerson: 'דמות שנייה',
    thirdPerson: 'דמות שלישית',
    thirdPersonLimited: 'דמות שלישית מוגבלת',
    thirdPersonOmniscient: 'דמות שלישית כל-יודעת',
    epistolary: 'אפיוסטולרי',
    beginner: 'מתחיל',
    intermediate: 'בינוני',
    advanced: 'מתקדם',
    experimental: 'ניסיוני',
    realistic: 'ריאליסטי',
    historical: 'היסטורי',
    casual: 'קז’ואל',
    drama: 'דרמה',
    fantasy: 'פנטזיה',
    adventure: 'הרפתקה',
    satire: 'סאטירה',
    scienceFiction: 'מדע בדיוני',
    mystery: 'מסתורין',
    linear: 'ליניארי',
    nonLinear: 'לא ליניארי',
    circular: 'מעגלי',
    inMediaRes: 'בתוך ההתרחשות',
    framedNarrative: 'נרטיב ממוסגר',
    past: 'עבר',
    present: 'הווה',
    future: 'עתיד',
    timelessOrUnspecified: 'ללא זמן מוגדר / נצחי',
    short: 'קצר (300 - 500 מילים)',
    medium: 'בינוני (500 - 800 מילים)',
    long: 'ארוך (מעל 800 מילים)',
    screenplay: 'תסריט',
    narrative: 'נרטיב',
    simple: 'פשוט',
    moderate: 'בינוני',
    advanced: 'מתקדם',
    jargonOrTechnical: 'מונחים מקצועיים או טכניים',
    periodSpecific: 'תקופתי / ספציפי לתקופה',
    slangOrColloquial: 'סלנג או דיבור יומיומי'
  },
  v4: {
    upload_another_file: 'העלה קובץ נוסף',
    all_files_uploaded: 'כל הקבצים הועלו',
    upload_and_submit: 'העלה ושלח',
    drop_files: 'גרור קובץ ובחר לאן להעלות.',
    duplicate_lessoon: 'השיעור כבר קיים בקורס',
    skill_rule_title: 'אנא הזן כותרת למסלול מיומנות',
    imageCreatorTitle: 'יוצר תמונות',
    isTranslated: 'מתורגם',
    translationCourseDesc:
      'התרגום של הקורס עשוי לקחת מספר דקות. תודה על הסבלנות!',
    translateCourseTip:
      'צור קורס מתורגם שתוכל לערוך באופן עצמאי מהמקור, כולל את כל השיעורים והדפים.',
    translateModalBtn: 'תרגם',
    translationSuccess: 'הקורס "<0/>" תורגם בהצלחה!',
    translatingCourse: 'מתרגם קורס...',
    translateModalTitle: 'תרגם קורס',
    translateSelectLang: 'בחר שפה',
    fileDeleteconfirm:
      'האם אתה בטוח שברצונך למחוק את הקובץ הזה? פעולה זו אינה ניתנת לביטול.',
    fileDeleteMessage: 'הקובץ נמחק בהצלחה.',
    fileDeleteFailedMessage: 'מחיקת הקובץ נכשלה!',
    fileDelete: 'מחק קובץ זה.',
    certificate_save_btn: 'הוסף תעודה ל-',
    maze_path_info: 'אין מסלולים זמינים לגרף!',
    file_size_mb: 'גודל הקובץ חייב להיות פחות מ-25 מגה-בייט!',
    reports: {
      products: 'מוצרים',
      users: 'משתמשים',
      ph_username: 'חפש משתמש לפי שם משתמש',
      ph_id: 'חפש משתמש לפי מספר זיהוי',
      ph_email: 'חפש משתמש לפי אימייל'
    },
    select_upload_section_id: 'נדרשת בחירת קטע להעלאה',
    tags_all: 'הכל',
    delete_file_confirm: 'האם אתה בטוח שברצונך למחוק את הקובץ הזה?',
    delete_file_title: 'מחק קובץ',
    tooltip_publish: 'פרסם את הקורס באפשרות שנבחרה',
    tooltip_save: 'שמור את הקורס עם העדכונים הנוכחיים',
    tooltip_next: 'עבור להגדרת הקורס הבאה',
    tooltip_finish: 'סיים ושמור את העדכונים הנוכחיים',
    stories_modal: {
      title_upload: 'העלה סיפורים',
      title_update: 'עדכן סיפורים',
      title_audio: 'קובץ אודיו לסיפור',
      btn_upload: 'העלה',
      btn_update: 'עדכן',
      btn_close: 'סגור',
      btn_cancel: 'בטל',
      lbl_cover: 'תמונת כריכת הסיפור',
      rule_cover: 'אנא העלה כריכת סיפור!',
      lbl_title: 'כותרת אודיו הסיפור',
      rule_title: 'אנא הזן כותרת אודיו לסיפור!',
      lbl_description: 'תיאור אודיו הסיפור',
      rule_description: 'אנא הזן תיאור אודיו לסיפור!',
      lbl_file: 'העלה קובץ אודיו לסיפור',
      rule_file: 'אנא העלה קובץ אודיו לסיפור!',
      rule_file_type: 'אנא העלה קובץ אודיו חוקי!',
      lbl_select_file: 'בחר קובץ אודיו לסיפור',
      msg_valid_file: 'אנא בחר קובץ אודיו חוקי!',
      msg_success: 'קובץ אודיו הסיפור הועלה בהצלחה',
      msg_failed: 'הקצאת מדיה נכשלה!',
      msg_error: 'שגיאה בהעלאת הקובץ!'
    },
    audio_modal: {
      title_upload: 'העלה',
      title_update: 'עדכן',
      title_audio: 'קובץ אודיו',
      btn_upload: 'העלה',
      btn_update: 'עדכן',
      btn_close: 'סגור',
      btn_cancel: 'בטל',
      lbl_cover: 'כריכת אודיו',
      rule_cover: 'אנא העלה כריכת אודיו!',
      lbl_title: 'כותרת אודיו',
      rule_title: 'אנא הזן כותרת אודיו!',
      lbl_description: 'תיאור אודיו',
      rule_description: 'אנא הזן תיאור אודיו!',
      lbl_file: 'העלה קובץ אודיו',
      rule_file: 'אנא העלה קובץ אודיו!',
      rule_file_type: 'אנא העלה קובץ אודיו חוקי!',
      lbl_select_file: 'בחר קובץ אודיו',
      msg_valid_file: 'אנא בחר קובץ אודיו חוקי!',
      msg_success: 'קובץ האודיו הועלה בהצלחה',
      msg_failed: 'הקצאת מדיה נכשלה!',
      msg_error: 'שגיאה בהעלאת הקובץ!'
    },
    info_episode: 'תמונת כריכה לפרק.',
    btn_delete_episode: 'מחק פרק פודקאסט זה.',
    btn_edit_marketplace: 'ערוך פרטי שוק.',
    btn_save_marketplace: 'שמור את השינויים הנוכחיים.',
    btn_ai_podcast: 'צור פרק פודקאסט מופעל בינה מלאכותית.',
    btn_upload_podcast: 'העלה פרק אודיו פודקאסט משלך.',
    attach_file: 'העלה קבצים כדי לשתף תוכן נוסף עם הקהל שלך',
    fileDownload: 'הורד קובץ זה.',
    singleEpishode: 'פרק',
    podcast_music: 'פודקאסט, מוזיקה וסיפורים',
    publishHeader: 'פרסם פודקאסטים, מוזיקה וסיפורים',
    editHeader: 'ערוך פודקאסטים, מוזיקה וסיפורים',
    createHeader: 'צור פודקאסטים, מוזיקה וסיפורים',
    marketplaceHeader: 'פרטי שוק לפודקאסטים, מוזיקה וסיפורים',
    message_marketplace: 'אנא השלם את טופס השוק!',
    create_podcast_live: 'פודקאסט ומוזיקה בשידור חי',
    create_podcast_custom: 'פודקאסט ומוזיקה מותאמים',
    create_podcast_stories: 'סיפור',
    ai_Assisted_podcast_reation: 'פודקאסט ומוזיקה עם סיוע AI',
    publishTitle: 'פרסם פודקאסט, מוזיקה וסיפורים לצפייה ציבורית.',
    customButton: 'צור מותאם אישית',
    customTitle: 'שמור שינויים שנעשו לפודקאסט.',
    updateButton: 'עדכן',
    createButton: 'צור',
    createNewButton: 'צור חדש',
    updateTitle: 'עדכן את פרטי הפודקאסט, המוזיקה והסיפורים הנוכחיים.',
    createTitle: 'צור פודקאסט, מוזיקה וסיפורים חדשים',
    createNewTitle:
      'פודקאסט, מוזיקה וסיפורים חדשים ייווצרו על פודקאסט, מוזיקה וסיפורים קיימים עם פרטי קלט חדשים.',
    podcastTitle: 'רשימת פרקים',
    podcastStoryTitle: 'רשימת פרקי סיפורים',
    podcastToolTipTitle: 'רשימת פרקי הפודקאסט',
    uploadAudio: 'העלה',
    aiAudio: 'אודיו בינה מלאכותית',
    emptyPodcast: 'טרם נרשם אודיו לפודקאסט, מוזיקה וסיפורים.',
    emptyStoriesPodcast: 'טרם נוספו סיפורים.',
    emptyCreatePodcast: 'אנא צור פודקאסט כדי להוסיף אודיו.',
    playPodcast: 'נגן את הפודקאסט, המוזיקה והסיפורים שנבחרו.',
    pausePodcast: 'עצור את הפודקאסט, המוזיקה והסיפורים שנבחרו.',
    selectPodcast: 'בחר את הפודקאסט, המוזיקה והסיפורים הללו.',
    downloadPodcast: 'הורד את האודיו הזה.',
    uploadAudioFile: 'העלה אודיו חדש והחלף את האודיו הנוכחי.',
    deleteConfirm: 'האם אתה בטוח שברצונך למחוק את האודיו הזה?',
    roomName: 'שם הפודקאסט',
    addGuestTitle: 'הוסף דובר אורח',
    showTime: 'זמן תצוגה',
    startTime: 'זמן התחלה',
    endTime: 'זמן סיום',
    erorMsgImg: 'אנא בחר תמונה חוקית.',
    failedMsgImg: 'טעינת התמונה נכשלה. אנא נסה שוב!',
    failedMsgUpload: 'העלאת תמונת הכריכה נכשלה!',
    btnCoverUpload: 'העלה כריכה',
    is_private: 'פרטי',
    to_attach: 'צרף קובץ',
    file_attached: 'קובץ (קבצים) מצורף',
    main_event: 'אירוע ראשי',
    event: 'אירועים',
    upload_pdf: 'העלה PDF',
    portrait: 'תמונה אנכית',
    landscape: 'תמונה אופקית',
    import_from_library: 'ייבא טקסט מספריית המדיה',
    question_answer_ai: 'שאלות/תשובות AI',
    take_maze: 'קח את מטא מבוך',
    training: 'אימון',
    select_transcribe_locale: 'בחר שפה לתמלול',
    transcribe_limit: 'אנא הזן את מספר דקות התמלול',
    not_complete: 'מידע השוק אינו מלא',
    complete: 'מידע השוק מלא',
    not_admin: 'נדרשת הרשאת מנהל לפרסום בשוק',
    no_course: 'אנא הזן כותרת ובחר תמונה להפעלת השוק',
    scorm_not_complete: 'אנא הזן כותרת ובחר תמונה להעלאת קובץ SCORM',
    not_found_maze: 'מטא מבוך לא נמצא',
    email_require: 'נדרשים דוא"ל',
    poll_required: 'נדרשים נתוני סקר',
    alert: 'התראה!',
    warning: 'אזהרה!',
    ok: 'אישור',
    cancel: 'בטל',
    done: 'בוצע',
    insert: 'הכנס',
    private: 'פרטי',
    public: 'ציבורי',
    no_connection: 'איבוד חיבור לאינטרנט',
    switch: 'החלף',
    share_screen: 'שיתוף מסך',
    stop_share_screen: 'עצור שיתוף מסך',
    share_screen_with_camera: 'שיתוף מסך עם מצלמה',
    stop_share_screen_with_camera: 'עצור שיתוף מסך עם מצלמה',
    camera_on: 'מצלמה דלוקה',
    camera_off: 'מצלמה כבויה',
    mic_on: 'הפעל מיקרופון',
    mic_off: 'כבה מיקרופון',
    fullscreen: 'מסך מלא',
    live_now: 'בשידור חי עכשיו',
    schedule_on: 'מתוזמן ל-',
    organisations: 'ארגונים',
    org_groups: 'קבוצות ארגון',
    specific_user: 'משתמש מסוים',
    gif: 'GIF',
    unavailable: 'לא זמין',
    yes: 'כן',
    no: 'לא',
    event_duration_message: 'מקסימום 300 דקות (5 שעות)',
    send_email: 'שלח הודעת דוא"ל',
    admin_only: 'רק למנהלים',
    join: 'הצטרף',
    leave: 'עזוב',
    share: 'שתף',
    share_text: 'אנא הקלד את כתובת האימייל של מי שברצונך לשתף איתו קובץ זה.',
    share_text_title: 'שתף PDF',
    share_text_title_txt: 'שתף טקסט',
    select_users: 'בחר משתמשים',
    delete: 'מחק',
    attachment_event: 'קבצים מצורפים לאירוע:',
    transcribe_limit: 'דקות תמלול',
    monthly_transcribe: 'מגבלת תמלול חודשית:',
    enable_ai: 'אפשר AI:',
    enable_maze: 'אפשר מטא מבוך:',
    media_service: 'שירות מדיה',
    allow_others: 'אפשר לאחרים לערוך',
    join_breakout_room: 'הצטרף לחדר מפוצל',
    bio: 'ביוגרפיה',
    linkedin: 'LinkedIn',
    select_org_report: 'אנא מצא ובחר ארגון ליצירת דוח.',
    org_image_not_found: 'תמונה לא נמצאה',
    insert_text: 'הכנס טקסט',
    insert_question_answer: 'שאלות/תשובות AI',
    modal_title2: 'גלריית טקסט',
    my_text_library: 'ספריית הטקסט שלי',
    ai: 'AI',
    public_text_library: 'ספריית טקסט ציבורית',
    organization_text_library: 'ספריית טקסט ארגונית',
    no_transcribed_text: 'לא נמצא טקסט מתומלל',
    public_text_not_found: 'לא נמצא טקסט מתומלל ציבורי',
    org_text_not_found: 'לא נמצא טקסט מתומלל ארגוני',
    org_video_not_found: 'וידאו לא נמצא',
    canva: 'עשה את זה ב-Canva',
    canva_open: 'לחץ כאן כדי לפתוח את עורך Canva.',
    pdf: 'PDF',
    txt: 'טקסט',
    human: 'פרימיום',
    shared_file: 'הקובץ שלך שותף בהצלחה.',
    error_shared_file: 'ישנה בעיה בשיתוף הקובץ. אנא נסה שוב.',
    publish: 'פרסם',
    maze_scenes: 'סצנות מטא מבוך',
    pexel_images: 'תמונות Pexel',
    group: 'קבוצה',
    group_name: 'שם הקבוצה',
    select_group: 'בחר קבוצה',
    search_maze: 'חפש מטא מבוך',
    hosts: 'מארחים',
    avg_score: 'אחוז הציון',
    maze_report: 'דוח מטא מבוך',
    maze_view: 'תצוגת מטא מבוך',
    title_maze: 'מטא מבוך',
    author: 'מחבר',
    match: 'התאמת מסלול',
    preview_mazeTitle: 'כותרת: ',
    other: 'אחר',
    total: 'סך הכל',
    report_course: 'קורס',
    report_courses: 'קורסים',
    report_event: 'אירוע',
    report_events: 'אירועים',
    report_maze: 'מאז',
    report_personalize_learning: 'למידה מותאמת אישית',
    report_live_assessment: 'הערכה חיה',
    report_live_assessments: 'הערכות חיות',
    report_skill_journey: 'מסע מיומנויות',
    skill_journey: 'מסע מיומנויות',
    skill_journeys: 'מסעות מיומנויות',
    date: 'תאריך: ',
    search_people: 'חפש אנשים',
    passed: 'עבר',
    failed: 'נכשל',
    item: 'פריט',
    type: 'סוג',
    minimum_pass_score: 'ציון מינימלי לעבור',
    resources_count: 'מספר משאבים',
    back: 'חזור',
    resources: 'משאבים',
    time_spent: 'זמן שהושקע (דקות)',
    detail: 'פרט',
    watched_time_mins: 'זמן צפייה (דקות)',
    personalize_learning: 'למידה מותאמת אישית',
    result: 'תוצאה',
    assessment_title: 'כותרת',
    marketPlace_graph: 'גרף שוק',
    attachments: 'קבצים מצורפים נוספים',
    new_scorm_course: 'העלה קורס SCORM חדש',
    upload_scorm_course: 'העלה קורס SCORM',
    new_maze: 'צור מטא מבוך חדש',
    new_skill_journey: 'צור מסע מיומנויות',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'מסע מיומנויות',
    new_discussion_room: 'צור פודקאסט חדש',
    title: 'מה תרצה לעשות היום?',
    build_course: 'בנה את הקורס שלי',
    live_broadcast: 'שידור חי',
    invite_users: 'הזמן משתמשים לארגון שלי',
    build_voice_over: 'צור קריינות',
    view_reports: 'הצג דוחות',
    upload_media: 'העלה מדיה או עבודה ושתף',
    main_menu: 'תפריט ראשי',
    get_started: 'התחל',
    search_group: 'חפש קבוצת ארגון',
    ai_course: 'קורס בינה מלאכותית',
    search_user: 'חפש שם חברה',
    no_maze: 'אין מטא מבוך זמינים כרגע.',
    conference_event_title: 'כנסים',
    conference_event_subTitle: 'כנסים שהסתיימו',
    conference_event: 'אין כנסים זמינים כרגע.',
    no_skill: 'אין מסעות מיומנויות זמינים.',
    no_podcast: 'אין פודקאסטים זמינים.',
    maze_channel: 'מטא מבוך',
    past_live_assessment: 'הערכות חיות קודמות',
    no_live_assessment: 'אין הערכות חיות זמינות.',
    enrolled_courses: 'קורסים',
    my_video_channel: 'ערוצי הווידאו שלי',
    enrolled_liveEvents: 'אירועים חיים',
    sharebot: 'Sharebot',
    selected_language: 'שפה נבחרה',
    shareSphere_game: 'משחק ShareSphere',
    maze: 'מטא מבוך',
    skill: 'מסע מיומנויות',
    channel: 'ערוץ',
    order: 'הזמנה',
    is_record: 'הקלטה',
    no_maze_found: 'לא נמצא מטא מבוך.',
    maze_self_limit_reached: 'הגעת למגבלת ההערכה העצמית של מטא מבוך.',
    metamaze_two_times: 'כבר ביצעת את ה-מטא מבוך הזה פעמיים.',
    metamaze_two_times_no_result:
      'כבר ביצעת את ה-מטא מבוך הזה פעמיים. התוצאה שלך לא תירשם לאחר הפעם השנייה.',
    scorm_zip: 'רוכסן של Scorm',
    pass_score: 'ציון מינימלי לעבור',
    organization: 'אנא בחר ארגון',
    pass_score_mark: 'אנא הזן ניקוד בין 1 ל-100',
    maze_cloning_success: 'ה-מטא מבוך "<0/>" שוכפל בהצלחה!',
    create_certificate: 'צור תעודה',
    create_badge: 'צור תג',
    certificate_added: 'התעודה נוספה.',
    badge_added: 'התיג נוספה.',
    certificate_warning: 'לא ניתן לערוך את התעודה/תג לאחר הפרסום!',
    created_course_plan: 'ערוך ופרסם את הקורס והאירועים החיים שיצרת',
    market_place_space: 'שוק',
    select_course_language: 'בחר שפה (אופציונלי)',
    select_language: 'בחר שפה',
    file_upload: 'העלאת קובץ',
    text: 'כתוב טקסט כאן…',
    attempts_count: 'מספר ניסיונות שהמשתמש יכול לנסות שוב',
    no_of_people_placeholder: 'מספר אנשים',
    back_to_maze: 'חזור לתרחיש מטא מבוך',
    edit_maze: 'ערוך מטא מבוך',
    wait: 'אנא המתן...',
    retry: 'נסה שוב',
    publish_scorm_course: 'פרסם קורס SCORM',
    publish_maze: 'פרסם מטא מבוך',
    import: 'ייבא אלמנטים',
    answer_correct: 'בחר את התשובה הנכונה',
    author_name: `אנא הזן שם המחבר`,
    select_category: 'אנא בחר קטגוריה',
    course_outline: 'אנא הזן תוכן הקורס',
    course_obj: 'אנא הזן את יעדי הקורס',
    course_description: 'אנא הזן תיאור הקורס',
    maze_outline: 'אנא הזן תוכן המבוך',
    maze_obj: 'אנא הזן את יעדי המבוך',
    maze_description: 'אנא הזן תיאור המבוך',
    lessons: 'אנא הזן את מספר השיעורים',
    user_email_require: `נדרש דוא"ל משתמש`,
    team_size: `נדרש גודל צוות`,
    enter_price: 'אנא הזן מחיר (5 או יותר)',
    input_title_maze: 'אנא הזן כותרת המבוך',
    trainer_bio: 'אנא הזן ביוגרפיה של המדריך',
    trainer_linkedin: 'אנא הזן את LinkedIn של המדריך',
    error_video: 'אנא הזן את מספר הסרטונים',
    input_video_link: 'אנא הזן קישור לסרטון',
    number_of_video: 'מספר סרטונים',
    number_of_lessions: 'מספר שיעורים',
    no_of_people_in_conference: 'כמה אנשים בכנס?',
    transcribe_settings: 'הגדרות תמלול',
    transcribe: 'תמלול',
    cloning_maze: 'שכפול מטא מבוך...',
    id_number: 'מספר זיהוי',
    timezone: 'אזור זמן',
    edit_maze: 'ערוך',
    delete_maze: 'מחק',
    view_maze: 'הצג',
    create_metamaze: 'צור מטא מבוך',
    metamaze_scenario: 'תרחיש מטא מבוך',
    publish_metamaze: 'הגדרות פרסום',
    search_result: 'תוצאות חיפוש:',
    search_for: 'חפש את',
    search_no_result: '- לא נמצאו תוצאות!',
    channel_no_available: 'אין ערוץ זמין!',
    this_card: 'זו כרטיסייה',
    course_no_available: 'אין קורסים זמינים!',
    exit_fullscreen: 'צא ממסך מלא',
    bg_image: 'תמונת רקע',
    introduction: 'הקדמה',
    summary: 'סיכום',
    generate_introduction: 'צור הקדמה',
    generate_summary: 'צור סיכום',
    bullet_points: 'נקודות תבליט',
    title_simulation: 'אנא הזן שם סימולציה',
    view_generated_images: 'הצג תמונות שנוצרו',
    image_transparency: 'שקיפות תמונה',
    template_bg_color: 'צבע רקע תבנית',
    select_template_layout: 'בחר פריסת תבנית',
    reload_template: '(טען מחדש תבניות)',
    are_you_sure_want_close: 'האם אתה בטוח שברצונך לסגור?',
    all_your_changes_will_be_lost: 'כל השינויים יאבדו.',
    please_checked_before_generated_video:
      'אנא אמת שכל התנאים נבדקו לפני יצירת וידאו.',
    voice_must_be_selected: 'יש לבחור קול',
    avatar_must_be_selected: 'יש לבחור דמות (avatar).',
    maximum_five_slides_try_again:
      'שגיאה בהוצאת תמונות מהקובץ שלך. וודא שיש עד 5 שקופיות עם הערות בכל שקופית. נסה שוב!',
    back_to_upload: 'חזרה להעלאה',
    uploading_file_to_server: 'מעלה את הקובץ שלך לשרת',
    extracting_images_from_your_file: 'מיוצאות תמונות מהקובץ שלך',
    upload_your_ppt_or_drag: 'העלה את קובץ המצגת (.PPTX) או גרור אותו לכאן.',
    maximum_five_slides_error:
      'ודא שקובץ PowerPoint מכיל עד 5 שקופיות ויש הערות בכל אחת. אחרת תתרחש שגיאה.',
    number_of_questions_generated: 'מספר השאלות ליצירה',
    quiz_page_this_cannot_be_done:
      'האם אתה בטוח שברצונך להוסיף את החידון לעמוד זה? אין אפשרות לבטל.',
    confirm_selection: 'אשר בחירה',
    select_quiz_page: 'בחר עמוד חידון',
    lesson_do_you_want_add_this_quiz:
      'באיזה חלק מהשיעור ברצונך להוסיף את החידון?',
    beginning_of_lesson: 'בתחילת השיעור',
    end_of_lesson: 'בסוף השיעור',
    currently_active_page: 'עמוד פעיל נוכחי',
    finish: 'סיום',
    upload_selection_file: 'העלה קובץ מדור',
    general_quiz: 'חידון כללי',
    manage_sequence: 'נהל רצף',
    save_sequence: 'שמור רצף',
    new: 'חדש',
    in_progress: 'בהתקדמות',
    recommended_course: 'קורס מומלץ',
    up_coming: 'בקרוב',
    past_live: 'חי עבר',
    input_your_channel_name: 'אנא הזן את שם הערוץ שלך!',
    organization_place: 'שוק הארגון',
    marketplace_report: 'דוח Marketplace',
    story_writing: 'כתיבת סיפור',
    Ai_quiz: 'חידון בינה מלאכותית',
    generate_quiz: 'צור חידון',
    create_story: 'צור סיפור',
    change_layout_page: 'אתה עומד לשנות את פריסת העמוד הזה.',
    change_layout_message:
      'שים לב, רק הטקסט, התמונות, הרקע והלוגו יישמרו. שאר האלמנטים יוסרו.',
    reviews: 'ביקורות',
    tab_attachments: 'מצורפים',
    zoom_in: 'התקרבות',
    zoom_out: 'התרחקות',
    zoom_reset: 'איפוס זום',
    no_attachment: 'אין מצורפים.',
    select_upload_simulation: 'אנא בחר/העלה סימולציה.',
    quiz_updated_successfully: 'החידון עודכן בהצלחה!',
    quizes: 'חידונים',
    trivia: 'חידת טריוויה',
    closing: 'נסגור...',
    products: 'מוצרים',
    ask_questions: 'שאל כאן שאלה...',
    course_information: 'מידע על הקורס',
    course_assistance: 'סיוע ליצירת קורס',
    go_back: 'חזור',
    ai_generate_content_progress: 'התקדמות יצירת תוכן AI',
    view_generate_content: 'הצג תוכן שנוצר',
    generate_error: 'שגיאה ביצירה!',
    confirm_creating_course: 'האם לאשר יצירת הקורס באמצעות התוכן הזה?',
    generate_content_automatically:
      'זה יוסיף את כל התוכן שנוצר כשיעורים ודפים בקורס שלך אוטומטית.',
    quiz_created_successfully: 'החידון נוצר בהצלחה!',
    create_quiz: 'צור חידון',
    quiz_setting: 'הגדרות חידון',
    please_fill_quiz_setting: '* אנא מלא את כל השדות בהגדרת החידון.',
    question_list: 'רשימת שאלות',
    add_quiz_to_page: 'הוסף חידון לעמוד',
    form_create_question: 'טופס יצירת שאלה',
    user_information_updated: 'פרטי המשתמש עודכנו!',
    your_stripe_activete_to_continue:
      'חשבון Stripe שלך אינו פעיל. אנא התחבר או הפעל אותו כדי להמשיך.',
    connect_tripe: 'התחבר ל-Stripe',
    certificate_sent_sucessfully: 'התעודה נשלחה בהצלחה לדוא"ל שלך.',
    error_try_again: 'שגיאה. נסה שוב!',
    error_delete_channel: 'שגיאה במחיקת הערוץ.',
    error_update_sub: 'שגיאה בעדכון המנוי.',
    end_time_cannot_start: 'שעת הסיום לא יכולה להיות לפני תחילת הפעילות.',
    start_date_time_interval: 'נדרשים תאריך ושעת תחילת פעילות!',
    podcast_updated_successful: 'הפודקאסט עודכן בהצלחה.',
    podcast_created_successful: 'הפודקאסט נוצר בהצלחה.',
    podcast_published_successful: 'הפודקאסט פורסם בהצלחה.',
    podcast_cover_updated: 'כיסוי הפודקאסט עודכן',
    new_podcast_details: 'פודקאסט חדש ייווצר בפודקאסט הנוכחי עם פרטים חדשים.',
    current_update_podcast: 'עדכן את הפודקאסט הנוכחי, המוסיקה & פרטי סיפורים.',
    create_new_podcast: 'צור פודקאסט חדש',
    publish_podcast_public_view: 'פרסם פודקאסט לצפייה ציבורית.',
    only_allowed_twenty_five_email: 'מותר עד 25 מיילים בלבד.',
    only_allowed_five_email: 'מותר עד 5 מיילים בלבד.',
    cover_is_required: 'נדרש כיסוי.',
    topic_is_required: 'נדרש נושא.',
    delete_schedule: 'מחק לוח זמנים',
    make_as_coaching: 'הגדר כהתמחות אימון',
    manage_category: 'נהל קטגוריה',
    threshold: 'סף',
    threshold_popup: 'ערך סף באחוזים (%), הערך שאחריו ההמלצה מופעלת לקטגוריה.',
    list_of_catagory: 'רשימת קטגוריות',
    category_name: 'שם קטגוריה',
    category_threshold: 'סף קטגוריה',
    play_game: 'שחק משחק',
    switching_organization: 'מעבר לארגון...',
    coaching_session: 'מפגש אימון',
    required_channel_id: 'נדרש זיהוי ערוץ!',
    error_occured_try_again: 'אירעה שגיאה. נסה שוב!',
    please_complete_marketplace_form: 'אנא השלם את טופס Marketplace!',
    upload_file_corrupt: 'הקובץ שהועלה פגום.',
    course_not_published: 'הקורס עדיין לא פורסם!',
    error_request: 'שגיאה בבקשה. אנא נסה שוב!',
    skill_request: 'אנא השלם את שדות הכישורים!',
    error_occured: 'אירעה שגיאה. נסה שוב!',
    show_time: 'הצג שעה',
    start_time: 'שעת התחלה',
    end_time: 'שעת סיום',
    room_name: 'שם פודקאסט',
    add_guest_speaker: 'הוסף מרצה אורח',
    cover_picture: 'תמונת כיסוי',
    guest_speaker: 'מרצה אורח',
    see_more: 'ראה עוד',
    see_less: 'ראה פחות',
    background: 'רקע',
    icon: 'אייקון',
    icon_size: 'גודל אייקון',
    icon_color: 'צבע אייקון',
    only_text: 'טקסט בלבד',
    change_bg: 'שנה צבע רקע',
    bg_color: 'צבע רקע',
    font_size: 'גודל גופן',
    normal: 'רגיל',
    change_color: 'שנה צבע טקסט',
    slant_text: 'טקסט נטוי',
    text_radius: 'רדיוס טקסט',
    vertical_align: 'יישור אנכי',
    horizontal_align: 'יישור אופקי',
    change_icon_color: 'שנה צבע אייקון',
    upload_icon: 'העלה אייקון',
    upload_signature: 'העלה חתימה',
    add_another_sign: 'הוסף חתימה נוספת',
    name_badges: 'שם תג',
    should_less_150: 'עד 150 תווים',
    your_badge: 'התג שלך',
    do_you_want_delete_badge: 'האם ברצונך למחוק תג זה?',
    do_you_want_delete_cert: 'האם ברצונך למחוק הסמכה זו?',
    upload_logo: 'העלה לוגו',
    name_of_cert: 'שם הסמכה',
    upload_cert: 'עדכן הסמכה',
    your_cert: 'ההסמכה שלך',
    translate_to: 'תרגם ל־',
    select_file_attach: 'בחר קובץ לצירוף',
    certificate: 'הסמכה',
    badge: 'תג',
    publish_options: 'אפשרויות פרסום',
    publish_skills_journey: 'פרסום מסלול מיומנויות',
    videos: 'סרטונים',
    generate_ai_video:
      'תהליך יצירת סרטון AI עלול לקחת זמן. תקבל הודעה באימייל כשיסתיים.',
    trainer_information: 'מידע על המדריך',
    promotional_video_link: 'קישור לסרטון פרסומי',
    please_select: 'אנא בחר',
    image_name: 'שם תמונה:',
    image_size: 'גודל תמונה:',
    charecters_fifteen_less: 'עד 15 תווים',
    leadership: 'מנהיגות',
    text_arc: 'קשת טקסט',
    vertical: 'אנכי',
    horizontal: 'אופקי',
    badge_history: 'היסטוריית תגיות',
    templates: 'תבניות',
    sign: 'חתימה',
    logo: 'לוגו',
    certificate_history: 'היסטוריית הסמכות',
    please_wait: 'אנא המתן…',
    information: 'מידע',
    support_five_thousand_live_event: 'תומך בעד 5000 משתתפים באירוע חי',
    support_ten_live_event: 'תומך בעד 10 משתתפים חיים',
    we_will_back_participant: 'נחזור עם אירוע עם גישה לקהל משתתפים.',
    course_objectives: 'יעדי הקורס',
    course_outlines: 'תוכני הקורס',
    price_dollor: 'מחיר (USD)',
    not_completed: 'לא הושלם',
    enable_marketplace: 'הפעל שוק',
    enable_course_ai: 'הפעל יצירת קורס עם בינה מלאכותית',
    enable_report_to_admin: 'הפעל דיווח למנהל',
    enable_white_label: 'הפעל White Label',
    enable_eleven_labs_for_maze_play: 'הפעל ElevenLabs להפעלת מבוך',
    enable_eleven_labs_for_maze_play_cloned: 'הפעל ElevenLabs לקולות משוכפלים',
    simulation_quiz: 'חידון סימולציה',
    bg_color_setting: 'הגדרת צבע רקע',
    color_preview: 'תצוגה מקדימה של צבע',
    choose_new_color: 'בחר צבע חדש',
    remove_color: 'הסר צבע',
    apply_color: 'החל צבע',
    elemeent_in_a_sceenario_page:
      'לא ניתן להוסיף יותר רכיבים לעמוד תרחיש. נסה עמודים אחרים או הסר את רכיב האתגר.',
    no_data_found: 'לא נמצאו נתונים',
    references: 'הפניות',
    open_file: 'פתח קובץ',
    showing_result: 'הצגת תוצאה:',
    fiften_day_free_trail: '15 ימים ניסיון חינם',
    your_browser_does_not_support: 'הדפדפן שלך לא תומך באודיו.',
    podcast_desc: 'תיאור הפודקאסט',
    input_podcast_desc: 'הזן תיאור לפודקאסט',
    podcast_obj: 'מטרות הפודקאסט',
    input_podcast_obj: 'הזן מטרות לפודקאסט',
    podcast_outline: 'סקירה כללית של הפודקאסט',
    input_podcast_outline: 'הזן סקירה כללית של הפודקאסט',
    add_file: 'הוסף קובץ',
    generate_podcast_audio: 'צור אודיו לפודקאסט',
    generate_uploaded_file_input_parameter: 'צור לפי תוכן הקבצים שהועלו.',
    go_backe_generation_state: 'חזור למצב יצירת תוכן',
    create_ai_powered_podcast: 'צור פודקאסט עם בינה מלאכותית',
    generate_voice_for_all_podcast: 'צור קול לכל הפרקים',
    create_podcast_episode: 'צור פרק בפודקאסט',
    voice_name: 'שם קול',
    input_custom_name: 'הכנס שם מותאם אישית!',
    enter_custom_name: 'הזן שם מותאם אישית לקול',
    upload_complete: 'ההעלאה הושלמה',
    uploading_in_progress: 'העלאה מתבצעת...',
    podcast_stream_content: 'תוכן הסדרה של הפודקאסט',
    upload_podcast_cover: 'העלה תמונת כיסוי לפודקאסט!',
    enter_podcast_name: 'הזן שם לפודקאסט!',
    podcast_topic: 'נושא הפודקאסט',
    enter_podcast_topic: 'הזן נושא לפודקאסט!',
    enter_podcast_desc: 'הזן תיאור לפודקאסט!',
    number_of_speaker: 'מספר דוברים',
    select_the_number_of_speaker: 'בחר מספר דוברים!',
    number_of_episode: 'מספר פרקים',
    input_number_of_episode: 'הזן מספר פרקים!',
    podcast_length: 'אורך הפודקאסט',
    select_the_podcast_length: 'בחר אורך לפודקאסט!',
    short_podcast: 'קצר (5–10 דקות)',
    medium_podcast: 'בינוני (15–18 דקות)',
    long_podcast: 'ארוך (18+ דקות)',
    name_of_host: 'שם המנחה',
    enter_host_name: 'הזן שם מנחה!',
    guest_name: 'שמות אורחים',
    enter_guest_name: 'הזן שמות אורחים!',
    choose_speaker_tone: 'בחר טון דיבור',
    enter_speaker_tone: 'בחר טון דיבור לפודקאסט!',
    informal: 'בלתי פורמלי',
    formal: 'פורמלי',
    serious: 'רציני',
    light_humor: 'הומור קל',
    casual: 'קליל',
    select_content_source: 'בחר מקור תוכן',
    from_internet: 'מהאינטרנט',
    upload_pdf_internet: 'העלה PDF או עמוד תוכן',
    note: 'הערה:',
    podcast_content_will_be_automatically_generated:
      'התוכן של הפודקאסט יווצר אוטומטית ממקורות אינטרנט מהימנים.',
    upload_or_select_file: 'העלה או בחר קובץ!',
    podcast_eposode_title: 'כותרת פרק הפודקאסט',
    enter_podcast_title: 'הזן כותרת פרק!',
    podcast_episode_des: 'תיאור פרק הפודקאסט',
    enter_podcast_episode_des: 'הזן תיאור פרק!',
    voice: 'קול',
    music: 'מוזיקה',
    select_music: 'בחר מוזיקה',
    play_the_music: 'נגן מוזיקה',
    stop_the_music: 'הפסק מוזיקה',
    context: 'תוכן',
    generate_audio_content_selected_voice: 'צור אודיו עם הקול שנבחר.',
    required_field_before_submitting:
      'נא למלא את כל השדות החיוניים לפני שליחה.',
    regenerate_voice: 'צור קול מחדש',
    generate_voice: 'צור קול',
    your_browser_does_not_suppot: 'הדפדפן שלך לא תומך באודיו.',
    are_sure_leave_podcast: 'האם אתה בטוח שברצונך לעזוב את הפודקאסט?',
    broadcast_ongoing: 'ההשידור בעיצומו. האם אתה בטוח שברצונך לעזוב את הדף?',
    brodcaster_unavailable: 'המנחה אינו זמין.',
    setting_calender_for_booking: 'הגדרת לוח שנה להזמנה',
    add_calender: 'הוסף לוח שנה',
    waiting_join_host: 'ממתין להצטרפות המנחה...',
    no_reviews_found: 'לא נמצאו ביקורות',
    rated_already: 'כבר דירגת את השידור החי הזה',
    downlink_png: 'הורד כ-PNG',
    downlink_jpg: 'הורד כ-JPG',
    donwload_file_format: 'בחר פורמט קובץ להורדה.',
    crashed_event: 'האירוע קרס. יש ליצור אירוע חדש. מתנצלים על אי הנוחות.',
    prompt: 'הנחיה:',
    generated_image: '🚀 תמונה נוצרה... אנא המתן.',
    download_add: 'הורד הכול',
    setting_generator: 'הגדרות יוצר',
    enter_image_prompt: 'הזן נושא לתמונה',
    image_prompt: 'נושא התמונה',
    negative_prompt: 'תוכן לא רצוי',
    negative_image_prompt: 'נושא תמונה לא רצוי',
    number_output: 'מספר תמונות ליצירה',
    enter_number_output: 'הזן מספר תמונות',
    image_style: 'סגנון תמונה',
    output_format: 'פורמט פלט',
    seeds: 'זרעים',
    enter_seeds: 'הזן זרעים',
    performance_mode: 'מצב ביצועים',
    quality: 'איכות',
    speed: 'מהירות',
    balanced: 'מאוזן',
    guidance_scale: 'מדד הנחיה',
    enter_guidance: 'הזן ערך הנחיה',
    select_image: 'בחר תמונה.',
    image_prmt: 'נושא התמונה',
    generate_image_list_empty: 'אין תמונות זמינות.',
    knowledge_center_tooltrip_des:
      'קבל תשובות מדויקות ורלוונטיות מבוססות על מידע מהאינטרנט. הבינה המלאכותית משתמשת בתוכן מהאינטרנט.',
    contexts: 'הקשרים',
    ai_processing_video_sharebot:
      'עיבוד הבינה המלאכותית ל-Sharebot Video תקף ל-24 שעות.',
    remove_sharebot_video:
      'כדי להסיר את סרטון ה-Sharebot, הסר את קטע הקול או הסרטון.',
    remove_sharebot_video_audio:
      'הסרת קטע הקול תסיר את קישור Sharebot מהווידאו/אודיו, אך התוכן יישאר בספריה.',
    monthly_live_stream: 'פנה אלינו לשינוי מגבלות שידור חי חודשיות.',
    monthly_transcribe_limit: 'פנה אלינו לשינוי מגבלות תמלול חודשיות.',
    must_be_one_to_three_hundred: 'הערך חייב להיות בין 1 ל-300 דקות.',
    all_field_required: 'כל השדות הם חובה.',
    duration_minute: 'משך (מקסימום 300 דקות)',
    gender: 'מין',
    select_gender: 'בחר מין',
    accent: 'מבטא',
    select_accent: 'בחר מבטא',
    create_voice: 'צור קול',
    enter_voice_name: 'הזן שם קול',
    select_voice_gender: 'בחר מין הקול',
    upload_voice: 'העלה את קולך',
    upload_voice_mp_three: 'העלה את קולך (.mp3)',
    cloned_voice: 'קול משוכפל',
    voice_type: 'סוג קול',
    select_voice_type: 'בחר סוג קול',
    sharelook_stand: 'סטנדרטי',
    sharelook_premium: 'פרימיום',
    sharelook_custum_voice: 'מותאם אישית (קול משוכפל)',
    create_auto_flow: 'צור זרימה אוטומטית',
    how_many_layers: 'כמה שכבות',
    verify_selection: 'אמת בחירה',
    uploaded_successful: 'הקובץ הועלה בהצלחה',
    upload_failed: 'ההעלאה נכשלה',
    upload_only_five_mb: 'העלה קבצים (PDF, עד 5 קבצים)',
    docs_from_org_library: 'מסמכים מספריית הארגון',
    failed_maze_generate: 'יצירת מבוך נכשלה. נסה שוב.',
    generate_metamaze: 'יוצר מטא מבוך...',
    metamaze_being_generated:
      'מטא מבוך נוצר. תקבל הודעת דואר אלקטרוני כשהוא מוכן.',
    metamaze_generate_successfully: 'מטא מבוך נוצר בהצלחה!',
    metamaze_with_proceed: 'עכשיו תוכל להמשיך עם מטא מבוך.',
    ai_metamaze_generate: 'מטא מבוך שנוצר על ידי AI',
    what_kind_maze_create: 'איזה סוג מבוך ברצונך ליצור?',
    manual_metamaze_creation: 'יצירת מטא מבוך ידנית',
    manually_maze_customizing_scnario: 'התאם תרחישים ואפשרויות ידנית',
    maze_ai_generated: 'מבוך שנוצר אוטומטית על ידי AI',
    unmark_deadend: 'בטל סימון סיום',
    mark_deadend: 'סמן כסיום',
    select_multiple_image_for_scenario: 'בחר מספר תמונות לתרחיש זה.',
    select_your_image: 'תמונה שנבחרה',
    click_to_preview: 'לחץ לתצוגה מקדימה',
    are_you_sure_delete_image: 'האם אתה בטוח שברצונך למחוק תמונה זו?',
    select_image_from_library: 'בחר תמונה מספריית המדיה',
    uploading_video: 'טוען וידאו...',
    tree_node_type: 'סוג צומת עץ',
    correct_option_scenario: 'אפשרות/תרחיש נכון',
    incorrect_option: 'אפשרות שגויה',
    option_scenario_without_text: 'אפשרות/תרחיש ללא טקסט',
    dead_end: 'סוף דרך (סימון אדום)',
    correct_path: 'נתיב נכון',
    incorrect_path_not_selected_correct_option_path:
      'נתיב שגוי / לא נבחרה האפשרות הנכונה',
    double_click_on_tree_node: 'לחץ פעמיים על הצומת כדי לראות את התרחיש הקשור.',
    add_scenario: 'הוסף תרחיש',
    add_option: 'הוסף אפשרות',
    an_error_occured: 'אירעה שגיאה:',
    download_summary: 'הורד סיכום',
    step_wise_analysis: 'ניתוח שלב אחר שלב',
    step: 'שלב',
    upload_csv_file: 'העלה קובץ CSV',
    download_template_to_import: 'הורד תבנית לייבוא',
    please_input_email: 'הזן אימייל',
    email_at_least_three_characters: 'האימייל חייב להכיל לפחות 3 תווים',
    email_cannot_be_empty: 'האימייל לא יכול להיות ריק',
    input_email_in_new_line: 'הכנס כל אימייל בשורה חדשה',
    role: 'תפקיד',
    select_role: 'בחר תפקיד',
    select_group: 'בחר קבוצה',
    identification_number: 'מספר זיהוי (אופציונלי)',
    add_identification_number: 'הוסף מספר זיהוי',
    pie_chart_of_all_categories: 'תרשים עוגה של כל הקטגוריות ב-Sharelook',
    total_sharesphere_question_answered_by_users:
      'סך כל שאלות ShareSphere שנענו בהצלחה/לא בהצלחה על ידי משתמשים',
    voice_style_over_the_text:
      'החל סגנונות קול שונים על הטקסט. Lorem Ipsum הוא טקסט דמה בתעשיית ההדפסה מאז המאה ה-16.',
    input_your_question: 'הקלד את שאלתך!',
    make_me_sales_manager: 'לדוגמה - הפוך אותי למנהל מכירות',
    enter_the_number_relevant_document: 'הזן את מספר המסמכים הרלוונטיים',
    please_wait_loading_result: 'אנא המתן, טוען תוצאות...',
    no_result_found: 'לא נמצאו תוצאות. נסה לשאול בצורה שונה.',
    browser_doesnot_support_iframes: 'הדפדפן שלך אינו תומך ב-iframes',
    total_duration: 'משך כולל',
    number_of_messages: 'מספר הודעות',
    search_result: 'תוצאות חיפוש',
    count_result: '(1244 תוצאות)',
    your_other_interests: 'תחומי עניין נוספים שלך',
    your_total_score: 'הציון הכולל שלך',
    add_a_question: '+ הוסף שאלה',
    travia_question_empty: 'אין שאלות טריוויה',
    video_generation_is_on_queue: 'הווידאו שלך בתור!',
    checking_video_status: 'בודק את מצב הווידאו...',
    total_quizzes: 'סך כל חידונים',
    number_of_votes: 'מספר הצבעות',
    total_events: 'סך כל אירועים',
    number_of_rates: 'מספר דירוגים',
    number_of_likes: 'מספר לייקים',
    all_courses: 'כל הקורסים',
    total_questions: 'סך כל השאלות',
    no_skill_journey: 'אין מסלול מיומנויות זמין!',
    search_no_results: '- ללא תוצאות!',
    no_image_generated: 'טרם נוצרה תמונה!',
    all_topic_in_this_lesson:
      'פעולה זו תמחק את כל הנושאים מהשיעור. פעולה זו אינה ניתנת לביטול.',
    content_has_been_generated: 'תוכן כבר נוצר לנושא זה.',
    update_course_template: 'עדכן תבנית קורס',
    add_course_template: 'הוסף תבנית קורס',
    create_course_now: 'צור קורס עכשיו',
    preview_course: 'תצוגה מקדימה של הקורס',
    layout: 'פריסה',
    import_from_youtube: 'ייבא מ-YouTube',
    my_media_library: 'ספריית המדיה שלי',
    bg_added: 'הרקע נוסף',
    add_bg: 'הוסף רקע',
    booked_schedule: 'לוח זמנים שהוזמן',
    add_schedule: 'הוסף לוח זמנים',
    are_you_delete_schedule: 'האם אתה בטוח שברצונך למחוק לוח זמנים זה?',
    add_task: 'הוסף משימה',
    update_calender: 'עדכן לוח שנה',
    manage_cookies: 'ניהול עוגיות',
    cookie_banner_text:
      'אנו משתמשים בעוגיות כדי לשפר את חוויית הגלישה שלך, לנתח תנועת האתר ולהתאים תוכן אישית. פרטיותך חשובה לנו.',
    accept_all_cookies: 'קבל את כל העוגיות',
    reject_all: 'דחה הכל',
    customize: 'התאמה אישית',
    cookie_preferences_title: 'העדפות עוגיות והגדרות פרטיות',
    privacy_subtitle:
      'הפרטיות שלך חשובה לנו. בחר את סוגי העוגיות שאתה מרגיש בנוח איתם. ניתן לשנות הגדרות אלה בכל עת.',
    save_choices: 'שמור את הבחירות שלי',
    strictly_necessary: 'הכרחי לחלוטין',
    strictly_necessary_desc:
      'העוגיות האלה חיוניות כדי שהאתר יעבוד כראוי. הן מתירות פונקציות בסיסיות כמו ניווט בדפים, שליחת טפסים וגישה לאזורים מאובטחים. האתר לא יוכל לתפקד כראוי בלעדיהן.',
    analytics_performance: 'אנליטיקה וביצועים',
    analytics_performance_desc:
      'העוגיות האלה עוזרות לנו להבין כיצד מבקרים מתקשרים עם האתר שלנו על-ידי איסוף ודיווח מידע באופן אנונימי. זה עוזר לנו לשפר את ביצועי האתר וחוויית המשתמש.',
    advertising_marketing: 'פרסום ושיווק',
    advertising_marketing_desc:
      'העוגיות האלו משמשות להפוך מסרי פרסום לרלוונטיים יותר עבורך. הן מונעות מאותו מודעה להופיע שוב ושוב ודואגות שהפרסומות יוצגו בצורה ראויה למפרסמים.',
    tracking_social: 'מעקב ורשתות חברתיות',
    tracking_social_desc:
      'העוגיות האלה מאפשרות פונקציונליות מתקדמת והתאמה אישית, כגון פונקציות של מדיה חברתית ותוכן מותאם. הן עשויות להיות מוגדרות על-ידי מאיתנו או על-ידי ספקים צד שלישי.',
    functional: 'פונקציונאלי',
    functional_desc:
      'העוגיות האלו מאפשרות פונקציונליות מתקדמת כמו תמיכה בצ’אט, עזרה חיה ותכונות אינטראקטיביות אחרות שמטרתן לשפר את החוויה שלך באתר שלנו.',
    your_rights: 'הזכויות שלך:',
    rights_description:
      'אתה יכול למשוך את הסכמתך בכל עת, לגשת לנתונים שלך או לבקש את מחיקתם בכל עת.',
    withdraw_consent: 'משוך את כל ההסכמה',

    how_many_options: 'כמה אפשרויות',
    add_content: 'הוסף תוכן',
    downloads_center: 'מרכז ההורדות',
    sharelook_help_center: 'מרכז העזרה של Sharelook',
    channel_outline: 'קווי מתאר של ערוץ',
    channel_objectives: 'מטרות הערוץ',
    no_sop_available: 'אין רשימת SOP זמינה.',
    generate_world_summary: 'צור תרחיש',
    world_scenario: 'תרחיש מהעולם האמיתי',
    drag_icon_hint: 'רמז: גרור את האייקון על הקנבס כדי למקם אותו',
    drag_text_hint: 'רמז: גרור את הטקסט על הקנבס כדי למקם אותו',
    edit_badge: 'ערוך תּוֹעָר',
    create_new_badge: 'תּוֹעָר חדש',
    select_video_preview: 'בחר סרטון לתצוגה מקדימה',
    certificate_title_required: 'נדרש כותרת תעודה',
    discard_changes: 'בטל שינויים',
    edit_certificate: 'ערוך תעודה',
    add_another_logo: 'הוסף לוגו נוסף',
    optional: 'אופציונלי',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'צור משימה חדשה',
    quest_filter_title: 'משימה',
    sharelook_assistance: 'סיוע Sharelook',
    upload_scorm_zip: 'העלה קובץ SCORM ZIP',
    only_letters_numbers_space_dot_allowed:
      'מותר רק אותיות, מספרים, רווחים ונקודות!',
    video_playing: 'ניגון',
    course_price_message:
      '*הקורס יפורסם רק למשתמשים בארגון ולא ניתן למכירה מחדש בשוק.',
    lesson_must_be_positive: 'מספר השיעורים חייב להיות גדול מ־1',
    btn_proceed: 'המשך',
    rule_select_music: 'אנא בחר מוזיקה',
    course_info: 'מידע על הקורס',
    content_selection: 'בחירת תוכן',
    course_content_source: 'מקור תוכן הקורס',
    choose_how_to_source: 'בחר כיצד לאסוף תוכן עבור הקורס הזה:',
    automatic_selection: 'בחירה אוטומטית',
    system_will_automatically_select_relavant_documents:
      'המערכת תבחר אוטומטית מסמכים רלוונטיים מהספרייה שלך',
    manual_selection: 'בחירה ידנית',
    choose_specific_documents_from_your_library:
      'בחר מסמכים ספציפיים מהספרייה שלך',
    upload_files: 'העלה קבצים',
    upload_new_documents:
      'העלה מסמכים חדשים (PDF, DOC, DOCX, PPT, PPTX, TXT) - מקסימום 5 קבצים',
    file: 'קובץ',
    ready_to_upload: 'מוכן להעלאה',
    clear_all: 'נקה הכל',
    confirm_course_wide_premiew: 'אשר תצוגה מקדימה לקורס כולו',
    generate_course_preview: 'צור תצוגה מקדימה של הקורס',
    instructions_across_the_course_to_generate:
      'ניישם את ההנחיות שלך בכל הקורס כדי ליצור תצוגה מקדימה. סקור הכל תחילה, ואז בחר אם לשמור או לבטל שינויים.',
    instruction_to_preview_course_wide: 'הוראות לתצוגה מקדימה של הקורס כולו:',
    edit_content: 'ערוך תוכן',
    manage_course_template: 'נהל תבנית קורס',
    undo: 'בטל',
    apply_changes: 'החל שינויים',
    characters: 'תווים',
    apply_all: 'החל לכולם',
    apply_to_all: 'החל לכולם',
    use_this_content: 'השתמש בתוכן הזה',
    original: 'מקורי',
    edited: 'נערך',
    edited_content_preview: 'תצוגת תוכן נערך',
    apply_edits_to_all_topices: 'החל עריכות על כל הנושאים?',
    current_editing_instructions_across_the_whole_course:
      'זה יחיל את הוראות העריכה הנוכחיות שלך על כל הקורס. תוכל לסקור את התצוגה המשולבת לפני שמירה.',
    edit_content_instructions: 'הוראות לעריכת תוכן',
    generate_content_for_this_topic_instruction:
      'צור תוכן לנושא זה באמצעות ההוראות שלך',
    descrip_edit_content:
      'תאר כיצד לערוך תוכן זה (לדוגמה: קיצור, פישוט, ניסוח מחדש)',
    try_short_clear_direcctives:
      'נסה הנחיות קצרות וברורות. דוגמאות: “צמצם למאה מילים, שמור נקודות מפתח”, “פשט שפה”, “היה תמציתי ומחק תוספות”.',
    we_preserve_the_core_meaning:
      'אנחנו שומרים על המשמעות הבסיסית בזמן שַׁמְשִׁים את ההוראות שלך.',
    feedback_optional: 'משוב (אופציונלי)',
    write_your_feedback_here: 'כתוב את המשוב שלך כאן',
    from_web: 'מהאינטרנט',
    from_desktop: 'מהשולחן-העבודה',
    pleae_wait_processing: 'אנא המתן…',
    create_simulation_from_screen_capture: 'צור סימולציה מהקלטת מסך',
    sharelook_not_found: 'ShareLook לא נמצא',
    sharelook_screen_capture_application_not_be_opened:
      'אפליקציית ShareLook להקלטת מסך לא נפתחה. ייתכן שלא מותקנת במחשב שלך.',
    download_sharelook: 'הורד את ShareLook',
    launch_sharelook_application: 'הפעל את אפליקציית ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'זה יפתח את אפליקציית ShareLook להקלטת מסך.',
    sharelook_dosenot_open: 'אם ShareLook לא נפתח, ייתכן שלא מותקן במחשב שלך.',
    open_sharelook: 'פתח את ShareLook',
    download_app: 'הורד אפליקציה',
    background_image_setting: 'הגדרות תמונת רקע',
    current_image: 'תמונה נוכחית',
    change_image: 'שנה תמונה',
    remove_image: 'הסר תמונה',
    no_background_image_selected: 'לא נבחרה תמונת רקע',
    add_image: 'הוסף תמונה',
    this_will_open_for_screen_recording: 'זה יפתח את ShareLook להקלטת מסך.',
    ai_image_generation: 'יצירת תמונה באמצעות AI',
    image_edit: 'עריכת תמונה',
    text_to_image: 'טקסט לתמונה',
    output_gallary: 'גלריית תוצאה',
    instant_generation: 'מוכן ליצירה מיידית',
    prompt_and_unleash_the_power: 'הזן את בקשתך ושחרר את הכוח',
    use_this_image: 'השתמש בתמונה הזו',
    error_generating: 'שגיאה ביצירה.',
    generation_tips: 'טיפים ליצירה',
    detailed_descriptions_for_more_accurate_results:
      'השתמש בתיאורים מפורטים לתוצאות מדויקות יותר',
    reference_image: 'תמונת ייחוס',
    select_pixel_image: 'בחר תמונת פיקסל',
    max_mb: 'מקסימום 50 MB',
    please_enter_text_to_appear_image: 'אנא הזן טקסט שיופיע בתמונה',
    enter_text_to_apear_in_the_image: 'הזן את הטקסט שיופיע בתמונה',
    generate_image: 'צור תמונה',
    prompt_assistant: 'עוזר בקשת AI',
    generate_image_using_suggested_prompt: 'צור תמונה באמצעות בקשה מוצעת',
    talk_to_ai_about_the_image_generate: 'שוחח עם AI על התמונה שברצונך ליצור',
    ask_for_prompt_suggestions: 'בקש הצעות לבקשה…',
    enter_a_search_term_to_find_stock_images:
      'הזן מונח חיפוש למציאת תמונות סטוק',
    choose_your_content_source: 'בחר את מקור התוכן שלך:',
    upload_new_document_from_your_device: 'העלה מסמך חדש מהמכשיר שלך',
    automatic_library_selection: 'בחירה אוטומטית מספרייה',
    system_automatically_selects_relevant_document:
      'המערכת בוחרת אוטומטית מסמכים רלוונטיים',
    manual_library_selection: 'בחירה ידנית מספרייה',
    generate_content: 'צור תוכן',
    add_to_current_page: 'הוסף לדף הנוכחי',
    generate_bullet_points: 'צור נקודות־תבליט',
    generating: 'יוצר…',
    this_may_take_a_few_moments: 'זה עשוי לקחת מספר רגעים',
    apply_to_page: 'החל לדף',
    scenario_escription: 'תיאור התרחיש:',
    feedback: 'משוב',
    form_mode: 'מצב טופס',
    chat_mode: 'מצב צ’אט',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'זה ייצור המשך של הסיפור הנבחר באמצעות AI.',
    continue_this_story_question: 'להמשיך את הסיפור הזה?',
    continue_this_story: 'המשך את הסיפור הזה',
    what_will_happen: 'מה יקרה:',
    the_ai_will_analyze_the_existing_story_content:
      'ה-AI יבחן את תוכן הסיפור הקיים',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'צור המשך טבעי שהוא באותו הטון והסגנון',
    create_new_content_that_build_upon_the_current_narrative:
      'צור תוכן חדש שיתבסס על הנרטיב הקיים',
    this_process_may_take_a_few_moments_to_complete:
      'תהליך זה עשוי להימשך מספר רגעים.',
    no_existing_stories_found_for_this_course:
      'לא נמצאו סיפורים קיימים לקורס זה.',
    create_your_first_story: 'צור את הסיפור הראשון שלך',
    existing_stories: 'סיפורים קיימים',
    create_new_story: 'צור סיפור חדש',
    tone: 'טון',
    style: 'סגנון',
    genre: 'ז’אנר',
    loading_your_stories: 'טוען את הסיפורים שלך…',
    edit_story: 'ערוך סיפור',
    story_preferences: 'העדפות סיפור',
    please_input_your: 'אנא הזן את',
    add_character_names_and_press_enter: 'הוסף שמות דמויות ולחץ לְהַכנִיס',
    select_or_type_your: 'בחר או הקלד את',
    enter_your: 'הזן את',
    position_of_the_story_in_the_lesson:
      'מיקום הסיפור בשיעור. הסיפור יתווסף כחלק במיקום שצוין.',
    save_previous_content_on_the_pages: 'שמור את התוכן הקודם בדפים',
    the_existing_content_in_the_selected_pages:
      'התוכן הקיים בדפים שנבחרו יוחלף על-ידי הסיפור שנוצר.',
    real_world_scenario: 'תרחיש מהעולם האמיתי',
    add_optional_instructions: 'הוסף הוראות אופציונליות (טון, אורך, קהל וכו׳).',
    ready_to_enerate_your_real_world_scenario:
      'מוכן ליצירת התרחיש שלך מהעולם האמיתי',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'לחץ “צור תרחיש מהעולם האמיתי” כדי ליצור תרחיש ריאלי המבוסס על תוכן השיעור שלך.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'ה-AI יבחן את נושא השיעור והתוכן שלך',
    generate_a_practical_real_world_scenario: 'צור תרחיש מעשי מהעולם האמיתי',
    you_can_then_edit_and_customize_the_result:
      'תוכל לערוך ולהתאים אישית את התוצאה',
    add_it_as_a_new_page_to_your_lesson: 'הוסף זאת כדף חדש לשיעור שלך',
    regenerate_with_instructions: 'צור מחדש עם הוראות',
    add_real_world_scenario: 'הוסף תרחיש מהעולם האמיתי',
    generate_real_world_scenario: 'צור תרחיש מהעולם האמיתי',
    simulation_has_been_stopped: 'הסימולציה נעצרה!',
    loading_simulation: 'טוען סימולציה...',
    you_have_exhausted_all_the_attempts: 'מיצית את כל הניסיונות',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'למד את התרחיש בדף זה ובחר את התשובה הנכונה מבין האפשרויות למטה.',
    attempts_limit_reached:
      'הגעת למגבלת הניסיונות. תוכל לשחק שוב אך הציון שלך לא יישמר.',
    play_again: 'שחק שוב',
    import_music_from_computer: 'ייבא מוזיקה מהמחשב.',
    more: 'עוד',
    no_badge_yet: 'אין עדיין תגי הישגים',
    competition_filter: 'מסנן תחרות',
    global_leaderboard: 'טבלת מובילים עולמית',
    placeholder_for_the_global_leaderboard:
      'זהו מציין מקום לטבלת המובילים העולמית.',
    badge_editor: 'עורך תגי הישגים',
    adjust_the_appearance_of_this_badge_icon:
      'התאם את המראה של סמל התג הזה. השינויים יחולו רק על תג זה.',
    badge_style: 'סגנון תג',
    the_image_must_be_pixels: 'התמונה חייבת להיות בגודל 200x200 פיקסלים.',
    badge_name: 'שם התג',
    badge_descrription: 'תיאור התג',
    enter_badge_criteria: 'הזן קריטריונים לתג',
    discard: 'בטל',
    badge_enable: 'תגים מופעלים',
    award_users_with_badges_to_highlight_the_milestones:
      'הענק למשתמשים תגים כדי להדגיש את אבני הדרך במסע הלמידה שלהם.',
    badge_types: 'סוגי תגים',
    enable_or_disable_specific_badge_types_for_your_users:
      'הפעל או השבת סוגי תגים מסוימים למשתמשים שלך.',
    levels_enabled: 'שלבים מופעלים',
    level_rules: 'כללי שלבים',
    points: 'נקודות',
    add_new_level: 'הוסף שלב חדש',
    add_level: 'הוסף שלב',
    points_enabled: 'נקודות מופעלות',
    learning_activities_and_encourage_healthy_competition:
      'הענק נקודות על פעילויות למידה שונות ועודד תחרות בריאה.',
    award_points: 'הענק נקודות',
    the_following_equates_the_value_of_one_item_completion:
      'הבאים מייצגים את ערך סיום פריט אחד',
    general: 'כללי',
    others: 'אחרים',
    certificate: 'תעודה',
    quiz_passed: 'המבחן עבר בהצלחה',
    tip_approved: 'טיפ אושר',
    tip_liked: 'טיפ נאהב',
    rewards: 'פרסים',
    offer_discounts_when_learners_achieve:
      'הצע הנחות כאשר לומדים משיגים נקודות, תגים או שלבים מסוימים.',
    give_rewards: 'הענק פרסים',
    discount_course_purchases_by: 'הנחה ברכישת קורסים ב־',
    with_points_more_than: 'עם יותר מ־נקודות',
    with_badges_more_than: 'עם יותר מ־תגים',
    with_level_upwards_more_than: 'עם רמה גבוהה יותר מ־',
    leaderboard: 'טבלת מובילים',
    leaderboard_enabled: 'טבלת מובילים מופעלת',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'טבלאות המובילים מציעות למשתמשים סקירה של התקדמות הלמידה שלהם ביחס לאחרים.',
    show_levels: 'הצג שלבים',
    show_points: 'הצג נקודות',
    show_badges: 'הצג תגים',
    show_courses: 'הצג קורסים',
    show_certificates: 'הצג תעודות',
    leaderboard_settings: 'הגדרות טבלת מובילים',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'הגדר חוויות טבלת מובילים מעוררות עניין כדי לשפר את המוטיבציה של הלומדים.',
    award_users_with_points_for_different_learning_activities:
      'הענק למשתמשים נקודות עבור פעילויות למידה שונות.',
    badge_set: 'ערכת תגים',
    choose_the_type_of_badges_your_users:
      'בחר את סוגי התגים שמשתמשיך ירוויחו במהלך הלמידה.',
    levels: 'שלבים',
    Levels_represent_the_stages:
      'שלבים מייצגים את התחנות במסע הלמידה של המשתמש.',
    enabled: 'מופעל',
    disabled: 'מושבת',
    quick_select: 'בחירה מהירה',
    yesterday: 'אתמול',
    last_week: 'שבוע שעבר',
    Last_month: 'חודש שעבר',
    last_quarter: 'רבעון אחרון',
    historical_leaderboard: 'טבלת מובילים היסטורית',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'עקוב אחר הביצועים שלך וראה את דירוגך בין חבריך.',
    time_period: 'תקופת זמן',
    page_of: 'עמוד 1 מתוך 1',
    edit_competition: 'ערוך תחרות',
    create_competition: 'צור תחרות',
    arrow_right: 'חץ ימינה',
    update_competition: 'עדכן תחרות',
    competition_title: 'כותרת התחרות',
    enter_competition_title: 'הזן כותרת לתחרות',
    enter_competition_description: 'הזן תיאור לתחרות',
    leaderboard_skill: 'מיומנות',
    select_a_skill: 'בחר מיומנות',
    no_skills_found: 'לא נמצאו מיומנויות',
    competition_period: 'תקופת התחרות',
    add_badge_rule: 'הוסף כלל תג',
    create_badge: 'צור תג',
    add_level_rule: 'הוסף כלל שלב',
    selected_participants: 'משתתפים שנבחרו',
    no_participants: 'אין משתתפים',
    start_end_date: 'תאריך התחלה–סיום',
    created_date: 'נוצר על ידי',
    new_competition: 'תחרות חדשה',
    competitions_list: 'רשימת תחרויות',
    search_competitions: 'חפש תחרויות...',
    are_you_sure_you_want_to_delete_the_competition:
      'האם אתה בטוח שברצונך למחוק את התחרות?',
    history: 'היסטוריה',
    export: 'ייצוא',
    search_by_name: 'חפש לפי שם...',
    no_historical_data_available_for_the_selected_period:
      'אין נתונים היסטוריים זמינים לתקופה שנבחרה.',
    no_leaderboard_data_available: 'אין נתוני טבלת מובילים זמינים.',
    competitions: 'תחרויות',
    leaderboards: 'טבלאות מובילים',
    welcome_back: 'ברוך שובך',
    track_your_performance_and_see:
      'עקוב אחר הביצועים שלך וראה כיצד אתה מדורג ביחס לאחרים',
    team_leaderboard: 'טבלת מובילים צוותית',
    try_again: 'נסה שוב',
    no_competitions_for_search: 'אין תחרויות זמינות עבור החיפוש',
    no_competitions_available: 'אין תחרויות זמינות',
    no_competitions_matching_search:
      'לא נמצאו תחרויות התואמות לחיפוש שלך. נסה לשנות את מונחי החיפוש או חזור מאוחר יותר.',
    no_competitions_general:
      'אין כרגע תחרויות פעילות. חזור מאוחר יותר או פנה למנהל שלך ליצירת תחרויות חדשות.',
    media_management: 'ניהול מדיה',
    badgess_set: 'ערכת תגים',
    choose_the_default_visual_style_for_badge:
      'בחר את סגנון התצוגה ברירת המחדל לסמלי תגים בכל הפלטפורמה.',
    enable_badges: 'הפעל תגים',
    add_badge: 'הוסף תג',
    min: 'מינימום',
    max: 'מקסימום',
    your_rank: 'הדירוג שלך',
    your_points: 'הנקודות שלך',
    your_level: 'הרמה שלך',
    rank: 'דירוג #',
    level: 'רמה',
    progress: 'התקדמות',
    new_folder: 'תיקייה חדשה',
    file_upload: 'העלאת קובץ',
    writer: 'עורך טקסט',
    text_documents: 'מסמכי טקסט',
    spreadsheets: 'גיליונות נתונים',
    impress: 'מצגות Impress',
    presentations: 'מצגות',
    capture_desktop_screen: 'לכוד את מסך שולחן העבודה',
    capture_desktop_screens: 'לכוד מסכי שולחן עבודה',
    your_documents: 'המסמכים שלך',
    manage_your_videos_images_audio_files:
      'נהל את הסרטונים, התמונות, קבצי האודיו והנכסים האחרים המשמשים ביצירת התוכן שלך.',
    your_organization_documents: 'מסמכי הארגון שלך',
    keep_your_organization_creative_assets_organized:
      'שמור על נכסי המדיה של הארגון שלך מאורגנים ונגישים – שפר את עבודת הצוות וייצור התוכן.',
    your_public_documents: 'המסמכים הציבוריים שלך',
    curated_collection_of_media_assets_available:
      'אוסף מאורגן של נכסי מדיה הזמינים לכולם – גלה, השתמש וצור.',
    your_download_center_documents: 'מסמכי מרכז ההורדות שלך',
    repository_of_approved_media_assets_for_download:
      'מאגר של נכסי מדיה מאושרים להורדה ולשימוש בפרויקטים שלך.',
    search_files_and_folders: 'חפש קבצים ותיקיות...',
    home: 'בית',
    folders: 'תיקיות',
    folder_name: 'שם תיקייה',
    owner: 'בעלים',
    last_updated: 'עודכן לאחרונה',
    action: 'פעולה',
    no_folders_found: 'לא נמצאו תיקיות',
    files: 'קבצים',
    enabling_ai: 'מפעיל בינה מלאכותית...',
    rename: 'שנה שם',
    copy: 'העתק',
    move: 'העבר',
    verson_history: 'היסטוריית גרסאות',
    manage_permission: 'נהל הרשאות',
    generate_audit_report: 'צור דוח ביקורת',
    last_edited: 'נערך לאחרונה',
    no_files_found: 'לא נמצאו קבצים',
    are_you_sure_you_want_to_make_this_item_public:
      'האם אתה בטוח שברצונך להפוך פריט זה לציבורי? הוא יועתק לספרייה הציבורית שלך.',
    move_to_organization: 'העבר לארגון',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'האם אתה בטוח שברצונך להעתיק פריט זה לספריית הארגון שלך?',
    are_you_sure_you_want_to_make_this_item_private:
      'האם אתה בטוח שברצונך להפוך פריט זה לפרטי? הוא יועתק לספרייה האישית שלך.',
    date_modified: 'תאריך שינוי',
    workflow_management: 'ניהול תהליך עבודה',
    configure_editors_approvers_and_viewers_for_this_document:
      'הגדר עורכים, מאשרים וצופים עבור מסמך זה.',
    error_Loading_editor: 'שגיאה בטעינת העורך',
    debug_info: 'מידע לניפוי שגיאות',
    loading_editor: 'טוען עורך...',
    submitted_for_review: 'נשלח לבדיקה',
    editors: 'עורכים',
    no_editors_added_yet:
      'לא נוספו עדיין עורכים. לחץ "הוסף עורך" כדי להוסיף אחד.',
    add_editor: 'הוסף עורך',
    approvers: 'מאשרים',
    no_approvers_added_yet:
      'לא נוספו עדיין מאשרים. לחץ "הוסף מאשר" כדי להוסיף אחד.',
    add_approvers: 'הוסף מאשרים',
    viewer: 'צופה',
    no_viewers_added_yet:
      'לא נוספו עדיין צופים. לחץ "הוסף צופה" כדי להוסיף אחד.',
    add_viewer: 'הוסף צופה',
    are_you_sure_you_want_to_delete_the_selected_items:
      'האם אתה בטוח שברצונך למחוק את הפריטים שנבחרו?'
  },
  v3: {
    reportShareSphere: 'SHARESPHERE',
    overview: 'סקירת קטגוריה',
    triviaReport: 'קטגוריית ShareSphere',
    overviewGraph: 'גרף סקירת קטגוריה',
    category: 'קטגוריה',
    phCategory: 'בחר קטגוריה',
    podcast: 'פודקאסטים, מוזיקה וסיפורים',
    pastPodcast: 'פודקאסטים קודמים',
    upcomingPodcast: 'פודקאסטים עתידיים',
    podcastLanguageTitle: 'שפת הפודקאסט, מוזיקה וסיפורים',
    podcastLanguageCheckbox: 'AI מייצר שפה לפודקאסט שלי',
    howRate: 'איך היית מדרג את הפודקאסט הזה?',
    podcastSubmit: 'שלח',
    podcastGuest: 'מרצה אורח:',
    podcastReview: 'ביקורות',
    podcastEpishode: 'פרקים',
    podcastEnd: 'הפודקאסט הסתיים',
    date_podcast: 'תאריך הפודקאסט',
    skill_not_found: 'מצטערים! לא נמצאה מסלול מיומנות.',
    coaching: 'אימון',
    webinar: 'וובינר',
    public_conference: 'כנס ציבורי',
    skill_journey_subtitle:
      'הוסף הגדרות למסלול המיומנות שלך ובחר מי יכול לצפות ולהתקשר עם מסלול המיומנות שלך.',
    enable_white_label: 'אפשר תווית לבנה',
    create_new_event_org: 'צור אירוע חדש לארגון שלך.',
    create_new_event_marketplace: 'צור אירוע חדש לשוק.',
    create_new_event_both: 'צור אירוע חדש גם לארגון שלך וגם לשוק.',
    event_outline: 'אנא הזן תקציר אירוע',
    event_obj: 'אנא הזן את מטרות האירוע',
    event_description: 'אנא הזן תיאור אירוע',
    create_new_metamaze_org: 'צור מטא מבוך חדש לארגון שלך.',
    create_new_metamaze_marketplace: 'צור מטא מבוך חדש לשוק.',
    create_new_metamaze_both: 'צור מטא מבוך חדש גם לארגון שלך וגם לשוק.',
    add_key_words: 'הוסף מילות מפתח',
    press_enter_make_keyword: 'לחץ על Enter כדי ליצור מילת מפתח',
    disable_skip_quiz: 'השבת דילוג על החידון',
    warning_complete_quiz: 'אנא השלם את החידון כדי להמשיך.',
    signup_email_verification:
      'שלחנו קישור אימות לכתובת האימייל שסיפקת. אנא בקר בקישור זה לאישור ההרשמה שלך.',
    verifying_registration: 'מאמתים את הרשמת החשבון...',
    reset_password_linK:
      'שלחנו קישור לכתובת האימייל שסיפקת. אנא בקר בקישור זה כדי להגדיר סיסמה חדשה.',
    reset_email_error:
      'לא נמצא משתמש עם אימייל זה, נסה שוב עם שם המשתמש במקום!',
    first_name: 'שם פרטי',
    last_name: 'שם משפחה',
    error_firstName: 'אנא הזן את שמך הפרטי',
    error_sharebot_organization: 'אנא הזן את הארגון שלך',
    error_lastName: 'אנא הזן את שם המשפחה שלך',
    private_conference: 'כנס פרטי',
    public_conference: 'כנס ציבורי',
    discussion_room: 'חדר דיון',
    training_no_courses: 'אינך רשום לשום קורס כרגע.',
    training_no_events: 'אינך רשום לאירועים כלשהם כרגע',
    allow_sharing_trainer_info: 'אפשר שיתוף כתובת אימייל בשוק',
    error_username_space: 'שם המשתמש לא יכול להכיל רווחים.',
    error_sharebot_organization_space: 'שם הארגון לא יכול להכיל רווחים.',
    edit_permission: 'הרשאת עריכה',
    valid_price: 'המחיר חייב להיות גבוה מ-0',
    course_price_message: `*הקורס יפורסם למספר המשתמשים שרכש הארגון בלבד ולא
יהיה ניתן למכור אותו מחדש בשוק`,
    valid_edit_price: 'מחיר העריכה חייב להיות נמוך ממחיר הקנייה.',
    my_calendar: 'הלוח שלי',
    error_valid_firstName: 'אנא הזן שם פרטי תקין.',
    error_valid_organization: 'אנא הזן שם ארגון תקין.',
    error_valid_lastName: 'אנא הזן שם משפחה תקין.',
    error_name_spaces: 'השם לא יכול להכיל רווחים',
    items: 'פריטים',
    publish_to_channel: 'פרסם לאוסף הערוץ שלי',
    create_a_channel: 'צור ערוץ',
    create_a_trivia: 'משחק טריוויה',
    create_a_new_channel: 'צור ערוץ חדש',
    add_videos: 'הוסף סרטונים',
    save_and_continue: 'שמור והמשך',
    channel: 'ערוץ',
    channels: 'ערוצים',
    view_channel: 'הצג ערוץ',
    edit_channel: 'ערוך ערוץ',
    delete_channel: 'מחק ערוץ',
    my_video_channels: 'ערוצי הווידאו שלי',
    training_no_channel: 'אינך רשום לאף ערוץ כרגע.',
    monthly_price_required: 'נדרש מחיר חודשי',
    yearly_price_required: 'נדרש מחיר שנתי',
    one_time_price_required: 'נדרש מחיר חד-פעמי',
    marketplace_quantity: 'USD',
    report_webinar: 'וובינר',
    report_coaching: 'אימון',
    report_channel: 'ערוץ',
    report_public_conference: 'כנס ציבורי',
    report_maze: 'מבוך',
    channel: 'ערוץ',
    edit_price: 'ערוך מחיר ($)',
    quantity: 'כמות',
    payment_type: 'סוג תשלום',
    total_amount: 'סכום כולל ($)',
    net_amount: 'סכום נטו ($)',
    edit_option: 'אפשרות עריכה',
    marketplace_price: 'מחיר ($)',
    market_name: 'שם',
    duration_min: 'משך (דקות)',
    users_total: 'משתמשים (סה"כ)',
    sales_total: 'סך כל המכירות (USD)',
    search_coaching: 'חפש אימון',
    search_channel: 'חפש ערוץ',
    search_webinar: 'חפש וובינר',
    search_maze: 'חפש מבוך',
    search_public_conference: 'חפש כנס ציבורי',
    buyer_type: 'סוג קונה',
    quanity: 'כמות',
    channel_unit_amount: 'סכום נטו ($)',
    channel_updated_at: 'תאריך עדכון',
    month_price: 'מחיר (חודש)',
    year_price: 'מחיר (שנה)',
    one_time_price: 'מחיר (חד-פעמי)',
    sharebot_organization: 'הוסף שם ארגון חדש',
    share_sphere: 'ShareSphere',
    ai_course_title: 'כותרת הקורס',
    ai_input_course_title: 'אנא הזן את כותרת הקורס!',
    learning_objective_label: 'מטרת הלמידה',
    learning_objective_message: 'אנא הזן את מטרת הלמידה!',
    standard_question: 'האם יש תקן שעל התלמיד לעמוד בו?',
    standard_details_label: 'פרטי התקן',
    standard_details_message: 'אנא הזן את פרטי התקן!',
    estimated_duration_label: 'משך משוער של הקורס (בדקות)',
    estimated_duration_message: 'אנא הזן את משך הזמן המשוער!',
    min_duration_message: 'המשך המינימלי הוא 5 דקות.',
    ai_mins: '25 דקות',
    industry_specific_question: 'האם זה ספציפי לתעשייה מסוימת?',
    industry_label: 'ציין את התעשייה',
    industry_message: 'אנא הזן את התעשייה!',
    ai_course_creation: 'יצירת קורס באמצעות AI',
    course_generated: 'קורס שנוצר על ידי Sharelook',
    ai: 'AI',
    ai_you: 'אתה',
    ai_prompt_ready: 'הבקשה שלך מוכנה. כעת תוכל ליצור את תוכן הקורס.',
    ai_unable_respond: 'מצטערים! ה-AI לא יכול להגיב לבקשתך. אנא נסה שוב.',
    ai_hide_toc: 'הסתרת תוכן העניינים',
    ai_preview_toc: 'תצוגה מקדימה של תוכן העניינים',
    ai_generate_toc_now: 'צור עכשיו את תוכן העניינים',
    ai_creation_course_title: 'כותרת הקורס:',
    ai_creation_industry_specific: 'האם זה ספציפי לתעשייה מסוימת:',
    ai_creation_industry: 'תעשייה:',
    ai_creation_standard_needed: 'האם יש תקן שעל התלמיד לעמוד בו?',
    ai_creation_standard_details: 'פרטי התקן:',
    ai_creation_estimated_duration: 'משך משוער של הקורס (בדקות):',
    minutes: 'דקות',
    ai_creation_learning_objective: 'מטרת הלמידה:',
    setup_again: 'הגדר שוב',
    ai_creation_confirm_title: 'האם אתה בטוח שברצונך לאפס את הטופס?',
    ai_creation_confirm_content: 'השיחה וכל התוכן שנוצר יאופסו.',
    ai_toc: 'תוכן העניינים',
    ai_note_topic: 'הערה: ניתן לגרור ולשחרר כדי לארגן מחדש את הנושאים בקורס.',
    ai_add_topic: '+ הוסף נושא',
    add_topic: 'הוסף נושא',
    add_lesson: 'הוסף שיעור',
    add_new_lesson: 'הוסף שיעור חדש',
    ai_add_lesson: '+ הוסף שיעור',
    attention: 'תשומת לב',
    before_varifying: 'לפני אימות',
    ai_save_later: 'שמור מאוחר יותר',
    ai_download_word_doc: 'הורדה כקובץ Word',
    ai_download_course_word_doc: 'הורדת הקורס כקובץ Word',
    ai_create_course_button: 'צור קורס',
    ai_generate_course_content: 'צור תוכן קורס',
    ai_out_of: 'מתוך',
    ai_subtopic_failed_content:
      "תתי-הנושאים לא הצליחו ליצור תוכן. לחץ שוב על 'צור תוכן קורס' כדי ליצור תוכן רק עבור תתי-הנושאים הללו.",
    ai_edit_topic: 'ערוך נושא',
    ai_edit_lesson_title: 'ערוך כותרת שיעור',
    ai_save_topic: 'שמור נושא',
    ai_save: 'שמור',
    ai_save_lesson_title: 'שמור כותרת שיעור',
    ai_add_new_topic: 'הוסף נושא חדש',
    ai_download_ref: 'הורדה עם הפניות',
    ai_download_ref_content: 'זה יוריד את הקורס כקובץ Word עם הפניות.',
    ai_download_without_ref: 'הורדה ללא הפניות',
    ai_download_two_word: 'יורדו שני קבצי Word:',
    ai_download_two_word_content_one: '- אחד עם התוכן הראשי ללא הפניות,',
    ai_download_two_word_content_two:
      'והשני עם רשימת ההפניות בלבד ללא תוכן מקושר.',
    ai_manage_content: 'נהל תוכן',
    ai_add_content_from_internet: '+ הוסף תוכן מהאינטרנט',
    ai_confirm_start: 'אישור התחלה',
    ai_Verify: 'אמת',
    ai_undo_warning:
      'תהליך זה עשוי להימשך זמן מה. אנא אל תסגור את החלון עד לסיום היצירה כי אין אפשרות לביטול.',
    ai_verified_content:
      'אישרת את התוכן. לאחר האישור לא תוכל לחזור לשיחה עם עוזר ה-AI עם התוכן הנוכחי.',
    ai_want_proceed: 'האם אתה בטוח שברצונך להמשיך?',
    upload_simulation: 'העלאת סימולציה',
    name_simulation: 'שם סימולציה',
    selected_simulation_files: 'קבצי סימולציה שנבחרו',
    score_between_one_hundred: 'הציון שלך צריך להיות בין 1 ל-100.',
    are_sure_simulation: 'האם אתה בטוח שברצונך למחוק את קובץ הסימולציה הזה?',
    required_simulation: 'הציון נדרש',
    required_section_file: 'קובץ הסעיף נדרש',
    simulation: 'סימולציה',
    simulation_quiz_games: 'עליך להוסיף חידונים למשחקים',
    simulation_alert_des:
      'ניתן להוסיף משחקים רק אם כל השאלות הן מסוג תשובה יחידה או תשובה מרובה.',
    alert_info: 'מידע',
    ai_number_quiz: 'מספר חידונים',
    ai_point: 'נקודה',
    ai_points: 'נקודות',
    val_required: 'נדרש',
    games: 'משחקים',
    add_simulation: 'הוסף סימולציה',
    text_tiewer: 'מציג טקסט',
    back_to_account: 'חזרה לחשבון',
    delete_account: 'מחק חשבון',
    delete_account_title: 'מחיקת חשבון ???',
    delete_account_subtitle: 'ניתן למחוק את החשבון שלך כאן.',
    delete_account_cannot_undo:
      'אתה עומד למחוק את החשבון שלך. פעולה זו לא ניתנת לביטול.',
    account_org_profile:
      'אתה גם תפסיד את כל הקורסים שיצרת, פרופיל הארגון שלך וכל ההגדרות שלך.',
    deleting_account_database:
      'מחיקת החשבון תמחק את כל הנתונים שלך מהמסד נתונים שלנו.',
    account_confirm_delete: 'האם אתה בטוח שברצונך למחוק את החשבון שלך?',
    action_cannot_be_undone: 'פעולה זו לא ניתנת לביטול.',
    account_delete_message_success: 'החשבון שלך נמחק בהצלחה.',
    message_edit: 'ערוך',
    message_delete: 'מחק',
    message_reply: 'השב',
    attached_file: 'קובץ מצורף',
    attach_file: 'צרף קובץ',
    attach_des: '25MB, גודל קובץ מקסימלי',
    view: 'צפה',
    go_to_marketplace: 'עבור לשוק',
    learning_center: 'מרכז למידה',
    knowledge_center: 'מרכז ידע',
    sharebot: 'ShareBot',
    sharebot_help_message: 'כיצד אוכל לעזור לך היום?',
    my_organization: 'הארגון שלי',
    world_knowledge: 'ידע עולמי',
    welcome_to_sharelook: 'ברוכים הבאים ל-Sharelook!',
    sharelook_you_want_go: 'לאן תרצה ללכת היום?',
    shareLook_learning_management_system:
      'גש למערכת ניהול למידה של ShareLook כדי ליצור או לגשת למשאבי הדרכה כמו אירועים חיים וקורסים בארגון שלך ב-ShareLook.',
    shareLook_powerful_ai_system:
      'גש למערכת ה-AI העוצמתית של ShareLook, שם תוכל להעלות קבצי PDF ולקבל תובנות מועילות תוך שניות. קבל תשובות מהירות המבוססות על משאבים שהועלו לארגון שלך או מהמערכת הכללית שלנו בקטגוריית הידע העולמי.',
    edit_now: 'ערוך עכשיו',
    sharelook_log_out: 'התנתקת מ-Sharelook. אנא התחבר שוב!',
    sorry_error: 'מצטערים! נתקלנו בשגיאה.',
    login: 'התחברות',
    refresh_page: 'רענן עמוד',
    just_a_moment: 'רק רגע',
    enter_lname_fname: 'אנא הזן את שמך הפרטי ושם המשפחה כדי להמשיך.',
    procced_to_sharelook: 'המשך ל-Sharelook',
    option_one: 'אפשרות 1',
    option_two: 'אפשרות 2',
    selected_image: 'תמונה נבחרה:',
    add_text: 'הוסף טקסט',
    linkdin_is_required: 'נדרש LinkedIn.',
    bio_is_required: 'נדרש ביוגרפיה.',
    save_user_information: 'שמור מידע משתמש',
    select_all: 'בחר הכל',
    enable_ai: 'הפעל AI',
    load_more: 'טען עוד',
    channel_id: 'מזהה ערוץ.',
    send: 'שלח',
    v4: 'מידע',
    subscription: 'מנוי',
    reset_user_flag: 'איפוס דגל משתמש',
    delete_my_accont: 'מחק את החשבון שלי',
    sharebot_sub_error: 'שגיאה בקבלת המנויים. אנא נסה שוב!',
    sharebot_no_sub: 'אין לך מנוי פעיל כרגע.',
    sharebot_dont_sub: 'אין לך מנוי קודם.',
    sharebot_prev_sub: 'מנויים קודמים',
    sharebot_sub: 'מנוי ShareBot',
    sharebot_un_sub: 'בטל מנוי ShareBot',
    sharebot_no_available: 'אין תיאור זמין',
    sharebot_start_date: 'תאריך התחלה:',
    sharebot_end_date: 'תאריך סיום:',
    sharebot_sure: 'האם אתה בטוח?',
    sharebot_do_you_want: 'האם ברצונך',
    unsubscribe: 'לבטל את המנוי שלך',
    unsubscribe_what: 'לבטל את המנוי שלך?',
    subscribe: 'להירשם',
    subscribe_what: 'להירשם?',
    subscribe_now: 'הירשם עכשיו',
    confirm: 'אשר',
    sharebot_intel_knowledge_center: 'מרכז הידע האינטליגנטי של ShareBot',
    sharebot_welcome_paragraph:
      "ברוכים הבאים למרכז הידע של ShareBot, הצ'אטבוט המתקדם מבוסס AI שנועד לשנות את הדרך שבה מקצוענים מקבלים מידע ומשתפים פעולה.",
    expired: 'פג תוקף',
    active: 'פעיל',
    Inactive: 'לא פעיל',
    yearly_subscription: 'מנוי שנתי',
    monthly_subscription: 'מנוי חודשי',
    no_sharebot_org: 'אין לך ארגון ב-ShareBot',
    sharebot_start_free_trial: 'התחל ניסיון חינם',
    sub_month: 'מנוי חודשי',
    sub_year: 'מנוי שנתי',
    question_per_month: 'אחסון נתונים (1 TB) ו‑1000 שאלות לכל החיים',
    sharebot_para:
      'בהתקדמותך, אתה מאשר מחיקה מיידית של הארגון. פעולה זו תגרום לאובדן כל התובנות החשובות שניתנו על ידי ShareBot ולא ניתנת להחזרה.',
    cancelled_date: 'תאריך ביטול:',
    live_straming_para:
      'אם ברצונך לשנות את המגבלה החודשית על שידור חי, אנא פנה ל',
    sharelook_agree: 'אני מסכים ל‑Sharelook',
    terms_condition: 'תנאים והגבלות',
    and: 'ו‑',
    privacy_policy: 'מדיניות פרטיות',
    save_for_later: 'שמור מאוחר יותר',
    ai: 'בינה מלאכותית',
    no_video_yet: 'עדיין לא נבחר אודות!',
    are_you_sure_delete_video: 'האם אתה בטוח שברצונך למחוק את הווידאו הזה?',
    video_des: 'תיאור',
    video_now: 'עכשיו',
    video_playing: 'מתנגן:',
    video_no: 'ווידאו מס’',
    ai_generated_course: 'קורס שנוצר על ידי AI',
    create_course_on_our_own: 'צור קורס בעצמך',
    ai_Assisted_ourse_reation: 'יצירת קורס בסיוע AI',
    pending: 'בהמתנה',
    published: 'פורסם',
    intro_course: 'להוסיף לקורס?',
    clone_course: 'האם ברצונך לשכפל קורס זה?',
    browser_audio_not_support: 'הדפדפן שלך לא תומך בתגית Audio.',
    audio_popup_content:
      'אתה יכול להשתמש בסגנונות קול שונים על‑פי הטקסט שלך — Lorem Ipsum הוא טקסט דמה סטנדרטי המשמש מאז המאה ה‑16.',
    close: 'סגור',
    podcast_rec: 'הקלטה',
    create_podcast: 'צור פודקאסט',
    add_admin: 'הוסף מנהל',
    delete_all: 'מחק הכל',
    ai_podcast_audio: 'סאונד פודקאסט מבוסס AI',
    language: 'שפה',
    podcast_download_content:
      '*הורד את קובץ הצליל ש־AI הפיק כדי לערוך אותו בעורך שלך.',
    upload_audio: 'העלה אודיו',
    browser_do_not_support_audio: 'הדפדפן שלך אינו תומך בתגית audio.',
    upload_cover: 'העלה תמונת קאבר',
    upload_ai_creator: 'הוסף יוצר AI',
    required_cover_image: 'תמונת קאבר חובה!',
    room_required_name: 'שם הפודקאסט נדרש!',
    add_guest_list: 'אנא הוסף רשימת אורחים!',
    podcast_add_participants: 'הוסף משתתפים',
    topic_required: 'נדרש נושא אחד לפחות',
    podcast_description: 'תיאור',
    podcast_date: 'תאריך',
    date: 'תאריך',
    podcast_time: 'שעה',
    podcast_to: 'עד',
    podcast_all_day: 'כל היום',
    podcast_start_date_time: 'נדרש תאריך ושעת התחלה!',
    podcast_id: 'מזהה',
    selected_user: 'הזמן משתמשים נבחרים',
    see_more: 'הצג יותר',
    see_less: 'הצג פחות',
    no_review_yet: 'עדיין אין ביקורות — תהיה הראשון!',
    request_to_speak: 'לקבל את בקשת הדיבור של המשתמש?',
    kick_user: 'להוציא את המשתמש?',
    accept_request: 'קבל בקשה',
    kick: 'הוצא',
    started: 'התחיל',
    end: 'נסגר',
    join_now: 'הצטרף עכשיו',
    podcast_end: 'הפודקאסט הסתיים',
    connecting: 'מתחבר...',
    knowledge_center_know_today: 'מה תרצה לדעת היום?',
    knowledge_center_question: 'אנא הזן שאלה תחילה',
    knowledge_center_error: 'מצטערים! אירעה שגיאה.',
    knowledge_center_tooltrip:
      'קבל תשובות מהירות ממשאבי הלמידה בארגון שלך עם הפניות ל‑PDF ויכולת לצפות ולהוריד אותם.',
    my_organization: 'הארגון שלי',
    world_knowledge: 'ידע עולמי',
    open_file: 'פתח קובץ',
    reference: 'הפניה',
    are_you_cancel: 'האם אתה בטוח שברצונך לבטל?',
    are_you_remove_media: 'האם אתה בטוח שברצונך להסיר את המדיה?',
    terms_agree: 'אני מסכים לתנאים אלו',
    ready: 'מוכן',
    send_email: 'שלח אימייל',
    active_users: 'משתמשים פעילים',
    sign_up_user: 'משתמשים רשומים',
    non_sign_up_user: 'משתמשים לא רשומים',
    organisation: 'ארגון',
    usage_report: 'דו"ח שימוש',
    check_email: 'בדוק את האימייל שלך',
    delete_schedule: 'מחק לוח זמנים',
    are_you_sure_delete_schedule: 'האם אתה בטוח שברצונך למחוק לוח זה?',
    add_task: 'אנא הזן משימה!',
    coaching_available: 'אימון זמין',
    message_booking_coaching: 'חלון הזמן הזה הוזמן על ידי משתמש לאימון.',
    task_day: 'יום המשימה',
    created_task_day: 'יצרת משימה עבור היום הזה.',
    event_day: 'יום האירוע',
    has_booked_coaching: 'כבר הזמנת אימון ליום זה.',
    active_day: 'יום פעיל',
    selectable_time_slots:
      'החלופות הניתנות לבחירה זמינות לימי הפעילים מצד ימין.',
    compare_last_month: 'השווה לחודש שעבר',
    uploading_file: 'הקובץ נטען',
    attach_file_course: 'מצורף לקורס',
    fetch_request: 'טוען את בקשתך',
    finilize_upload: 'מסיים את ההעלאה',
    scorm_scanned: 'אנא המתן... קובץ ה‑SCORM שלך נסרק.',
    scan_status: 'מצב הסריקה:',
    scan_completed: 'הסריקה הושלמה. הקובץ הוא',
    scan_progress: 'הסריקה בתהליך...',
    check_scorm: 'בודק את פורמט קובץ SCORM שלך...',
    file_check_success: 'בדיקת הקובץ הצליחה',
    file_check_progress: 'בדיקת הקובץ בעיצומה',
    scorm_not_upload: 'הקובץ שהועלה אינו תואם ל־SCORM 1.2, אנא העלה שנית.',
    select_question: 'שאלת בחירה (תשובה אחת נכונה)',
    select_answer: 'אנא בחר תשובה!',
    check_option_one: 'אנא הזן אפשרות אחת!',
    check_option_two: 'אנא הזן שתי אפשרויות!',
    check_option_three: 'אנא הזן שלוש אפשרויות!',
    check_option_four: 'אנא הזן ארבע אפשרויות!',
    question_image: 'תמונת השאלה',
    select_question_image: 'אנא בחר תמונה לשאלה!',
    ans_image: 'תמונת התשובה',
    upload_image_question: 'העלה תמונת שאלה',
    select_image_answer: 'בחר תמונת תשובה!',
    save_question: 'שמור את השאלה',
    do_you_leave: 'האם אתה רוצה לעזוב? אתה בטוח?',
    loose_all_progress: 'כל ההתקדמות שלך תאבד.',
    welcome: 'ברוך הבא',
    team_knowledge_quest: 'משימת צוות ידע',
    your_score: 'הציון שלך',
    start_playing: 'התחל לשחק',
    share_sphere_complete: 'ShareSphere הושלם',
    final_score: 'הציון הסופי',
    play_next: 'שחק הבא',
    you_donot_access_event: 'אין לך גישה לאירוע הזה',
    ai_content_generated: 'תוכן שנוצר על ידי AI לנושא זה',
    ai_popup_confirm_content: 'אשר יצירת תוכן',
    limit_transcribe_text:
      'דקות נשארו לתמלול: <0>{{ transcribe_limit }}</0> דקות <1/><2/> <3>. כדי לשנות את מגבלת התמלול שלך, אנא פנה אל </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'אין לך גישה לאירוע זה.',
    ai_course_title_training: 'קורסי אימון מנהיגות',
    ai_course_object: 'ניווט במנהיגות דיגיטלית',
    create_ai_video: 'צור וידאו בינה מלאכותית',
    generate: 'יצירה',
    video_generate_process:
      'תהליך יצירת הווידאו עלול לקחת זמן. תקבל הודעת דואר אלקטרוני כשהוא יסתיים.',
    stripe_account_connect:
      'חשבון Stripe שלך אינו פעיל. אנא התחבר או הפעל אותו כדי להמשיך.',
    ai_creator: 'יוצר בינה מלאכותית',
    check_video_status: 'בודק את מצב יצירת הווידאו...',
    video_on_queue: 'יצירת הווידאו בתור.',
    video_fail_generation: 'מצטערים, יצירת הווידאו נכשלה. אנא נסה שוב.',
    video_currently_generated: 'וידאו זה נמצא בתהליך יצירה.',
    checking_status: 'בודק מצב',
    check_status: 'בדוק מצב',
    browser_does_not_support_audio: 'הדפדפן שלך אינו תומך בתג השמע',
    existing_edit_scenario:
      'האם ברצונך לערוך את התרחיש הקיים או ליצור תרחיש חדש? אם תיצור תרחיש חדש, תפסיד את הישן.',
    generate_scenario: 'צור תרחיש',
    layout: 'פריסה',
    confirm_change: 'אשר שינוי',
    generated_ai_creation_message:
      'שים לב שרק אלמנטים טקסט שנוצרו באמצעות יצירת AI יישמרו. כל שאר האלמנטים יוסרו מהדף.',
    generate_story: 'צור סיפור',
    save_original_content: 'שמור תוכן מקורי:',
    story_added_specified_position:
      'מיקום הסיפור בשיעור. הסיפור יתווסף כחסימה במיקום שצוין.',
    position_of_story: 'מיקום הסיפור',
    start_the_lesson: 'תחילת השיעור',
    end_the_lesson: 'סוף השיעור',
    add_story_pages: 'הוסף סיפור לדפים',
    browser_does_not_support: 'הדפדפן שלך אינו תומך באלמנט השמע.',
    no_video_available: 'אין סרטונים זמינים.',
    no_podcast_available: 'אין פודקאסטים זמינים.',
    no_item_baskets: 'אין פריטים בעגלה.',
    ai_course_object: 'ניווט במנהיגות דיגיטלית'
  },
  v2: {
    n_data: 'אין נתונים',
    change: 'שנה',
    remove: 'הסר',
    auto_background: 'רקע אוטומטי',
    create_new_course_org: 'צור קורס חדש לארגון שלך.',
    create_new_course_marketplace: 'צור קורס חדש לשוק.',
    create_new_course_both: 'צור קורס חדש גם לארגון שלך וגם לשוק.',
    ok: 'אישור',
    page_bg: 'רקע עמוד',
    lesson_cover: 'תמונת שער של השיעורים',
    create_skill_journey: 'צור מסלול מיומנויות',
    Metamaze: 'מבוך מטא',
    events: 'אירועים',
    scroms: 'SCORMs',
    min_score_pass: 'ניקוד מינימלי לעבור',
    no_scorms_available: 'אין SCORMs זמינים.',
    no_events_available: 'אין אירועים זמינים.',
    no_courses_available: 'אין קורסים זמינים.',
    no_courses_baskets: 'אין קורסים בסל הקניות.',
    no_mazes_baskets: 'אין מבוכים בסל הקניות.',
    no_scroms_baskets: 'אין SCORMs בסל הקניות.',
    no_events_baskets: 'אין אירועים בסל הקניות.',
    sorry: 'מצטערים!',
    option_1: 'אפשרות 1',
    option_2: 'אפשרות 2',
    enter_number_words: 'הזן את המספר המקסימלי של מילים.',
    summarize: 'סכם',
    answer: 'תשובה',
    hold_tight_one_minute: 'המתן! אנחנו עדיין מכינים. זה עשוי לקחת עד דקה.',
    enter_question: 'הזן את שאלתך.',
    enter_relevant_documents: 'הזן את מספר המסמכים הרלוונטיים.',
    please_input_relevant_documents: 'אנא הזן את מספר המסמכים הרלוונטיים!',
    please_wait_loading_results: 'אנא המתן לטעינת התוצאות...',
    proceed_to_add_voice: 'המשך להוספת קול',
    results: 'תוצאות',
    no_result_found_try_asking_questions:
      'לא נמצאו תוצאות. נסה לשאול שאלות נוספות.',
    eg: 'למשל,',
    what_make_sales_manager: 'מה יכול להפוך אותי למנהל מכירות?',
    please_select_lang: 'אנא בחר שפה!',
    search: 'חיפוש',
    please_copy_desired_content:
      'אנא העתק את התוכן הרצוי מהתיבה השמאלית לתיבה הימנית.',
    rating_req: 'נדרש דירוג.',
    review_req: 'נדרשת סקירה.',
    rating_review_req: 'יש לספק גם דירוג וגם סקירה.',
    how_rate_this: 'איך תדרג זאת?',
    amazing_above_expectations: 'מדהים! מעבר לציפיות!',
    certificates: 'תעודות',
    you_no_certificates: 'אין ברשותך תעודות זמינות כרגע.',
    please_add_review: 'אנא ספק סקירה יחד עם הדירוג, תודה!',
    post: 'פרסם',
    rate: 'דרג',
    avg_rating: 'דירוג ממוצע',
    no_review_found: 'לא נמצאה סקירה',
    are_sure_to_disale_zoom_integration:
      'האם אתה בטוח שברצונך להשבית את אינטגרציית Zoom?',
    badges: 'תגים',
    you_no_badge_available: 'אין ברשותך תגים זמינים כרגע.',
    download_certificate: 'הורד תעודה',
    loading: 'טוען...',
    no_file_attached: 'אין קבצים מצורפים',
    you_do_not_have_any_notes: 'אין ברשותך הערות.',
    question: 'שאלה',
    score: 'ציון',
    alert_score_message: 'משתמשים הגישו את הציונים שלהם.',
    alert_question_message: 'עדיין לא נוספו שאלות.',
    button_submit: 'שלח',
    button_allScores: 'כל הציונים נשלחו.',
    record_wait: 'ההקלטה מתחילה. אנא המתן...',
    buttonSubmit_warning: 'אנא הזן את כל הציונים לפני השליחה.',
    upload_ar_assets: 'העלה נכסי AR',
    edit_ar_assets: 'ערוך נכסי AR',
    edit_maze_assets: 'ערוך נכסי מטא מבוך',
    upload_assets: 'העלה נכסים',
    upload_maze_assets: 'העלה נכסי מטא מבוך',
    trigger_title: 'כותרת טריגר',
    model_title: 'כותרת מודל',
    trigger_description: 'תיאור טריגר',
    model_description: 'תיאור מודל',
    please_type_target_description: 'אנא הקלד תיאור יעד.',
    please_type_model_description: 'אנא הקלד תיאור מודל.',
    trigger_image: 'תמונת טריגר*',
    model_image: 'תמונת מודל*',
    upload_trigger_image: 'העלה תמונת טריגר',
    upload_model_image: 'העלה תמונת מודל',
    drag_n_drop: 'גרור ושחרר',
    file_size_should_not_exceed: '(גודל קובץ תמונה (JPEG) לא יעלה על 512 KB)',
    zip_size_should_not_exceed: '(גודל קובץ zip לא יעלה על 60 MB)',
    ar_content: 'תוכן AR*',
    model_content: 'מודל תלת־ממדי*',
    upload_3d_zip: 'העלה ZIP / וידאו',
    upload_3d_maze_zip: 'העלה ZIP',
    audio_content: 'תוכן שמע',
    _mp3: '(.mp3)',
    content_attached: 'ZIP מצורף.',
    video_attached: 'וידאו מצורף.',
    audio_attached: 'שמע מצורף.',
    enter_trigger_image_title: 'הקלד כותרת לתמונת טריגר.',
    enter_model_title: 'הקלד כותרת למודל מטא מבוך.',
    ar_preview_image: 'תצוגת מקדימה AR',
    upload_preview_image: 'העלה תמונת תצוגה מקדימה',
    upload_audio: 'העלה שמע',
    creating___: 'נוצר...',
    updating___: 'מעודכן...',
    create: 'צור',
    update: 'עדכן',
    ar_assets: 'תמונת תלת־ממדי',
    _3d_files_mp4: '(ZIP .obj, .fbx או וידאו .mp4)',
    _3d_files_mp4_ar: '(ZIP .obj, .fbx)',
    maze_3d_files_mp4: '(ZIP .obj, .fbx)',
    _jpg_files: 'תומך רק בקבצי .jpg',
    persons_have_submitted_their_scores: 'משתמשים הגישו את הציונים שלהם.',
    no_questions_added_till_now: 'טרם נוספו שאלות.',
    submit: 'שלח',
    all_scores_submitted: 'כל הציונים הוגשו.',
    recording_is_starting: 'ההקלטה מתחילה. אנא המתן…',
    please_input_scores_before_submitting: 'אנא הזן את כל הציונים לפני השליחה.',
    end_for_all: 'סיום לכל',
    full_screen: 'מסך מלא',
    breakout_room: 'חדר משני',
    send_invitations: 'שלח הזמנות',
    add_participants: 'הוסף משתתפים',
    create_breakout_room: 'צור חדר משני',
    connecting: 'מתחבר...',
    currently_broadcaster_unavailable: 'השדר אינו זמין כעת.',
    how_many_breakout_room_to_create: 'כמה חדרים משניים ליצור?',
    create_upto_three_breakout_rooms: '*ניתן ליצור עד 3 חדרים משניים',
    allow: 'אפשר',
    additional: 'נוסף',
    attachment: 'קובץ מצורף',
    no_description_available: 'אין תיאור זמין.',
    people: 'אנשים',
    waiting: 'ממתין',
    hand_raising_users: 'משתמשים שמרימים יד',
    invite: 'הזמן',
    create_room: 'צור חדר',
    create_live_event: 'צור אירוע חי',
    support_upto_fivethousand_participants: 'תומך עד 5,000 משתתפים',
    support_upto_ten_participants: 'תומך עד 10 משתתפי וידאו',
    support_upto_twohundred_participants: 'תומך עד 200 משתתפים לאירוע',
    supprt_upto_five_participants: 'תומך עד 5 משתתפי וידאו',
    support_upto_twentyfive_participants: 'תומך עד 25 משתתפי וידאו',
    two_live_video_participants: '2 משתתפי וידאו (מארח ומוזמן)',
    you_can_have_upto_five_examinees: 'ניתן להוסיף עד 5 בוחנים.',
    you_can_have_upto_twentyfive_participants: 'ניתן להוסיף עד 25 משתתפים.',
    you_can_have_upto_five_participants: 'ניתן להוסיף עד 5 משתתפים.',
    you_can_have_upto_ten_participants: 'ניתן להוסיף עד 10 משתתפים.',
    select_hosts_email: 'בחר את מייל המארח',
    send_invite_email: 'שלח מייל הזמנה',
    do_not_send_invite_email: 'אל תשלח מייל',
    error: 'שגיאה',
    max_twentyfive_users_allowed: 'ניתן לבחור עד 25 משתמשים',
    max_five_users_allowed: 'ניתן לבחור עד 5 משתמשים',
    max_ten_users_allowed: 'ניתן לבחור עד 10 משתמשים',
    no_user_found: 'לא נמצאו משתמשים',
    transcribe_to: 'המר לטקסט',
    integrate_zoom_to_start_meeting: 'שלב את Zoom כדי להתחיל פגישה.',
    zoom_is_not_integrated: 'Zoom לא משולב.',
    delete_poll: 'מחק סקר',
    add_poll: 'הוסף סקר',
    live_now: 'בלייב!',
    average_rating: 'דירוג ממוצע',
    review: 'ביקורת',
    time_spent: 'זמן ממושך',
    total: 'סה״כ',
    mins: 'דקות',
    no_data: 'אין נתונים זמינים.',
    total_score: 'צב评分 מלאולא',
    pass_score: 'נקודת מעבר',
    point: 'נקודה',
    wrong: 'לא נכון',
    response: 'תגובה',
    submitted: 'נשלח',
    average: 'ממוצע',
    total_play: 'סך המשחקים',
    view_graph: 'הצג גרף',
    time_spent_mins: 'זמן (בדקות)',
    play: 'שחק',
    ideal_path: 'נתיב אידיאלי',
    user_incorrect_path: 'נתיב שגוי של המשתמש',
    ideal_path_taken: 'הנתיב האידיאלי שנבחר',
    scenario: 'תסריט',
    option: 'אפשרות',
    spend: 'הוצאה',
    average_spending_time: 'זמן ממוצע בהוצאה',
    activity_overview: 'סקירת פעילות',
    live_event: 'אירוע חי',
    live_assessment: 'הערכה חיה',
    report_download: 'הורד דוח',
    all_workshops: 'כל הסדנאות',
    overview_average_activity: 'סקירה ממוצעת של פעילות',
    overview_workshop_graph: 'גרף סדנא',
    mazes: 'מבוכים',
    correct_feedback: 'משוב נכון',
    incorrect_feedback: 'משוב שגוי',
    checkin_checkout: 'צ’ק אין – צ’ק אאוט',
    minutes: 'דקות',
    incorrect_path: 'נתיב שגוי',
    answer_not_available: 'תשובה לא זמינה',
    views: 'צפיות',
    item: 'פריט',
    questions: 'שאלות',
    total_points: 'סה״כ נקודות',
    total_attempts: 'סה״כ ניסיונות',
    created_date: 'תאריך יצירה',
    host_name: 'שם מארח',
    host_section: 'מדור מארח',
    choose_products: 'בחר מוצרים',
    add_to_basket: 'הוסף לעגלה',
    basket: 'עגלה',
    times: 'פעמים',
    scorms: 'קבצי SCORM',
    skill_journey_overview: 'סקירת מסלול מיומנויות',
    how_to_use: 'כיצד להשתמש',
    live_broadcast_description: 'שילבנו שידור חי בכלי בניית קורסים נוח לשימוש',
    live_broadcast_subdescription:
      'עם מערכת השידור החי בהמצאת ShareLook, ניתן ליצור מעורבות, לאוטומט למידה ולהגדיל את שיתוף הידע.',
    disclaimer: `אני מצהיר כי המסלול שלי לכישורים לא:
- מפר זכויות צד שלישי
- מכיל תוכן בלתי חוקי (השמצות, עירום, אלימות, אפליה)
- מכיל התקפה אישית
- מתחזה לזהות אחר
- מקליט מידע אישי ללא רשות
- מכיל פרסומות או ספאם`,
    price: 'מחיר',
    video_link: 'קישור וידאו',
    category: 'קטגוריה',
    objectives: 'מטרות',
    marketplace_description: 'תיאור שוק',
    live_discussion: 'דיון חי',
    poll: 'סקר',
    hide_grid: 'הסתר רשת',
    show_grid: 'הצג רשת',
    stop_screen_share: 'עצור שיתוף מסך',
    screen_share: 'שתף מסך',
    mute: 'השתקה',
    unmute: 'בטל השתקה',
    raise_hand: 'הרם יד',
    waiting__: 'ממתין...',
    audio_active: 'שמע פעיל'
  },

  general: {
    save: 'שמור',
    autosaved: 'שמור אוטומטית',
    back_to: 'בחזרה אל',
    by: 'על ידי',
    chat: 'צ’אט',
    completed: 'הושלם',
    canceled: 'בוטל',
    component: 'מרכיב',
    confirm: 'אשר',
    course: 'קורס',
    skill: 'מסע הכישורים',
    maze: 'מטא מבוך',
    channel: 'ערוץ',
    podcast: 'פודקאסט',
    date: 'תאריך',
    details: 'פרטים',
    empty: 'אין נתונים',
    enrolled: 'רשום',
    free: 'חינם',
    graph: 'גרף',
    loading: 'טוען....',
    lesson: 'שיעור',
    lessons: 'שיעורים',
    live_assessment: 'הערכה בשידור חי',
    live_event: 'אירוע בשידור חי',
    no: 'לא',
    of: 'של',
    or: 'או',
    organization: 'ארגון',
    page: 'עמוד',
    pages: 'עמודים',
    personal: 'אישי',
    poll: 'סקר',
    rating: 'דירוג',
    reset: 'איפוס',
    signin: 'כניסה',
    signup: 'הרשמה',
    soon: 'בקרוב',
    type: 'סוג',
    uploading: 'מעלה...',
    yes: 'כן',
    something_went_wrong: 'משהו השתבש!',
    view_all: 'הצג הכל',
    upload_successful: 'הועלה בהצלחה',
    upload_successful_message:
      'מסמכי ה-אקסל שלך הועלו בהצלחה וכעת הם בעיבוד. זה עשוי לקחת קצת זמן. ',
    check_email_upload_successful:
      'בבקשה <0>תבדוק את הדוא”ל שלך</0> עבור <1>הדוח</1> רשימת המשתמשים שהועלתה',
    is_private: 'פרטי',
    to_attach: 'לצרף קובץ',
    file_attached: 'מצורף קובץ'
  },

  account: {
    title: 'חשבון',
    subtitle: 'נהל את ההגדרות ואת פרטי החשבון שלך.',
    saved: 'החשבון עודכן בהצלחה'
  },

  assessments: {
    title: 'אומדנים',
    subtitle: 'צור הערכה',
    finished: 'ההערכה הסתיימה',
    countdown: 'ההערכה בשידור חי תשודר ב ',
    create: 'צור הערכה',
    list_title: 'האומדנים שלך',
    delete_warning: 'האם אתה בטוח שברצונך למחוק פריט זה?',
    details_title: 'הוסף פרטי ההערכה',
    details_subtitle:
      'תן שם לאומדן שלך ותגיד לקהל שלך מה הם צריכים לצפות ממנו.',
    disclaimer: `אני מתחייב שהאומדן המוקלט שלי לא:
    - פוגע בזכויות של צד שלישי כלשהו
    - מכיל כל אי חוקיות, כולל תוכן משמיץ, מגונה, גס, מזויף, פורנוגרפי, אלים, פוגע, מעליב, מאיים או מפלה, אפילו מוסווה לכוכביות
    - מכיל התקפות אישיות על אנשים אחרים
    - מכיל כל התחזות למשתתפים אחרים, אישי ציבור או ידוענים
    - מכיל כל הקלטה או מידע אישי על אדם כלשהו ללא הסכמתו של אדם כזה ואינו מפר כל תקנה להגנה על מידע באף חלק בעולם
    - מכיל כל שידול מסחרי או כל סוג של "ספאם"'`,
    assessment_details: 'פרטי ההערכה',

    assessment_settings: 'הגדרות ההערכה'
  },

  buildersettings: {
    title: 'הגדרות פרסום',
    subtitle:
      'הוסף הגדרות לאירוע שלך, מי יכול להציג את האירוע שלך ולקיים אינטראקציה איתו'
  },

  buttons: {
    market_place: 'שוק',
    back_to_normal: 'חזרה למצב רגיל',
    add: 'הוסף',
    add_page: 'הוסף עמוד',
    add_lesson: 'הוסף שיעורים',
    add_answer: 'הוסף תשובה חדשה',
    add_group: 'הוסף קבוצה',
    add_organization: 'הוסף ארגון',
    add_question: 'הוסף שאלה',
    add_quiz: 'הוסף בחינה',
    add_users: 'הוסף משתמשים',
    back: 'חזרה',
    back_to_course: 'חזרה לקורס',
    back_to_lesson: 'חזרה לשיעור',
    back_to_media: 'חזרה לספריית המדיה',
    back_to_details: 'חזרה לפרטים',
    cancel: 'ביטול',
    clear: 'נקה',
    close: 'סגור',
    clone: 'שכפל',
    close_lesson: 'סגור שיעור',
    clone_course: 'שכפול קורס',
    confirm: 'אשר',
    create: 'צור',
    download: 'הורדה',
    download_mass_user_tamplate: 'הורדת תבנית',
    add_mass_users: 'הוסף משתמשים המוניים',
    upload_excel_list: 'העלה רשימת אקסל',
    delete: 'מחק מדיה',
    edit: 'עריכה',
    edit_course: 'עריכת קורס',
    enroll: 'לְהִרָשֵׁם',
    finish: 'סיום',
    upload_image: 'העלה תמונה',
    upload_image_video: 'העלה תמונה או וידאו',
    select_media_library: 'בחר ספריית מדיה',
    make_public: 'הפוך לציבורי',
    make_private: 'הפוך לפרטי',
    make_org: 'צור ארגון',
    media: 'ספריית מדיה',
    my_theme: 'הנושא שלי',
    next: 'הבא',
    next_lesson: 'שיעור הבא',
    next_step: 'השלב הבא',
    previous_step: 'השלב הקודם',
    publish: 'פרסם',
    publish_assessment: 'פרסם את ההערכה שלך',
    publish_course: 'פרסם את הקורס שלך',
    publish_event: 'פרסם את האירוע שלך',
    reset: 'איפוס',
    reset_elements: 'אפס אלמנטים',
    save: 'שמור',
    creating: 'מייצר...',
    updating: 'מעדכן...',
    saved: 'שמור',
    save_for_later: 'שמור למועד מאוחר יותר',
    save_settings: 'שמור הגדרות',
    select_files: 'בחר קבצים',
    select_theme: 'בחר נושא',
    start_lesson: 'התחל שיעור',
    update: 'עדכון',
    upload: 'העלה',
    upload_audio: 'העלה קובץ אודיו',
    upload_photo: 'העלה תמונת פרופיל',
    upload_video: 'העלה סרטון',
    enrolled: 'רשום',
    unenroll: 'בטל הרשמה',
    from_library: 'ספריית מדיה',
    remove: 'הסר',
    removed: 'הוסר',
    start_broadcast: 'התחל שידור',
    end_broadcast: 'סיים שידור',
    camera: 'מצלמה',
    screen: 'מסך',
    screen_with_camera: 'מסך עם מצלמה',
    insert: 'הוסף',

    inserting: 'מוסיף',
    upload_pdf: 'העלה PDF',

    portrait: 'דְיוֹקָן',
    landscape: 'נוֹף'
  },

  card: {
    quick_add: 'הוספה מהירה',
    add: 'הוסף',
    clone: 'שכפל',
    completed: 'השיעורים הושלמו'
  },

  course: {
    upcoming_course: 'הקורס הקרוב',
    unPublishEvent: 'בטל פרסום האירוע',
    unPublishAssessment: 'בטל פרסום ההערכה',
    pastCourse: 'קורס הכשרה',
    upcoming: 'האירוע בשידור חי הקרוב',
    unPublishMaze: 'ביטול פרסום המבוך',
    upcomingMaze: 'מבוך קרוב',
    pastMaze: 'מטא־מבוך עבר',
    pastEvent: 'האירוע בשידור חי הקודם',
    pastAssessment: 'ההערכה בשידור חי הקודמת',
    upcomingAssessment: 'ההערכה בשידור חי הקרובה',
    created: 'תאריך יצירה:',
    assignees: 'מועמדים',
    organisations: ' {{ ארגונים }} ארגונים, <2> {{ משתמשים }} משתמשים</2>',
    event_date: 'תאריך שידור חי האירוע <1> {{ תאריך }} </1>',
    delete_warning: 'האם אתה בטוח שברצונך למחוק את זה',
    clonning_no_lesson: 'הוסף לפחות שיעור אחד על מנת לשכפל קורס זה.',
    clone_warning: 'האם אתה בטוח שברצונך לשכפל את זה',
    clone_success: 'נמצא בתהליך שכפול',
    disclaimer: `אני מתחייב שהאומדן המוקלט שלי לא:
    - פוגע בזכויות של צד שלישי כלשהו
    - מכיל כל אי חוקיות, כולל תוכן משמיץ, מגונה, גס, מזויף, פורנוגרפי, אלים, פוגע, מעליב, מאיים או מפלה, אפילו מוסווה לכוכביות
    - מכיל התקפות אישיות על אנשים אחרים
    - מכיל כל התחזות למשתתפים אחרים, אישי ציבור או ידוענים
    - מכיל כל הקלטה או מידע אישי על אדם כלשהו ללא הסכמתו של אדם כזה ואינו מפר כל תקנה להגנה על מידע באף חלק בעולם
    - מכיל כל שידול מסחרי או כל סוג של "ספאם"`
  },

  coursecreate: {
    take_a_tour: 'צא לסיור',
    dropzone_text: 'הכנס מדיה',
    sidebar_text: 'בחר נושא <1/> לשיעורים <3/> שלך',
    delete_warning: 'האם אתה בטוח שברצונך למחוק את השיעור הזה?'
  },

  coursepage: {
    quizview_loading: 'התתשובה בבדיקה. אנא המתן...',
    quizview_answer: 'התשובה שלך'
  },

  coursequiz: {
    title: 'בחינות לכל השיעורים'
  },

  dashboard: {
    tooltip_title: 'אל תציג את הסרטון הזה שוב',
    page_title: 'סטטיסטיקת הקורסים שלך',
    page_subtitle: 'מצב הקורסים שיצרת',
    profile_add_info:
      'הוסף את <1>{{uncompletedText}}</1> כדי להשלים את הפרופיל שלך.',
    profile_build:
      'בנה את הפרופיל שלך <1>כאן</1>, ספר לנו את תחומי העניין שלך ואת הכישורים שלך.',
    profile_title: 'חוזק פרופיל',
    more_details: 'פרטים נוספים'
  },

  errors: {
    answer: 'אנא הזן תשובה',
    answer_correct: 'בחר את התשובה הנכונה',
    code: 'אנא הזן את הקוד שלך',
    criterion: 'אנא הזן קריטריון',
    duration: 'משך זמן נדרש',
    element: 'אנא הזן אלמנט',
    email: 'אנא הזן את הדוא"ל שלך',
    email_invalid: 'הדוא"ל שהוזן אינו תקין',
    feedback_correct: 'אנא הזן משוב נכון',
    feedback_incorrect: 'אנא הזן משוב שגוי',
    host: 'אנא הזן מארח האירוע',
    host_assessment: 'אנא הזן מארח האומדן',
    image: 'אנא העלה תמונה',
    location: 'הזן את המיקום שלך',
    live_location: 'הזן את המיקום השידור',
    limit: 'אנא הזן את מספר הדקות של השידור חי',
    min_3char: 'מינימום 3 תווים',
    number: 'אנא הזן מספר חיובי.',
    host_email_require: `דוא"ל של מארחים נדרשים.`,
    attendee_email_require: `דוא"ל של משתתפים נדרשים`,
    name: 'אנא הזן את שמך',
    not_found_course: 'קורס לא נמצא',
    not_found_event: 'אירוע לא נמצא',
    not_found_assessment: 'אומדן לא נמצא',
    password: 'אנא הזן את הסיסמה שלך',
    password_digit: 'לפחות ספרה אחת',
    password_short: 'הסיסמה קצרה מדי, מינימום 10 תווים',
    password_special: 'לפחות תו מיוחד אחד',
    password_uppercase: 'לפחות תו אחד גדול',
    password_lowercase: 'לפחות תו אחד קטן',
    phone: 'אנא הזן את הטלפון שלך',
    phone_invalid: 'מספר טלפון לא תקין',
    position: 'אנא הזן את עמדתך',
    question: 'אנא הזן שאלה',
    start_date: 'תאריך ושעה התחלה נדרשים',
    tag: 'אנא בחר תג',
    topics: 'אנא בחר נושא אחד לפחות.',
    live_topics: 'אנא הוסף נושאים',
    title: 'אנא הזן כותרת',
    title_assessment: 'אנא הזן כותרת ההערכה',
    title_course: 'אנא הזן את כותרת הקורס',
    title_empty: 'הכותרת לא יכולה להיות ריקה',
    title_event: 'אנא הזן כותרת האירוע',
    title_lesson: 'אנא הזן כותרת השיעור',
    title_quiz: 'הזן שם הבוחן',
    username: 'אנא הזן את שם המשתמש שלך',
    invalid_verification_code: 'קישור אימות זה פג תוקף או שאינו תקף עוד. בדרך כלל זה קורה אם התבקש אימייל אימות חדש יותר. אנא בדוק את האימייל האחרון מ-Sharelook כדי לאמת את האימייל שלך.',
    upload_error: 'שגיאה - הקובץ לא תואם!',
    upload_more_than_10: 'אתה יכול להעלות רק 10 קבצים בבת אחת.',
    topics_max: 'אנא הוסף מקסימום 3 נושאים.',
    upload_excel: 'אנא וודא שהעלית את הקובץ הנכון.',
    title_excel: 'שגיאה בהעלאת תבנית:',
    file_size_exceed: 'גודל הקובץ חורג',
    subtitle_excel: 'אנא וודא שאתה משתמש בתבנית שסופקה והעמודות ממולאות כראוי.',
    select_broadcast_option: 'אנא בחר אפשרות אחת לשידור אירוע זה',
    multi_hosts_number_error: 'מספר המגישים לא יכול לחרוג מהמצוין עבור האירוע.',
    conference_people_number_error: `מספר המשתתפים לא יכול לחרוג מהמצוין באירוע.`,
    select_max_host: 'בחר לפחות מגיש אחד לאירוע.',
    select_max_conference: 'בחר לפחות משתתף אחד לאירוע',
    stream_stop_error: 'השידור החי הופסק באופן בלתי צפוי!',
    unsecure_context:
      'שגיאה חמורה: הדפדפן לא יכול לגשת למצלמה ולמיקרופון בגלל הקשר לא מאובטח. אנא התקן SSL והיכנס דרך https',
    ws_not_supported: 'שגיאה חמורה: WebSocket לא נתמך בדפדפן זה',
    no_org: 'כדי להמשיך בחר לפחות ארגון אחד.',
    no_org_group: 'כדי להמשיך בחר לפחות בקבוצת ארגון אחת.',
    waiting_to_join: 'מחכה שמישהו יצטרף!',
    select_transcribe_locale: 'בחר שפה לתמלול',
    transcribe_limit: 'אנא הזן תמלול דקות',
    monthly_transcribe: 'מגבלת תמלול חודשית:'
  },

  events: {
    title: 'הוסף פרטי האירוע בשידור חי',
    change_host: 'שנה מארח',
    finished: 'הסתיים האירוע בשידור חי ',
    countdown: 'השידור החי של האירוע יתחיל בעוד ',
    subtitle:
      'תן שם לשידור החי של האירוע שלך ותגיד לקהל שלך מה עליהם לצפות ללמוד ממנו.',
    poll_disabled: 'סקר אינו זמין באירוע זה',
    disclaimer: `אני מתחייב שההערכה המוקלטת שלי לא:
    - פוגע בזכויות של צד שלישי כלשהו
    - מכיל כל אי חוקיות, כולל תוכן משמיץ, מגונה, גס, מזויף, פורנוגרפי, אלים, פוגע, מעליב, מאיים או מפלה, אפילו מוסווה לכוכביות
    - מכיל התקפות אישיות על אנשים אחרים
    - מכיל כל התחזות למשתתפים אחרים, אישי ציבור או ידוענים
    - מכיל כל הקלטה או מידע אישי על אדם כלשהו ללא הסכמתו של אדם כזה ואינו מפר כל תקנה להגנה על מידע באף חלק בעולם
    - מכיל כל שידול מסחרי או כל סוג של "ספאם"'`,
    prompt_message:
      'היציאה מהדף הזה יסיים את האירוע שלך. האם אתה בטוח לעזוב את הדף הזה?',
    duration_exceed_message:
      'זמן השידור שלך חורג, האפליקציה עומדת להפסיק את השידור.',
    before_schedule_message:
      'אתה עומד להתחיל את השידור לפני שעת האירוע שנקבעה. שימו לב כי עצירת השידור תסיים את האירוע.',
    browser_unsupportive_message:
      'הדפדפן שלך אינו תומך בשיתוף מסך. אתה יכול לראות דפדפנים נתמכים בקישור זה',
    cancel_switch_host_message: 'המארח אינו זמין. האירוע יימשך מהקצה שלך.',
    coaching_prompt_message: 'אינך יכול לצאת מדף זה עד שהאירוע יסתיים.',
    event_modal_warn: 'האם אתה רוצה לעזוב את האירוע?',
    confirm_message: 'האירוע שלך יסתיים אם תלחץ על אישור.',
    screen_share_denied: 'שללת לשתף את המסך שלך',
    media_not_found: 'המצלמה או המיקרופון לא נמצאו או אינם מורשים בהתקן שלך.',
    media_not_access:
      'המצלמה או המיקרופון משמשים לתהליך אחר שאינו מאפשר לקרוא התקנים אלה',
    constraint_error:
      'לא נמצא מכשיר שמתאים לאילוצי הווידיאו והשמע שלך. אתה יכול לשנות אילוצי וידאו ושמע',
    media_access_denied: 'אינך מורשה לגשת למצלמה ולמיקרופון.'
  },

  filters: {
    days7: '7 ימים אחרונים',
    days15: '15 ימים אחרונים',
    days30: '30 ימים אחרונים',
    days365: '365 ימים אחרונים',
    date: 'תאריך יצירה',
    relevance: 'רלוונטיות',
    popularity: 'פופולריות',
    name: 'שם',
    group: 'קבוצה',
    Newest_to_Oldest: 'הכי חדש לישן ביותר',
    Oldest_to_Newest: 'הכי ישן לחדש ביותר',
    A_Z: 'A - Z',
    Z_A: 'Z - A'
  },

  helpers: {
    password:
      'כדי להבטיח את אבטחת חשבונך, אנו דורשים לפחות אות קטנה אחת וספרה אחת בסיסמה שלך. עליך גם אורך מינימלי הסיסמא של 10 תווים.',
    phone: 'כלול את קוד המדינה שלך בטלפון, לדוגמה: +65',
    username:
      'שם המשתמש שלך הוא מידע ציבורי והוא מוצג למשתמשים אחרים לפי הצורך. ככאלה, אנו ממליצים שלא להשתמש במידע אישי בשם המשתמש שלך',
    public_description_normal:
      '<0><0/> </0> שלך נשמר ונחשב כברירת מחדל כפרטי. המשמעות היא שרק אתה יכול לראות את התוכן הזה. כדי לפרסם תוכן זה אתה יכול לבחור אחת מהאפשרויות שלהלן. פרסום הקורס שלך לציבורי פירושו שהוא יהיה זמין לכל המשתמשים בפלטפורמה. האפשרות המשתמשים הספציפיים תאפשר לך לשתף את הקורס שלך עם משתמשים ספציפיים באמצעות כתובת הדוא"ל המשויכת לחשבון Sharelook שלהם.',
    public_description_admin:
      '<0><0/> </0> זה נשמר ונחשב כברירת מחדל כפרטי. משמעות הדבר היא שרק אתה (ויוצר התוכן) יכולים לראות את התוכן הזה. כדי לפרסם תוכן זה אתה יכול לבחור אחת מהאפשרויות שלהלן. פרסום הקורס שלך לציבורי פירושו שהוא יהיה זמין לכל המשתמשים בפלטפורמה - כולל אלה שמחוץ לארגון שלך. פרסום זה לארגון פירושו שכל המשתמשים בארגון יוכלו לראות אותו. אתה יכול גם לפרסם אותו בקבוצה אחת או יותר, כלומר רק המשתמשים בקבוצות אלו יוכלו לראות את זה. לבסוף, יש לך אפשרות לפרסם אותה למשתמשים ספציפיים בתוך הארגון ומחוצה לו באמצעות כתובת הדוא"ל של חשבון Sharelook שלהם.'
  },

  labels: {
    add: 'הוסף',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'סוג תשובה',
    answers: 'תשובות',
    back_to_quiz: 'חזרה לבוחן',
    back_to_question: 'חזרה לרשימת השאלות',
    chat: 'צ’אט',
    chat_available: "'צ'אט אינו זמין באירוע זה",
    // chat_report: 'דוח הצ'אט',
    choice_single: 'בחירה יחידה',
    choice_multiple: 'בחירה מרובה',
    choice_free: '”בחירה “חופשית',
    choice_sorting: 'בחירה “מיון”',
    choice_matrix: 'בחירה “מטריקס למיון”',
    clone_lesson_permission: 'הרשאת שכפול',
    code: 'קוד',
    correct: 'נכון',
    created: 'תאריך יצירה',
    clone_modal: 'שכפול קורס',
    cloning_course: 'משכפל את הקורס...',
    cloning: 'משכפל...',
    cloning_course_desc: 'תהליך זה ייקח זמן. אנא המתן בסבלנות.',
    cloning_success: 'הקורס "<0/>" שוכפל בהצלחה!',
    description: 'תיאור',
    disclaimer: 'הצהרת אחריות',
    drop_file: 'גרור קובץ כאן...',
    duration: 'משך זמן',
    edit: 'עריכה',
    email: 'דוא"ל',
    event: 'אירוע',
    event_all: 'כל האירועים שלו',
    event_date: 'תאריך / זמן מקומי האירוע בשידור חי',
    event_this: 'האירוע הזה',
    expire: 'פג תוקף ב',
    expiry_date: 'פג תוקף בתאריך',
    forgot: 'שכחת סיסמא?',
    group: 'קבוצה',
    groups_list: 'רשימת הקבוצות',
    host: 'מארח',
    id_annotation: 'מזהה ביאור',
    id_quiz: 'מזהה בוחן',
    incorrect: 'לא נכון',
    interests: 'תחומי עניין',
    invited: 'מוזמן',
    live_chat: 'צ’אט חי',
    live_stream_limit: 'דקות הסטרימינג בשידור חי',
    contact_text: 'כדי לשנות את מגבלת הסטרימינג החודשית שלך, אנא צור קשר',
    contact_admin:
      '<0>אם ברצונך לשנות את מגבלת הסטרימינג החודשית שלך, אנא צור קשר</0> <1>admin@sharelook.com</1>',
    // limit_stream_text:
    // 'מס הדקות שנותרו לסטרימינג בשידור חי': <0> {{limit}} </0> דקות <1 /> <2 /> <3> לשינוי מגבלת הסטרימינג החי החודשית אנא צרו קשר עם </ 3> <4> admin@sharelook.com </4>',
    location: 'מיקום',
    lessons: 'שיעורים',
    location_broadcast: 'מיקום שרת מארח',
    // location_broadcast_subtitle: 'הוסף את המיקום הכי קרוב למיקום של מארח השידור כדי להפחית את העיכובים באודיו \ וידאו',
    media_manager: 'מנהל מדיה',
    minutes: 'דקות',
    name: 'שם',
    online_quiz: 'בוחן בשידור חי',
    organiser: 'מחבר',
    organization: 'ארגון',
    overall_emotion: 'החוויה הכוללת:',
    organizations_list: 'רשימת ארגונים',
    password: 'סיסמא',
    participants: 'משתתפים',
    picture: 'תמונה (16:9)',
    phone: 'טלפון',
    photo: 'תמונה',
    poll: 'סקר',
    position: 'מיקום',
    processing: 'מעבד',
    privacy_settings: 'הגדרות פרטיות',
    question: 'שאלה',
    quiz_create: 'צור בוחן חדש',
    quiz_name: 'שם הבוחן',
    quiz_update: 'עדכן בוחן',
    select_organization: 'בחר ארגון',
    settings: 'הגדרות',
    show: 'הצג',
    show_graph: 'הצג את התוצאה בגרף',
    signin: 'כניסה',
    signup: 'הרשמה',
    sort_by: 'מיין לפי',
    start_date: 'תאריך התחלה',
    tags: 'תגיות',
    terms: 'אני מסכים <1>לתנאים והגבלות אלה</1>.',
    title: 'כותרת',
    topics: 'נושאים',
    topic: 'נושא',
    total_comments: 'סה"כ תגובות',
    username: 'שם משתמש',
    users_list: 'רשימת משתמשים',
    users_emails: 'הכנס את הדוא"ל של משתמשים ספציפיים',
    description_specifiction_email:
      'אנא הזן כתובת דוא"ל אחת בשורה כדי לשתף זאת עם מספר משתמשים ספציפיים.',
    message_specific_email: 'אנא הכנס הדוא"ל של המשתמש הספציפי.',
    viewers: 'צופים',
    edit_course: 'עריכה',
    edit_assessment: 'עריכה',
    edit_event: 'עריכה',
    delete_course: 'מחק',
    delete_event: 'מחק',
    delete_assessment: 'מחק',
    view_course: 'הצג',
    view_event: 'הצג',
    view_assessment: 'הצג',
    date_event: 'תאריך האירוע בשידור חי',
    date_assessment: 'תאריך האומדן בשידור חי',
    clone_of: 'שכפל את',
    clone_course:
      'צור שכפול של קורס זה, שתוכל לשנות ללא תלות במקור, כולל את כל השיעורים והדפים.',
    make: 'צור',
    available_to: 'זמין לכל משתמש ב- ShareLook',
    uploaded_by: 'הועלה על ידי: ',
    course: 'קורס',
    assessment: 'הערכה',
    user_not_exist: 'המשתמש לא קיים, האם תרצה לשלוח לו הזמנה?',
    check_user: 'התראה',
    user_not_exist_in_org:
      'המשתמש אינו קיים בארגון זה, האם תרצה לשלוח לו הזמנה?',
    title_modal_stream: 'שנה הגבלת השידור חי של הארגון',
    des_warning_stream: 'אתה עומד להשתנות',
    monthly_stream: 'מגבלת שידור חי החודשית:',
    // min_per_month: 'דקות \ חודש',
    broadcast_label: 'אני רוצה לעשות:',
    hosts_emails: `הכנס דוא"ל של מארחים ספציפיים`,
    attendee_emails: `הכנס דוא"ל של משתתפים ספציפיים`,
    description_host_specifiction_email: 'אנא הכנס כתובת דוא"ל אחת בכל שורה.',
    presenter_label: 'מגיש',
    presenter_label_conference: 'מספר אנשים',
    event_privacy: 'מצב ועידה',
    alert: 'עֵרָנִי!',
    warning: 'אַזהָרָה!',
    ok: 'בסדר',
    cancel: 'לְבַטֵל',
    done: 'בוצע',
    insert: 'לְהַכנִיס',
    private: 'פְּרָטִי',
    public: 'פּוּמְבֵּי',
    no_connection: 'חיבור לאינטרנט אבד',
    switch: 'החלף',
    share_screen: 'שתף מסך',
    stop_share_screen: 'עצור את מסך השיתוף',
    share_screen_with_camera: 'שתף את המסך עם המצלמה',
    stop_share_screen_with_camera: 'עצור את שיתוף המסך עם המצלמה',
    camera_on: 'מצלמה מופעלת',
    camera_off: 'מצלמה כבויה',
    mic_on: 'בטל השתקה',
    mic_off: 'לְהַשְׁתִיק',
    fullscreen: 'מסך מלא',
    live_now: 'תחיה עכשיו',
    schedule_on: 'לוח זמנים ל',
    organisations: 'ארגונים',
    org_groups: 'קבוצות ארגון',
    specific_user: 'משתמש ספציפי',
    gif: 'GIF',
    unavailable: 'אינו זמין',
    yes: 'כן',
    no: 'לא',
    event_duration_message: 'מקסימום 300 דקות (5 שעות)',
    send_email: 'שלח הודעת דואר אלקטרוני',
    admin_only: 'מנהל בלבד',
    join: 'לְהִצְטַרֵף',
    leave: 'לעזוב',
    share: 'לַחֲלוֹק',
    share_text: 'אנא הקלד דוא"ל עם מי ברצונך לשתף קובץ זה',
    share_text_title: 'לַחֲלוֹק PDF',
    select_users: 'בחר משתמשים',
    delete: 'לִמְחוֹק', // to_translate
    attachment_event: 'קבצים מצורפים לאירוע:', // to_translate
    transcribe_limit: 'תמלל דקות'
  },

  broadcastOptions: {
    stream_from_phone: 'שידור חי עם הטלפון שלי',
    other_webrtc: 'וובינר מהמחשב שלי',
    multihost: 'וובינר מרובה מארחים מהמחשב שלי',
    peer2peer: 'שיעור פרטי',
    conference: 'כנס בשידור חי'
  },

  lessoncreate: {
    take_a_tour: 'צא לסיור',
    title: 'הוסף פרטי שיעור',
    subtitle: 'תן שם לשיעור שלך ותגיד לקהל שלך מה עליהם לצפות ללמוד ממנו.',
    input_label_title: 'ותרת שיעור',
    input_label_topics: 'נושאי השיעור',
    input_label_description: 'תיאור השיעור',
    delete_warning: 'האם אתה בטוח שברצונך למחוק דף זה?'
  },

  lessonoverview: {
    title: 'הוסף שיעור',
    subtitle: 'הוסף שיעור קיים או צור שיעור חדש',
    new_lesson: 'צור שיעור חדש',
    new_lesson_sub: 'צרו שיעור חדש לגמרי, מאפס!',
    existing_lesson: 'בחר שיעור קיים',
    existing_lesson_sub:
      'קישור לשיעור קיים, שינויים שבוצעו בשיעור זה, ישפיעו גם על שיעור זה בקורסים אחרים',
    clone_lesson: 'שכפל את השיעור הקיים',
    clone_lesson_sub:
      'הכינו עותק ייחודי של השיעור בקורס זה, שינויים שיבוצעו בשיעור זה לא ישפיעו על השיעור המקורי.',
    clone_lesson_modal_sub:
      'אנא לחץ על כפתור השכפול שמתחת לשיעור שתרצה להוסיף לקורס שלך.'
  },

  management: {
    groups_title: 'נהל קבוצות',
    delete_warning: 'האם אתה בטוח?',
    organizations_title: 'הארגונים שלי',
    organizations_subtitle: 'הוסף ארגונים לרשימה שלך',
    users_title: 'נהל משתמשים',
    users_position: 'מנהל חשבון בכיר',
    user_not_found: 'משתמש לא נמצא',
    select_org: 'אנא מצא ובחר ארגון לניהול משתמשים'
  },

  audio: {
    modal_title: 'הכנס אודיו',
    list_view: 'הצג רשימה',
    create_audio_modal_title: 'צור אודיו',
    edit_audio_modal_title: 'ערוך אודיו',
    public_audio_not_found: 'אודיו לא נמצא',
    private_audio_not_found: 'עדיין לא העלית שום אודיו',
    are_you_sure_to_delete: 'האם אתה בטוח רוצה למחוק?',
    type_something: 'הקלד משהו',
    select_voice: 'בחר',
    file_name: 'שם הקובץ',
    description: 'תיאור',
    topic: 'נושא',
    key_words_tag: 'תג מילות מפתח',
    mp3_audio: 'MP3 אודיו',
    created: 'נוצר',
    duration: 'משך זמן',
    close: 'סגור'
  },

  image: {
    modal_title: 'הוסף תמונה',
    image: 'תמונה',
    pixel: 'פיקסל',
    dimension: 'גודל',
    public_image_not_found: 'תמונה לא נמצאה.',
    private_image_not_found: 'עדיין לא העלית שום תמונה'
  },

  annotation: {
    modal_title: 'הערה'
  },

  text: {
    modal_title: 'עורך טקסט'
  },

  video: {
    modal_title: 'הכנס וידאו',
    image: 'וידאו',
    mp4_video: 'MP4 וידאו',
    public_video_not_found: 'הוידאו לא נמצא',
    private_video_not_found: 'עדיין לא העלית שום קובץ וידאו'
  },

  media: {
    title: 'ספריית מדיה',
    subtitle: 'ספריית הקבצים שלך',
    modal_title: 'העלה מדיה',
    delete_warning: 'אשר את המחיקה',
    delete_message: 'מדיה שנמחקה עדיין תופיע בדפים שבהם נעשה בהם שימוש',
    dropzone_text: 'או גרור ושחרר',
    delete_success: 'המדיה נמחקה בהצלחה',
    upload_file: 'העלה קובץ',
    drag_drop: 'או גרור ושחרר',
    import_file: 'ייבא קבצים מהמחשב שלך',
    no_media: 'עדיין לא העלית שום מדיה',
    media_type: 'סוג מדיה',
    video: 'וידאו',
    image: 'תמונה',
    audio: 'אודין',
    gif: 'GIF תמונה',
    pdf: 'PDF קבצים',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'מדיה לא נמצאה.',
    of: 'של',
    disclaimer: `אני מתחייב שהמדיה שלי אינה עושה:
  - פוגע בזכויות של צד שלישי כלשהו
    - מכיל כל אי חוקיות, כולל תוכן משמיץ, מגונה, גס, מזויף, פורנוגרפי, אלים, פוגע, מעליב, מאיים או מפלה, אפילו מוסווה לכוכביות
    - מכיל התקפות אישיות על אנשים אחרים
    - מכיל כל התחזות למשתתפים אחרים, אישי ציבור או ידוענים
    - מכיל כל הקלטה או מידע אישי על אדם כלשהו ללא הסכמתו של אדם כזה ואינו מפר כל תקנה להגנה על מידע באף חלק בעולם
    - מכיל כל שידול מסחרי או כל סוג של "ספאם"`,
    my_media: 'המדיה שלי',
    public_library: 'הספרייה הציבורית',
    organization_library: 'מסמכי נהלים סטנדרטיים',
    upload_from_computer: 'העלה מהמחשב',
    create: 'צור',
    all: 'הכל',
    male: 'זכר',
    female: 'נקבה',
    processing_audio: 'מעבד אודיו',
    create_annotation: 'צור הערה',
    popup_over_lesson_text: 'הערה זו תופיע בדף השיעור לאחר לחיצה',
    edit_detail: 'ערוך פרט',
    delete: 'מחק',
    go_create_audio: 'ליצירת אודיו',
    show_more_details: 'הצג יותר פרטים',
    show_less_details: 'הצג פחות פרטים',
    drop_files: 'גרור קבצים לכאן והיכן להעלות אותם',
    or: 'או',
    import_files: 'יבא קבצים מהמחשב שלך',
    human: `בן אנוש`,
    shared_file: 'הקובץ שלך שותף בהצלחה',
    error_shared_file: 'יש בעיה בשיתוף הקובץ. אנא נסה שוב'
  },

  navigation: {
    account: 'חשבון',
    assessments: 'הערכות',
    dashboard: 'לוח מחוונים',
    groups: 'ניהול הקבוצה',
    logout: 'יציאה',
    organisations: 'ארגונים',
    organizations_users: 'ארגונים ומשתמשים',
    reports: 'דוחות',
    schedule: 'לוח זמנים',
    training: 'הַדְרָכָה',
    nowLive: 'שידור חי',
    users: 'משתמשים',
    workshop: 'הסדנה שלי'
  },

  onboarding: {
    step1_title: 'שלב 1: ספר לנו קצת על עצמך',
    step1_subtitle: 'מה שמך? מאיפה אתה? מהי תפקידך?',
    step2_title: 'שלב 2: בחר מיומנות שאתה יכול להשתפר בהן',
    step2_subtitle:
      'בשלב הבא, ספר לנו מה תרצה להבין טוב יותר. אולי משהו שטרם למדת? תחום לימודים חדש? מה יקירך עובד?'
  },

  pagebuilder: {
    title: 'צור שיעור',
    subtitle:
      'הגיע הזמן ליצור את התוכן לקהל שלך, כך שהוא ילמד ממך, תוכל ליצור תמונות, קטעי וידאו ואינפוגרפיקה',
    select_layout: 'בחר פריסת עמוד',
    template1: 'ריק',
    template2: 'כותרת ותת-כותרת',
    template3: 'כותרת וטקסט',
    template4: 'כותרת, מדיה וטקסט',
    template5: 'כותרת ומדיה',
    template6: 'כותרת ובוחן'
  },

  pageconstructor: {
    title: 'צור ושכפל שיעור',
    subtitle:
      'הגיע הזמן ליצור את התוכן לקהל שלך, כך שהוא ילמד ממך, תוכל ליצור תמונות, קטעי וידאו ואינפוגרפיקה'
  },

  passwordreset: {
    success_coded:
      'שלחנו לך קוד אישור לכתובת הדוא"ל שסיפקת, אנא העתק את הקוד לשדה למטה כדי להגדיר סיסמא חדשה.',
    success_changed: 'הגדרת בהצלחה סיסמה חדשה. אתה יכול להיכנס עכשיו.'
  },

  placeholders: {
    search: 'חיפוש',
    answer: 'תשובה',
    chat: 'תגיד משהו...',
    code: 'קוד',
    criterion: 'קריטריון',
    date_event: 'בחר תאריך ושעה',
    date_start: 'תאריך התחלה',
    date_expire: 'תאריך תפוגה',
    description: 'תיאור',
    elements: 'מיין אלמנטים',
    email: 'דוא"ל',
    feedback_correct: 'משוב נכון',
    feedback_incorrect: 'משוב לא נכון',
    host: 'מארח',
    keywords: 'חיפוש מילות מפתח',
    lesson_description: 'תיאור שיעור',
    location: 'מיקום',
    minutes: 'דקות',
    name: 'שם',
    organiser: 'מארגן',
    organization: 'ארגון',
    password: 'סיסמה',
    phone: 'טלפון',
    photo: 'תמונה',
    picture: 'תמונה',
    point: 'נקודה',
    position: 'מיקום',
    question: 'שאלה',
    quiz: 'שם הבוחן',
    search_course: 'חיפוש לפי קורס',
    search_media: 'חיפוש מדיה',
    search_name: 'חיפוש לפי שם',
    search_title: 'חיפוש לפי כותרת',
    search_training: 'חיפוש הדרכה',
    settings: 'הגדרות',
    tags: 'תגיות',
    title: 'כותרת',
    topics: 'נושאים',
    username: 'שם משתמש',
    keyword: 'מילות מפתח',
    max_500_characters: 'מקסימום 500 תווים ',
    no_description: 'לקובץ זה אין תיאור',
    no_keyword: 'לקובץ זה אין מילות מפתח',
    no_topics: 'לקובץ זה אין ערכת נושא',
    feedback: 'הודעה',
    contact: 'איך אנחנו יכולים לעזור?'
  },

  publishsettings: {
    title: 'הגדרות פרסום',
    event_subtitle:
      'הוסף הגדרות לאירוע שלך, מי שיכול לצפות ולקיים אינטראקציה באירוע שלך',
    assessment_subtitile:
      'תן שם להערכה שלך ותגיד לקהל שלך מה עליהם לצפות ללמוד ממנו.',
    course_subtitle:
      'הוסף הגדרות לשיעור שלך, מי שיכול לצפות ולקיים אינטראקציה בשיעור שלך',
    disclaimer: '1. הרשמה',
    /*
  על ידי הרשמה כמשתמש / יצירת חשבון אתה מסכים ל [הסכם המשתמש] שלנו ומאשר בקריאת [מדיניות הפרטיות] שלנו
 
  2. יצירת קורס
 
  על ידי שימוש בכלים שלנו ויצירת תכני קורס, אתה מסכים ל [הסכם המשתמש] שלנו ומאשר בקריאת [מדיניות הפרטיות] שלנו
 
  3. יצירת אירוע
 
  על ידי שימוש בכלים שלנו ויצירת אירוע, אתה מסכים ל [הסכם המשתמש] שלנו ומאשר בקריאת [מדיניות הפרטיות] שלנו
 
  4. יצירת אומדן
 
  על ידי שימוש בכלים שלנו ויצירת אומדן, אתה מסכים ל [הסכם המשתמש] שלנו ומאשר בקריאת [מדיניות הפרטיות] שלנו
  ', */
    dates_validation_error: 'ש למלא את שני התאריכים.',
    course_dates_validation_error: 'נא להזין תאריך התחלה ותפוגה של קורס זה.',
    emails_validation_error: 'רשימת הדוא"ל אינה חוקית.',
    specific_email_validation_error: 'רק מייל אחד מותר.',
    i_agree_to_these: 'אני מסכים לאלה ',
    terms_and_conditions: 'תנאים והגבלות.',
    PublicDescription:
      'משתמשים עצמאיים חינם: (אפשרויות פרטיות וציבוריות) [קורס | אירוע | אומדן] נשמר ונחשב כברירת מחדל כפרטי. המשמעות היא שרק אתה יכול לראות את התוכן הזה. כדי לפרסם תוכן זה, תוכל לבחור להפוך אותו לציבורי למטה. המשמעות היא שהקורס יהיה זמין לכל המשתמשים בפלטפורמה.',
    OrganisationsDescription:
      'משתמשים בארגונים: (במקום "סיום" להשתמש ב"פרסם "ולהביא אותם לדף הפרסום זהה למשתמשים אחרים אך ללא כל אחת מאפשרויות הפרסום.) [קורס | אירוע | אומדן] נשמר, והוא פרטי. משמעות הדבר היא שרק אתה והמנהלים בארגון שלך יכולים לראות את זה. כמשתמש, אינך יכול לפרסם את התוכן שלך בארגון שלך בעצמך מכיוון שהדבר מחייב זכויות מנהל. אנא צור קשר עם אחד ממנהלי המערכת שלך ובקש ממנו לפרסם את התוכן שלך בפומבי, לכל הארגון, לקבוצות ספציפיות בארגון שלך או למשתמשים ספציפיים.',
    OrganisationGroupsDescription:
      'מנהלי ארגונים: (לתוכן שנעשה בתוך הארגון: פרטי, ציבורי, ארגון, קבוצות, משתמשים ספציפיים): [קורס | אירוע | אומדן] נשמר ונחשב כברירת מחדל כפרטי. משמעות הדבר היא שרק אתה (ויוצר התוכן) יכולים לראות את התוכן הזה. כדי לפרסם תוכן זה אתה יכול לבחור אחת מהאפשרויות שלהלן. פרסום הקורס שלך לציבורי פירושו שהוא יהיה זמין לכל המשתמשים בפלטפורמה - כולל אלה שמחוץ לארגון שלך. פרסום זה לארגון פירושו שכל המשתמשים בארגון יוכלו לראות אותו. אתה יכול גם לפרסם אותו בקבוצה אחת או יותר, כלומר רק המשתמשים בקבוצות אלו יוכלו לראות את זה. לבסוף, יש לך אפשרות לפרסם אותו למשתמשים ספציפיים בתוך הארגון ומחוצה לו באמצעות כתובת הדוא"ל של חשבון Sharelook שלהם.',
    SpecificUsersDescription:
      'משתמשים עצמאיים ששולמו: (משתמשים פרטיים, ציבוריים וספציפיים) [קורס | אירוע | אומדן] נשמר ונחשב כברירת מחדל כפרטי. המשמעות היא שרק אתה יכול לראות את התוכן הזה. כדי לפרסם תוכן זה אתה יכול לבחור אחת מהאפשרויות שלהלן. פרסום הקורס שלך לציבורי פירושו שהוא יהיה זמין לכל המשתמשים בפלטפורמה. אפשרות המשתמשים הספציפיים תאפשר לך לשתף את הקורס שלך עם משתמשים ספציפיים באמצעות כתובת הדוא"ל המשויכת לחשבון Sharelook שלהם.'
  },

  quiz: {
    quiz_empty: 'עדיין לא יצרת בוחן',
    questions_empty: 'עדיין לא יצרת שאלה'
  },

  regions: {
    asia_pacific_australia: 'אוסטרליה',
    asia_pacific_india: 'הודו',
    asia_pacific_japan: 'יפן',
    asia_pacific_s_korea: 'דרום קוריאה',
    asia_pacific_singapore: 'סינגפור',
    asia_pacific_taiwan: 'טייוואן',
    eu_belgium: 'בלגיה',
    eu_germany: 'גרמניה',
    eu_ireland: 'אירלנד',
    south_america_brazil: 'ברזיל',
    us_central_iowa: 'איווה',
    us_east_s_carolina: 'דרום קרוליינה',
    us_east_virginia: " וירג'יניה' ",
    us_west_california: 'קליפורניה',
    us_west_oregon: 'אורגון'
  },

  reports: {
    title: 'דוחות',
    workshop_report: 'דוח הסדנה',
    user_report: 'דוח המשתמש',
    organization_workshop: 'סדנת הארגון',
    course: 'קורס',
    live_event: 'אירוע בשידור חי',
    workShop_graph: 'גרף הסדנת',
    organization_account: 'חשבון ארגון',
    all: 'הכל',
    name: 'שם',
    id_number: 'מספר מזהה',
    email: 'דוא"ל',
    search_user_report: 'חפש דוח משתמש',
    participant: 'משתתף',
    participants: 'משתתפים',
    host: 'מארח',
    username: 'שם משתמש',
    event: 'אירוע',
    quiz: 'בוחן',
    assessment: 'הערכה',
    time: 'זמן',
    no_recent_activity: 'אין פעילות לאחרונה',
    workshops: 'סדנאות',
    courses: 'קורסים',
    live_events: 'אירועים בשידור חי',
    live_assessments: 'הערכות בשידור חי',
    quizzes: 'בחינות',
    overview: 'סקירה כללית',
    by: 'על ידי',
    views: 'צפיות',
    status: 'סטטוס',
    poll: 'סקר',
    comment: 'תגובה',
    comments: 'תגובות',
    no_comments: 'אין תגובות',
    no_polls: 'אין סקרים',
    live_date: 'תאריך השידור חי',
    score: 'ציון',
    question: 'שאלה',
    submit: 'הגש',
    recent_activity: 'פעילות לאחרונה',
    ago: 'לפני',
    no_data_found: 'לא נמצאו נתונים',
    start_end_live: 'התחל / סיים שידור חי',
    join_leave_date: 'הצטרף / תעזוב',
    watched_time: 'זמן צפייה',
    complete: 'הושלם',
    in_complete: 'לא הושלם',
    today: 'היום',
    seven_days: '7 ימים',
    last_month: 'חודש האחרון',
    one_year: 'שנה אחת',
    all_time: 'כל הזמנים',
    report: 'דוח',
    from_date: 'מתאריך',
    to_date: 'לתאריך',
    all_workshop: 'כל הסדנה',
    all_participants: 'כל המשתתפים',
    live_assessment: 'הערכה בשידור חי',
    users: 'משתמשים',
    download: 'הורדה',
    recent: 'לאחרונה',
    WorkShop: 'סדנה',
    Activity: 'פעילות',
    created_date: 'תאריך שנוצר',
    lessons: 'שיעורים',
    lesson: 'שיעור',
    completed: 'הושלם',
    report_download: 'הורדת דוח',
    this_month: 'החודש',
    search_course: 'חיפוש קורס',
    participants_graph: 'גרף המשתתפים',
    viewed: 'נצפה',
    enrolled: 'נרשם',
    description: 'תיאור',
    topic: 'נושא',
    analytic: 'ניתוח',
    quiz_list: 'רשימת בחינות',
    select_one: 'בחר אחת',
    group_status: 'סטטוס הקבוצה',
    duration_min: 'משך זמן (דקות)',
    submit_poll: 'הגש את סקר',
    download_events: 'הורדת אירועים',
    search_event: 'חיפוש אירוע',
    duration: 'משך זמן',
    total_participants: 'סה”כ משתתפים',
    message: 'הודעה',
    avg_message: 'הודעה ממוצה',
    per_message: 'אחוז הודעות / אירוע'
  },

  signup: {
    success_step1:
      'שלחנו לך קוד אימות לכתובת הדוא"ל שסיפקת, אנא העתק את הקוד לשדה למטה כדי לאשר את הרשמתך.',
    success_step2: 'תודה. נרשמת בהצלחה.',
    privacy: `אני מסכים ל <1> תנאים וההגבלות</1> של שראלוק ו <3> מדיניות הפרטיות</3>`
  },

  stream: {
    emotion_impressive: 'מרשים',
    emotion_unimpressive: 'לא מרשים',
    message_not_started: 'בקרוב',
    message_running: 'שידור חי',
    message_processing:
      'אנו מעבדים כעת את הפעלת הווידיאו של הקלטת השידור החי. אנא חזור מאוחר יותר כדי לצפות בסרטון ולהמשיך להוסיף דירוגים ופידבקים'
  },

  tabs: {
    audience: 'קהל',
    course: 'סקירת הקורס',
    details: 'פרטי האירוע בשידור חי',
    description: 'תיאור',
    host: 'מארח',
    lesson: 'סקירת השיעור',
    lessons: 'שיעורים',
    overview: 'סקירה כללית',
    page: 'בונה עמוד',
    publish: 'פרסם',
    settings: 'הגדרות פרסום',
    total_views: 'סה"כ צפיות',
    live_participates: 'משתתפים לשידור החי',
    // live_chats: 'צ'אטים חיים',
    live_quiz: 'סקרים חיים',
    trainer_rating: 'דירוג מאמן',
    trainer_times: 'זמני המאמן',
    courses_quizzes: 'בחנות הקורסים',
    user_list: 'רשימת משתמשים',
    discussion: 'דיון',
    notes: 'ההערות שלי',
    attachments: 'מצורף נוסף'
  },

  topics: {
    SALES_TRAINING: 'הדרכת מכירות',
    NEGOTIATION_TRAINING: 'הדרכת משא ומתן',
    CROSS_CULTURAL_AWARENESS: 'מודעות חוצה תרבויות',
    NETWORKING_SKILLS: 'כישורי רשת',
    SOFTWARE_ARCHITECTURE: 'אדריכלות תוכנה',
    PROJECT_MANAGEMENT: 'ניהול פרויקטים',
    DIGITAL_TRANSFORMATION: 'טרנספורמציה דיגיטלית',
    IT_CONSULTING: 'ייעוץ IT',
    MANAGEMENT_CONSULTING: 'ייעוץ ניהולי',
    HR_CONSULTING: 'ייעוץ משאבי אנוש',
    INTERNET_OF_THINGS: 'האינטרנט של הדברים (IoT)',
    CYBERSECURITY: 'אבטחת סייבר',
    PRIVACY_AND_GDRP: 'פרטיות ו- GDPR'
  },

  training: {
    title: 'הדרכות',
    title_assessment: 'אומדנים',
    subtitle: 'קורסים ואירועים בשידור חי',
    enrolled_title: 'קורסים רשומים ואירועים בשידור חי',
    enrolled_subtitle: 'קורסים ואירועים בשידור חי שנרשמת אליהם',
    enrolled_message: 'כרגע אינך רשום לשום קורסים ואירועים.',
    past_live_event_title: 'אירועים ששודרו בעבר',
    past_live_event_subTitle: 'אירועים בשידור חי מוגמרים',
    past_live_event: 'אין כרגע אירועים ששודרו בשידור חי.',
    recomended_title: 'קורסים ואירועים מומלצים בשידור חי',
    now_live_event_title: 'עכשיו בשידור חי',
    now_live_event_subTitle: 'אירועים בשידור חי הרגע או שיהיו בקרוב מאוד',
    now_live_event: 'אין כרגע אירוע בשידור חי',
    webinar_event_title: 'ערוץ הוובינר',
    webinar_event_subTitle: 'וובינרים מוגמרים',
    webinar_event: 'כרגע אין וובינר.',
    p2p_event_title: 'פגישות הכשרה',
    p2p_event_subTitle: 'פגישת הכשרה מוגמרת',
    p2p_event: 'אין כרגע פגישת הכשרה.',

    now_live_assessment_title: 'עכשיו בשידור חי',
    now_live_assessment_subTitle: 'הערכה בשידור חי הרגע או שיהיה בקרוב מאוד',
    now_live_assessment_message: 'אין כרגע אומדן בשידור חי.',

    upcoming_assessment_title: 'ההערכות הקרובות בשידור חי',
    upcoming_assessment_subtitle: 'ההערכות הקרובות בשידור חי',
    upcoming_assessment_message: 'נכון לעכשיו אין הערכה בשידור חי בקרוב.',

    past_live_assessment_title: 'הערכות ששודרו בעבר',
    past_live_assessment_subTitle: 'הערכות ששודרו מוגמרים',
    past_live_assessment_message: 'אין כרגע הערכות ששודרו בשידור חי.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    /* recomended_subtitle:
  'ריכזנו קורסים ואירועים בשידור חי על בסיס <0><0/> </0>' שלך', */
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'חיפוש הדרכה',
    search_assessment: 'חיפוש הערכה',
    recomended_message: 'כרגע אין קורסים ואירועים מומלצים.'
  },

  warnings: {
    delete: 'האם אתה בטוח?'
  },

  workshop: {
    title: 'הסדנה שלי',
    subtitle: 'צור ותארח קורס או אירוע בשידור חי משלכם',
    new_course: 'צור קורס חדש',
    new_event: 'צור אירוע חדש בשידור חי',
    new_assessment: 'צור הערכה חדשה בשידור חי',
    courses_title: 'צור קורסים ואירועים בשידור חי',
    courses_subtitle: 'ערוך ופרסם את הקורס שנוצר ותכנן אירועים בשידור חי',
    tags_course: 'קורס',
    tags_live: 'אירוע בשידור חי',
    tags_assessment: 'הערכה בשידור חי'
  },

  help_center: {
    sidebar: {
      title: 'איך נוכל לעזור לך?',
      back_to: 'לוח מחוונים'
    },
    menu: {
      help_center: 'מרכז העזרה',
      whats_new: 'מה חדש',
      feedback: 'משוב',
      feedback_title: 'שלח משוב ל- sharelook',
      terms_and_conditions: 'תנאים והגבלות',
      privacy_policy: 'מדיניות פרטיות',
      contact_us: 'צור קשר'
    },
    get_started: {
      title: 'התחל להשתמש ב- sharelook',
      description: {
        main: 'שילבנו וידיאו בשידור חי לבונה קורסים קל לשימוש',
        tagline:
          'באמצעות מערכת השידור החיה המוגנת בפטנט של ShareLook, אתה יכול ליצור מעורבות, למידה אוטומטית, ולמקסם את שיתוף הידע.'
      }
    },
    whats_new: {
      title: 'התחל להשתמש ב- sharelook',
      description: {
        // main: 'האם ידעת שיצירת למידה בסגנון סיפור יכולה להיווצר תוך זמן קצר ולא כל כך יקר? עליך לשלב את בונה הקורסים של ShareLook ואת הכישרונות המתאימים. אתה יכול לשאול אותנו "איך",
        tagline: ''
      }
    },
    create_workshop: 'כיצד ליצור סדנה',
    create_course: 'כיצד ליצור קורס',
    create_user: 'כיצד ליצור משתמש',
    create_group: 'כיצד ליצור קבוצה',
    create_webinar: 'כיצד ליצור וובינר',
    create_live_event: 'כיצד ליצור אירוע בשידור חי',
    create_live_assessment: 'כיצד ליצור הערכה בשידור חי',
    create_live_on_mobile: 'צור שידור חי בנייד',
    personalize_profile: 'התאם אישית פרופיל',
    manage_group: 'נהל קבוצה',
    report: 'דווח',
    add_annotations: 'כיצד להוסיף הערות / חלונות קופצים',
    add_audio: 'כיצד להוסיף אודיו',
    add_header_and_footer: 'הוספת כותרת עליונה ותחתונה',
    add_image: 'כיצד להוסיף תמונה',
    add_quiz_content: 'כיצד להוסיף תוכן לבוחן',
    add_text_content: 'כיצד להוסיף תוכן טקסט',
    add_user: 'כיצד להוסיף משתמש',
    add_video: 'כיצד להוסיף וידאו',
    clone_course: 'כיצד לשכפל קורס',
    find_live_broadcast: 'כיצד למצוא שידור חי',
    contact_us: {
      title: 'צור קשר',
      subject_placeholder: 'הזן נושא*',
      content_placeholder: 'הזן הודעה*',
      subject_required: '*הנושא נדרש',
      content_required: '*הודעה נדרשת',
      submit: 'שלח',
      cancel: 'בטל',
      sent: 'שלח'
    },
    feedback: {
      title: 'שלח משוב ל- sharelook',
      attach_title: 'צרף קובץ',
      choose: 'בחר קובץ',
      detail: 'הקובץ ישותף עם צוות התמיכה',
      content_placeholder: 'הזן הודעה*',
      content_required: '*הודעה נדרשת',
      submit: 'שלח',
      cancel: 'בטל',
      sent: 'שלח'
    }
  },
  discussion: {
    join_discussion: 'הצטרף לדיון'
  },
  notes: {
    title: 'ההערות שלי',
    add_note: 'הוסף הערה חדשה'
  },
  groups: {
    search_group: 'קבוצת ארגון חיפוש'
  }
}
